webpackJsonp([1],{

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1XGG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnership_vue__ = __webpack_require__("RT3l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7240544c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnership_vue__ = __webpack_require__("JJZS");
function injectStyle (ssrContext) {
  __webpack_require__("hgB+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7240544c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7240544c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1w2/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA8CAYAAAA+CQlPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADedJREFUeNrsWglwVdUZ/t+el5WsCNnMRkISIAlJIFbQ6kwpo3SxtYza1hWttg4FLHXcUDLTMTNqO+A4Ax0stVNtcaR2AKtFtIiEJZCEkIQkZCEr2V9e9ree/v+5574tC3nJQ6zNGT/zuPfcd+53/uX8y1MwxuD/cSjmic8Tnyc+T3yWQ4mIR6Qh0hHJiDjEQsQCRABCg7AiRhF9iDZELaIMcQ7R8L9CPBSxGrEOcTsiBeE/6UyrFWhthUIBoFZPNoM24wziz4h/IAa/jsRvRTyM+A4iRr5oHxwCa0MLWKvrwFp3BaxXu8HeNwBseBSYyYQT7KgXSlDo/UAZGgyqmEWgWZ4K2tzloFmSyO+JUY94FbHv60BchbgP8QvEtxxkDQMwduRzMB39EswXLoH9ag+w0XFJukREiRJW4F+SNP4HtDzDDbAzYDYb1wBFcCBoUhPA7+5vg/993wfVoij56/+JeALRdaOI/wDxLGKVK+HhPe/C6LuHwNrYKpHUaUBBakwkadBaHCAYy2+hcJUu1wRmsgAzm0EVtxgCn7wfgp76mWwSFYgNiJavkjjqH/wOsdH14vhnxWD87atgqaoHhb8eFFqNdAMlyMxIAO1ZQeLVqEHhp8X7WiShkghbbVzt2ahJmofXFTq8r1JJe2WxcNPQo/RD3yoEZWQ4XT4vfMjwV0H8h4i3EDe5eaC/fgiGzTuRpJ3bKn/ZcSRhsYIqKgzUaYmgSU8B7dJk0CTfDOrIMFAEokMncjRMZrAZB8HS3gnm8mqwnK0Ac2kV2HoNoPT3kzYIX9E+MAi6tXkQ/vfdoAwJpid/j9g6G9J79+5lMyX+AqJQEqINhSFJY/yjz6Hvp1u5dLiUkSwbHwdNTgYEPPRj8LujAFU12vElY8hgfGwMbChFUnk1qq7Ozw/0KnevbmtqhZG/HIThvX/j/oFvKM63G4wQ8NhPIHT3KzQNvwSWiePvuhB/Xd7Zl19+GZYuXQobN25E79wP3Xc8ALbWTv5ipNJEPvjFX0LAw/eiuur4w41XmuCTf30M9fX10NLSAs3NLXD1agf04fM2mxXCwsIhOnoxJCcnw6pVq2D9XXdB2pIl/Fnz2XLo3/Qc2No6JfUn28eNj/z4T6BduRyEMF6aDXHubafBKwg2MjLCkCz3v+fOn6NLzFi4i7Xql7L2xatY+8I81h6Vy0aPHGOeY2hoiHV2drL+/n5mMBhYV1c3q6mpYUeOHGHbt29nCQkJTPbtBH9/f/boo4+ynt5e/ryppJy1LxJr4N9W/3Rm2LJT/voT13j/SbFnz55pJ/yIvnl8fJxt2LCBv1RSUhI6WwvuxCjrzLmbtYVl85dpC8xkAy+9waYZQ4h+xAB9pefG0Aa4kifccsst/B6N/iefZ61BmdJaoVms6477GbPa6FbLbIkrp9CGKOHI4JlnfgOHDh3iF7Ozs0GLdmmurAVrc7tk16h+ipAgCPj5PZ7fUYrYJo48CllJf1OFXdJxdIAmBQYGQlFRETz44INuDxcXFwNqBf+sW5OPXlgOhJXA0NGRL6HH5xJPTzaeJ/KHDx+GN9/c7bhINshtr6wKFzbz44hsW50QA6r4aNfnd4jQ9Q3EWUQrolcEHpcRh8WRWCg/8PTTTyMn99dpbm6WPshHnzzo39Jcsy+JE4NHrHim7tixw+1GXn6+RPx0uRSgcN9qBU1GshSoSGM/Yqfwutcaf+TOnrKWBQu4l3cdKSkpUlh/qR6DO7sjxlctjJSPzk5fEr+bVOj48eNQWlrqzD5CQyFjGWopHkWWyjoAEaSg1YAmb4Uj9UD8wYv17QJcumazU4B+eMxl5eRIR/0Z3GiNtClo2zyeF+OiL4lTRAQHDx50u5ieng4RSN7W2AK2ji4eYVF8rQzwB13ecod2Iqq9WD9FpKdAG+0WIiYmQmxsLLA+A1jrW5C4tNG0rrYgR5522lfE9WTK5PlKSkrcbqxdu1bafUw82OCI5GRQ7ZSLo0CVFC9PK5+hissj38HgtDuH1atXgxrXMFdfBntPPwZJSh4CK8NCQLsiTZ52zlfESQLxXV1dUFvrHhAVFBRIJk2OTQ56UO01qYlc6mKc8XJ9Tnx4eBgqKyvdbqxZs0byJxjGkgPljpTC4JujMVujWgZ3lDW+Ir6SrtFLDA468369Xg/Ls7KER6922htKQJO11PV5byRAwTp3DnV1dRjNXXW+FEo6W9i3BeN2hVLh4kiXyAkM2bfRV8T5eXXmjLvgKJyMiY0BhrZtrW1yZF/kybXZGfK0AUSVF2sniNIUd6KuoXN0dDSkUNg6Ng4WNC3QakVWy0CbkylPOz7XupgjUxMSn+BocnD3MQ0BEwYulCjwHUfvqowKB80Kh8TJNrq9VHO+gydOnHC7kZm5DPzRq1vqGsHa3iUdleRIA/U8AZqlWU1JnNLNVCOmiBUVFZPbG6o5OTQ5T1anxGPqGSlP+9LLtddI2muFs2fPeviT1dJ6JO3RMV61YVYLL0rwkhTAEKLSV8TJ3oJqa2ugu9spOEpBHY4NHY3CUSBAe1uWJumJNE56UwcgRaIPLXh+NzU1ue+IOEHIvh0GYMb1MKcXgUvtXIIXT+L8/D5//rybvcXFxUEi2jiMm8BS24jKKewbvazWqXYmURKa6VgkYne4cOECmKjw6BIoZVKghO9gvljrOL+ZzQ4apz857167mhvx/MnO0xUrVoAfOhfL5SZeOJTsDROToADQZDoiqCYva2DkoYLog6eaU74fERYG9s5usF1pk04QpKjQaUCblS5P+8IXRX8QBf4MChk9PXq+HJ+XVIB9aETYmw1U0VGYnMTK0y54Gbg4ipSe661cuVJar6KGl6K5I6XAJQJj+bQkOTE56yviFApFNTQ0AMEzgpKIX5CK//wfGLhkpDhqbLNwbNyIe3p6oLy83H1HRAZoKi7lJ4fDkSbEYXISIWtXs6+I59L/ysrKwCq8No3IyEjIJgmgalMFVU5M6N/a1TmuiUaxF2uGiJycR2sDAwOOGzqdDvIFcX5+q52OVJu/XE5NvQ2LpyXOHdtpD7XLzMyEBcHBYGu9CjYqPJB9k+Pz07lGbBRy1XmxZqoodMC5c+6BXlJSEiQgmHEIrJevOBMTjNO1zkToDPhgEHE/OXA57/EieXl50u5X1YF9YEhKFMi+o8LwPE2Qp1V6Wd9eKY6zCfZNFR41StVS0wC2rj5J4qLCw0NVHxMnjxFD9lZdfWlSezOfq+BxuWxvquR4zJJC5Wkls0lMyJHSUTbpeuVVvDYvJybq2EU8eMHR4eWxOS1xMla1ZG8GN3vLyskWhYALboUA7Qq3xMSbnFgjSlI8aHGUlmRHk5srET9V5qzwUGmLHKmk9hfn0j3xJL56qkJAXFw8sP4BsDY0T1UIGPMydCTtSpbPb4vF6aMiIiIgLSODEzW7VHjIKPTrb5On/cdX3VJZ4hPsjcJUqRCA9t1jkOyb7C1A73p+K6YpWE42niTt4hHIFycmONJQdKTWhitg75ASE1J3dXoy+K27Te6cfOhL4vHUFmptbZ3gaHgRramNDFK0ddHmTGZe3pVLY4inZhibb0H8Sk4vy8pKJ63wUGLChkb5E+RPgrY8whuRON6fS+HBc9Du+xFxV7WTe2Q8Sbkp0lnmJ/LobIbffh/CnOr+jMir94sXM4qzXScyPspwHgCXHnpHRwfU1NRMHiiJCg9tbsBD94D/xg1yNvYi+HCQxAc1aL9hGB+7jk8//VQU8/NA9901GD4aeOio8PeHsQ8+BuNLbwAbHpGn34s4Iuy9TqBWNBXeciVNY9++fTAy4niWr80DFyTMMzJMRXV3FkDIq8/KU6gx0ehL4rS7/6ZezObNm91aOGq1mh07JvXC7ANG1r9lJ2uPKeC9K2oZtapTWGfu95ixcDcb/+wkszS2MJthgNmHR5h9aJjZevv5Z89x9OhRptfr3dZ6/PHH+T1LYzNrDVnOeu95gtn6DPIju2fTJrpWC4m6pdtx8SIqPlClRVZxuQT03nvvOQoRtvorMPbJF2AurcRIrgNsnT1gNwyix1eBMjQElBhLq6IXgmpxJG8P6++8FVSJcSLKtXNJb922DYaHhhxrUCOB4vX4+HgYP3YSTJ8VQ8grW+RfP7yNeGyuKehU3dKbqSFKW7tp06YJzTs8z3lT73J9/cRWoNnC2OAwY/0oHYORseExxmzuU9rb29k777zD8JSY8N2E/fv3O+ba6fuc43VfS9pT4nKf+QWj0Qjr16+HU6dOTdilgIAAfsSR9HMxlI2JjYUQlBY19nmQYzLB0OAg9PX2QkN9PVxEDaKkhzTJYDBMuvOvvfYabNu2zfMyOcdfC2d5XYZrf9wP8SVtc3d3N0Pyk0rHFUqlkveyg4ODOeizSqW65nMENCF24MCBydrJhxDp10vSU/XHFyF41x9TU1ZUVMQWLlw4IyIzBaa5bOvWrQxjBk/CFYgHrjdhV3heiER8IL9NW1sbKywsZFlZWTOW5gSyUVFs3bp1bNeuXdzePUYJgly6/qskzX9zN8VvYB5CPCdaStwjV1VVwcmTxTziogSjr6+Pn8VUuKDOB3VbgoKCIDw8nDf7UlNTefSXlpbG43CXQSXcY8KG6a8NbsCY7sc/VAyknzk8LFJJvecESi1pU6gkRUGQZ2PfpQJL5SIKzj8S1ZpuuMFjpj/3oowqTyQ0qaI8TCUkfxH9kdTotxkUxMu/QqZfPlwSaII5/HrhRhL/xo154vPE54nPE58nPk/8GzD+K8AAyIeGmG9MgpsAAAAASUVORK5CYII="

/***/ }),

/***/ "4+x6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__("vwbq");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Maps',
  data: function data() {
    return {
      /**
       * If you change the map, change this bad boy.
       */
      indiaStates: ['andaman-and-nicobar-islands', 'andhra-pradesh', 'arunachal-pradesh', 'assam', 'bihar', 'chandigarh', 'chhattisgarh', 'dadra-and-nagar-haveli', 'daman-and-diu', 'delhi', 'goa', 'gujarat', 'haryana', 'himachal-pradesh', 'jammu-and-kashmir', 'jharkhand', 'karnataka', 'kerala', 'madhya-pradesh', 'maharashtra', 'manipur', 'meghalaya', 'mizoram', 'nagaland', 'odisha', 'puducherry', 'punjab', 'rajasthan', 'sikkim', 'tamil-nadu', 'telangana', 'tripura', 'uttar-pradesh', 'uttarakhand', 'west-bengal'],
      interval: undefined
    };
  },
  props: {
    clickDisabled: {
      default: false,
      required: false,
      type: Boolean
    },
    options: {
      required: false,
      type: Object
    }
  },
  methods: {
    modMap: function modMap(path, options) {
      var isIE = /* @cc_on!@ */false || !!document.documentMode;
      var svgBBox = document.getElementById('map').viewBox.baseVal;
      var self = this;
      var lineNumber = 0; // used for line ids

      function checkIfIndianState(stateSlug) {
        // helper method to destinguish between us state and indian states
        for (var i = 0; i < self.$data.indiaStates.length; i++) {
          if (stateSlug === self.$data.indiaStates[i]) {
            return true;
          }
        }
        return false;
      }
      function randomize(arr) {
        // randomize the order of an array-like structure of circs
        arr = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(arr);
        var currentIndex = arr.length;
        var temp = currentIndex;
        while (currentIndex !== 0) {
          var randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;
          temp = arr[currentIndex];
          arr[currentIndex] = arr[randomIndex];
          arr[randomIndex] = temp;
        }
        return arr;
      }

      function prepAndCreateArc(usStateCirc, indiaStateCirc, usScaled, indiaScaled, usdx, usdy, indiadx, indiady) {
        // this function does not need to be this complicated, but we run this thing on 3 pages with entirely different behavior so thats why we have this 8 param monstrocity
        // basically, if nothing is scaled (home page) we simply pull the center of the circles as our cx and cy values
        // if one place is scaled (mapResults) then we pull the cx and cy for the unscaled but assign the scaled state's data to a user found arugment (this can be made inside here but i dont want to deal with scope atm)
        // untested, if both are scaled (Partnership), then we assigned both scaled values provided by the user and then call createArc given the 2 points and the global lineNumber
        var usX = 0;
        var usY = 0;
        var indiaX = 0;
        var indiaY = 0;
        if (!usScaled && !indiaScaled) {
          usX = usStateCirc.cx.baseVal.value;
          usY = usStateCirc.cy.baseVal.value;
          indiaX = indiaStateCirc.cx.baseVal.value;
          indiaY = indiaStateCirc.cy.baseVal.value;
        } else if (!usScaled && indiaScaled) {
          usX = usStateCirc.cx.baseVal.value;
          usY = usStateCirc.cy.baseVal.value;
          indiaX = indiadx;
          indiaY = indiady;
        } else if (usScaled && !indiaScaled) {
          usX = usdx;
          usY = usdy;
          indiaX = indiaStateCirc.cx.baseVal.value;
          indiaY = indiaStateCirc.cy.baseVal.value;
        } else {
          usX = usdx;
          usY = usdy;
          indiaX = indiadx;
          indiaY = indiady;
        }
        self.createArc(usX, usY, indiaX, indiaY, lineNumber);
      }
      if (path === 'Home') {
        var usCircs = this.$refs.map.querySelector('#us').querySelectorAll('.circ');
        var indiaCircs = this.$refs.map.querySelector('#india').querySelectorAll('.circ'); // grab U.S. and India from Vue refs
        prepAndCreateArc(randomize(usCircs)[0], randomize(indiaCircs)[0], false, false, 0, 0, 0, 0);
        lineNumber++; // increment lineNumber so each line is uniquely identifiable
        self.interval = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* interval */](function () {
          // d3.interval = setInterval except it won't run on inactive pages (ie if user clicks differernt tab, then the animations will stop)
          if (self.$route.name !== 'Home') {
            lineNumber = 0;
            self.interval.stop();
          } else {
            // call until page change
            prepAndCreateArc(randomize(usCircs)[0], randomize(indiaCircs)[0], false, false, 0, 0, 0, 0);
            lineNumber++; // increment lineNumber so each line is uniquely identifiable
          }
        }, 2000);
      }
      if (isIE) {
        if (path === 'MapResults') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
            if (options.country === 'US' && checkIfIndianState(stateProvince)) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
            } else if (options.country !== 'US' && !checkIfIndianState(stateProvince)) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
            }
          });
          if (options.state_province === 'Washington D.C.') {
            __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.state_province.split(' ').join('-').split('.').join('').toLowerCase()).attr('class', 'state-selected').select('circle').attr('class', 'hidden');
          } else {
            __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.state_province.split(' ').join('-').toLowerCase()).attr('class', 'state-selected');
          } // color states red, selected state's country will not be selected

          __WEBPACK_IMPORTED_MODULE_3_d3__["c" /* selectAll */](options.country === 'US' ? '.us-state' : '.india-state').attr('class', 'hidden');

          var selectedStateProvince = __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.slug);
          var selStateProvBBox = document.getElementById(options.slug).getBBox();
          var scaleFactor = 600;

          var unscaledX = (svgBBox.width - selStateProvBBox.width) / 2 - selStateProvBBox.x;
          var unscaledY = (svgBBox.height - selStateProvBBox.height) / 2 - selStateProvBBox.y;
          var scale = scaleFactor / (selStateProvBBox.width + selStateProvBBox.height);
          var scaledX = (svgBBox.width / scale - selStateProvBBox.width) / 2 - selStateProvBBox.x;
          var scaledY = (svgBBox.height / scale - selStateProvBBox.height) / 2 - selStateProvBBox.y;
          var strokeWidth = document.defaultView.getComputedStyle(document.getElementById(options.slug)).getPropertyValue('stroke-width');

          selectedStateProvince.attr('transform', function () {
            // move and scale to middle of left side of screen
            return 'scale(' + scale + ', ' + scale + ') ' + 'translate(' + (options.country === 'US' ? parseInt(scaledX) - svgBBox.width / scale / 4 : parseInt(scaledX) + svgBBox.width / scale / 4) + ' ' + parseInt(scaledY) + ')';
          }).attr('stroke-width', strokeWidth); // modify stroke width

          self.interval = __WEBPACK_IMPORTED_MODULE_3_d3__["d" /* timeout */](function () {
            // d3.interval = setInterval except it won't run on inactive pages (ie if user clicks differernt tab, then the animations will stop)
            if (self.$route.name !== 'MapResults') {
              lineNumber = 0;
              self.interval.stop();
            } else {
              var selectedCirc = document.getElementById(options.slug).querySelector('.circ');
              var doc = document;
              var otherCircs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                return doc.getElementById(stateProvince).querySelector('.circ');
              });
              // need to find the location of the center of our points after scaling occurs. Because the scaling occurs using the center (because of transform-origin: center),
              // we have to find the new center based on the sacling from the perspective of the center of the bounding box of the path. yup fun
              // firstly, we got to find the center of our path. the value from path'b bbox for x is the distance from the left side of the svg to the right side of the path
              // and same for y coords. and our bbox width is the width of the box. so half the width of the box + our x coord is our center for x (thats the first two terms in dx)
              // then we need to find the distance to our old circle's coords, cx and cy.
              // this can be done by subtracting our center from our c values (notice the reuse of the center of the path)
              // the distance from the center to c values all times our scale will give us the distance from the center to the new values
              // then we simply add the center.
              var dx = selStateProvBBox.x + selStateProvBBox.width / 2 + (selectedCirc.cx.baseVal.value - (selStateProvBBox.x + selStateProvBBox.width / 2)) * scale;
              var dy = selStateProvBBox.y + selStateProvBBox.height / 2 + (selectedCirc.cy.baseVal.value - (selStateProvBBox.y + selStateProvBBox.height / 2)) * scale;
              for (var i = 0; i < otherCircs.length; i++) {
                lineNumber++;
                if (options.country === 'US' && checkIfIndianState(otherCircs[i].parentNode.id)) {
                  // when using our dx and dy, we need to compensate for translations as well, so the vals applied to the g tag are then applied here as well
                  prepAndCreateArc(selectedCirc, otherCircs[i], true, false, dx + parseInt(unscaledX) - svgBBox.width / 4, dy + parseInt(unscaledY), 0, 0);
                } else if (options.country === 'IN' && !checkIfIndianState(otherCircs[i].parentNode.id)) {
                  prepAndCreateArc(otherCircs[i], selectedCirc, false, true, 0, 0, dx + parseInt(unscaledX) + svgBBox.width / 4, dy + parseInt(unscaledY));
                }
              }
            }
          }, 1000);
        } else if (path === 'Partnership') {
          var doc = document;
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options.state_provinces).length > 2) {
            var desiredStates = [];
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
              desiredStates.push(doc.getElementById(stateProvince).querySelector('.circ'));
            });
            desiredStates.sort(function (a, b) {
              return a.cx.baseVal.value - b.cx.baseVal.value;
            });
            for (var i = 0; i < desiredStates.length; i++) {
              for (var j = i; j < desiredStates.length; j++) {
                if (!checkIfIndianState(desiredStates[i].parentNode.id) && checkIfIndianState(desiredStates[j].parentNode.id)) {
                  prepAndCreateArc(desiredStates[i], desiredStates[j], false, false, 0, 0, 0, 0);
                  lineNumber++; // increment lineNumber so each line is uniquely identifiable
                }
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_3_d3__["c" /* selectAll */]('.state').attr('class', 'hidden');
            var whichCountry = true;
            var _scaleFactor = 600;
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
              var selectedStateProvince = __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince);
              var selStateProvBBox = document.getElementById(stateProvince).getBBox();

              var scale = _scaleFactor / (selStateProvBBox.width + selStateProvBBox.height);
              var scaledX = (svgBBox.width / scale - selStateProvBBox.width) / 2 - selStateProvBBox.x;
              var scaledY = (svgBBox.height / scale - selStateProvBBox.height) / 2 - selStateProvBBox.y;
              var strokeWidth = document.defaultView.getComputedStyle(document.getElementById(stateProvince)).getPropertyValue('stroke-width');

              selectedStateProvince.attr('class', 'state-selected') // keep visible
              .attr('transform', function () {
                // move and scale to middle of left side of screen
                if (whichCountry) {
                  whichCountry = !whichCountry;
                  return 'scale(' + scale + ') ' + 'translate(' + (parseInt(scaledX) - svgBBox.width / scale / 4) + ', ' + parseInt(scaledY) + ')';
                } else {
                  whichCountry = !whichCountry;
                  return 'scale(' + scale + ') ' + 'translate(' + (parseInt(scaledX) + svgBBox.width / scale / 4) + ', ' + parseInt(scaledY) + ')';
                }
              }).attr('stroke-width', strokeWidth); // modify stroke width
            });
            self.interval = __WEBPACK_IMPORTED_MODULE_3_d3__["d" /* timeout */](function () {
              // d3.interval = setInterval except it won't run on inactive pages (ie if user clicks differernt tab, then the animations will stop)
              if (self.$route.name !== 'Partnership') {
                lineNumber = 0;
                self.interval.stop();
              } else {
                var _doc = document;
                var circs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                  return _doc.getElementById(stateProvince).querySelector('.circ');
                }); // grabbing our circles
                var bboxes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                  return document.getElementById(stateProvince).getBBox();
                }); // grabbing the bBox of the selected state
                var unscaledXs = [(svgBBox.width - bboxes[0].width) / 2 - bboxes[0].x, (svgBBox.width - bboxes[1].width) / 2 - bboxes[1].x]; // need to get each state's translation
                var unscaledYs = [(svgBBox.height - bboxes[0].height) / 2 - bboxes[0].y, (svgBBox.height - bboxes[1].height) / 2 - bboxes[1].y]; // ^^
                var scales = [_scaleFactor / (bboxes[0].width + bboxes[0].height), _scaleFactor / (bboxes[1].width + bboxes[1].height)]; // grabbing the scale applied to each by using the same method
                var usdx = bboxes[0].x + bboxes[0].width / 2 + (circs[0].cx.baseVal.value - (bboxes[0].x + bboxes[0].width / 2)) * scales[0]; // finding the new position of the center of the circle
                var usdy = bboxes[0].y + bboxes[0].height / 2 + (circs[0].cy.baseVal.value - (bboxes[0].y + bboxes[0].height / 2)) * scales[0]; // both x and y are needed for each state
                var indiadx = bboxes[1].x + bboxes[1].width / 2 + (circs[1].cx.baseVal.value - (bboxes[1].x + bboxes[1].width / 2)) * scales[1]; // called it dx since the center is usually
                var indiady = bboxes[1].y + bboxes[1].height / 2 + (circs[1].cy.baseVal.value - (bboxes[1].y + bboxes[1].height / 2)) * scales[1]; // cx. its kinda funny. The math behind this is explained in the mapResults part, this is the same but just with 2 points
                prepAndCreateArc(0, 0, true, true, usdx + parseInt(unscaledXs[0]) - svgBBox.width / 4, usdy + parseInt(unscaledYs[0]), indiadx + parseInt(unscaledXs[1]) + svgBBox.width / 4, indiady + parseInt(unscaledYs[1]));
              }
            }, 1000);
          }
        }
      }

      if (!isIE) {
        if (path === 'MapResults') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
            if (options.country === 'US' && checkIfIndianState(stateProvince)) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
            } else if (options.country !== 'US' && !checkIfIndianState(stateProvince)) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
            }
          });
          if (options.state_province === 'Washington D.C.') {
            __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.state_province.split(' ').join('-').split('.').join('').toLowerCase()).attr('class', 'state-selected').select('circle').attr('class', 'hidden');
          } else {
            __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.state_province.split(' ').join('-').toLowerCase()).attr('class', 'state-selected');
          } // color states red, selected state's country will not be selected

          __WEBPACK_IMPORTED_MODULE_3_d3__["c" /* selectAll */](options.country === 'US' ? '.us-state' : '.india-state').attr('class', 'hidden'); // make all states not selected disappear
          var _selectedStateProvince = __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + options.slug);
          var _selStateProvBBox = document.getElementById(options.slug).getBBox();
          var _scaleFactor2 = 600;
          var _unscaledX = (svgBBox.width - _selStateProvBBox.width) / 2 - _selStateProvBBox.x;
          var _unscaledY = (svgBBox.height - _selStateProvBBox.height) / 2 - _selStateProvBBox.y;
          var _scale = _scaleFactor2 / (_selStateProvBBox.width + _selStateProvBBox.height);
          var _strokeWidth = document.defaultView.getComputedStyle(document.getElementById(options.slug)).getPropertyValue('stroke-width');

          _selectedStateProvince.style('transform-box', 'fill-box') // change which box we are basing our calulations are on
          .style('transform-origin', 'center').transition() // begin transition
          .style('transform', function () {
            // move state to center of svg
            return 'translate(' + (options.country === 'US' ? parseInt(_unscaledX) - svgBBox.width / 4 : parseInt(_unscaledX) + svgBBox.width / 4) + 'px, ' + parseInt(_unscaledY) + 'px)';
          }).duration(1000) // duration of the above effects
          .transition() // being transtion after first transition
          .style('transform', function () {
            // move and scale to middle of left side of screen
            return 'translate(' + (options.country === 'US' ? Math.floor(parseInt(_unscaledX) - svgBBox.width / 4) : Math.floor(parseInt(_unscaledX) + svgBBox.width / 4)) + 'px, ' + parseInt(_unscaledY) + 'px) ' + 'scale(' + _scale + ')';
          }).attr('stroke-width', _strokeWidth) // modify stroke width
          .duration(1000); // duration of the above effects

          self.interval = __WEBPACK_IMPORTED_MODULE_3_d3__["d" /* timeout */](function () {
            // d3.interval = setInterval except it won't run on inactive pages (ie if user clicks differernt tab, then the animations will stop)
            if (self.$route.name !== 'MapResults') {
              lineNumber = 0;
              self.interval.stop();
            } else {
              var selectedCirc = document.getElementById(options.slug).querySelector('.circ');
              var _doc2 = document;
              var otherCircs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                return _doc2.getElementById(stateProvince).querySelector('.circ');
              });
              // need to find the location of the center of our points after scaling occurs. Because the scaling occurs using the center (because of transform-origin: center),
              // we have to find the new center based on the sacling from the perspective of the center of the bounding box of the path. yup fun
              // firstly, we got to find the center of our path. the value from path'b bbox for x is the distance from the left side of the svg to the right side of the path
              // and same for y coords. and our bbox width is the width of the box. so half the width of the box + our x coord is our center for x (thats the first two terms in dx)
              // then we need to find the distance to our old circle's coords, cx and cy.
              // this can be done by subtracting our center from our c values (notice the reuse of the center of the path)
              // the distance from the center to c values all times our scale will give us the distance from the center to the new values
              // then we simply add the center.
              var dx = _selStateProvBBox.x + _selStateProvBBox.width / 2 + (selectedCirc.cx.baseVal.value - (_selStateProvBBox.x + _selStateProvBBox.width / 2)) * _scale;
              var dy = _selStateProvBBox.y + _selStateProvBBox.height / 2 + (selectedCirc.cy.baseVal.value - (_selStateProvBBox.y + _selStateProvBBox.height / 2)) * _scale;
              for (var _i = 0; _i < otherCircs.length; _i++) {
                lineNumber++;
                if (options.country === 'US' && checkIfIndianState(otherCircs[_i].parentElement.id)) {
                  // when using our dx and dy, we need to compensate for translations as well, so the vals applied to the g tag are then applied here as well
                  prepAndCreateArc(selectedCirc, otherCircs[_i], true, false, dx + parseInt(_unscaledX) - svgBBox.width / 4, dy + parseInt(_unscaledY), 0, 0);
                } else if (options.country === 'IN' && !checkIfIndianState(otherCircs[_i].parentElement.id)) {
                  prepAndCreateArc(otherCircs[_i], selectedCirc, false, true, 0, 0, dx + parseInt(_unscaledX) + svgBBox.width / 4, dy + parseInt(_unscaledY));
                }
              }
            }
          }, 2500);
        } else if (path === 'Partnership') {
          var _doc3 = document;
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options.state_provinces).length > 2) {
            var _desiredStates = [];
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
              _desiredStates.push(_doc3.getElementById(stateProvince).querySelector('.circ'));
            });
            _desiredStates.sort(function (a, b) {
              return a.cx.baseVal.value - b.cx.baseVal.value;
            });
            for (var _i2 = 0; _i2 < _desiredStates.length; _i2++) {
              for (var _j = _i2; _j < _desiredStates.length; _j++) {
                if (!checkIfIndianState(_desiredStates[_i2].parentElement.id) && checkIfIndianState(_desiredStates[_j].parentElement.id)) {
                  prepAndCreateArc(_desiredStates[_i2], _desiredStates[_j], false, false, 0, 0, 0, 0);
                  lineNumber++; // increment lineNumber so each line is uniquely identifiable
                }
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_3_d3__["c" /* selectAll */]('.state').attr('class', 'hidden');
            var _whichCountry = true;
            var _scaleFactor3 = 600;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options.state_provinces).map(function (stateProvince) {
              __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince).attr('class', 'state-selected');
              var selectedStateProvince = __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + stateProvince);
              var selStateProvBBox = document.getElementById(stateProvince).getBBox();

              var unscaledX = (svgBBox.width - selStateProvBBox.width) / 2 - selStateProvBBox.x;
              var unscaledY = (svgBBox.height - selStateProvBBox.height) / 2 - selStateProvBBox.y;
              var scale = _scaleFactor3 / (selStateProvBBox.width + selStateProvBBox.height);
              var strokeWidth = document.defaultView.getComputedStyle(document.getElementById(stateProvince)).getPropertyValue('stroke-width');

              selectedStateProvince.attr('class', 'state-selected') // keep visible
              .style('transform-box', 'fill-box') // change which box we are basing our calulations are on
              .style('transform-origin', 'center').transition() // begin transition
              .style('transform', function () {
                // move state to center of svg
                if (_whichCountry) {
                  return 'translate(' + (parseInt(unscaledX) - svgBBox.width / 4) + 'px, ' + parseInt(unscaledY) + 'px)';
                } else {
                  return 'translate(' + (parseInt(unscaledX) + svgBBox.width / 4) + 'px, ' + parseInt(unscaledY) + 'px)';
                }
              }).duration(1000) // duration of the above effects
              .transition() // being transtion after first transition
              .style('transform', function () {
                // move and scale to middle of left side of screen
                if (_whichCountry) {
                  _whichCountry = !_whichCountry;
                  return 'translate(' + (parseInt(unscaledX) - svgBBox.width / 4) + 'px, ' + parseInt(unscaledY) + 'px)' + 'scale(' + scale + ')';
                } else {
                  _whichCountry = !_whichCountry;
                  return 'translate(' + (parseInt(unscaledX) + svgBBox.width / 4) + 'px, ' + parseInt(unscaledY) + 'px)' + 'scale(' + scale + ')';
                }
              }).attr('stroke-width', strokeWidth) // modify stroke width
              .duration(1000); // duration of the above effects
            });
            self.interval = __WEBPACK_IMPORTED_MODULE_3_d3__["d" /* timeout */](function () {
              // d3.interval = setInterval except it won't run on inactive pages (ie if user clicks differernt tab, then the animations will stop)
              if (self.$route.name !== 'Partnership') {
                lineNumber = 0;
                self.interval.stop();
              } else {
                var circs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                  return _doc3.getElementById(stateProvince).querySelector('.circ');
                }); // grabbing our circles
                var bboxes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(options.state_provinces).map(function (stateProvince) {
                  return document.getElementById(stateProvince).getBBox();
                }); // grabbing the bBox of the selected state
                var unscaledXs = [(svgBBox.width - bboxes[0].width) / 2 - bboxes[0].x, (svgBBox.width - bboxes[1].width) / 2 - bboxes[1].x]; // need to get each state's translation
                var unscaledYs = [(svgBBox.height - bboxes[0].height) / 2 - bboxes[0].y, (svgBBox.height - bboxes[1].height) / 2 - bboxes[1].y]; // ^^
                var scales = [_scaleFactor3 / (bboxes[0].width + bboxes[0].height), _scaleFactor3 / (bboxes[1].width + bboxes[1].height)]; // grabbing the scale applied to each by using the same method
                var usdx = bboxes[0].x + bboxes[0].width / 2 + (circs[0].cx.baseVal.value - (bboxes[0].x + bboxes[0].width / 2)) * scales[0]; // finding the new position of the center of the circle
                var usdy = bboxes[0].y + bboxes[0].height / 2 + (circs[0].cy.baseVal.value - (bboxes[0].y + bboxes[0].height / 2)) * scales[0]; // both x and y are needed for each state
                var indiadx = bboxes[1].x + bboxes[1].width / 2 + (circs[1].cx.baseVal.value - (bboxes[1].x + bboxes[1].width / 2)) * scales[1]; // called it dx since the center is usually
                var indiady = bboxes[1].y + bboxes[1].height / 2 + (circs[1].cy.baseVal.value - (bboxes[1].y + bboxes[1].height / 2)) * scales[1]; // cx. its kinda funny. The math behind this is explained in the mapResults part, this is the same but just with 2 points
                prepAndCreateArc(0, 0, true, true, usdx + parseInt(unscaledXs[0]) - svgBBox.width / 4, usdy + parseInt(unscaledYs[0]), indiadx + parseInt(unscaledXs[1]) + svgBBox.width / 4, indiady + parseInt(unscaledYs[1]));
              }
            }, 2500);
          }
        }
      }
    },
    createArc: function createArc(x1, y1, x2, y2, num) {
      // takes 2 points and a unique identifier
      // arcs require 3 points to be defined so we need to generate the other two points
      var x3 = 1 / 2 * Math.sqrt(Math.pow(x1 - x2, 2)) + (x1 <= x2 ? x1 : x2); // get the third x by using the point between the other two with regards to the x coordinates
      var y3 = y2 < y1 ? y2 / 2 : y1 / 2; // pick third y such that it is the point half-way between the y=0 and the smaller of the two y coordinates
      var A = -(x3 * (y2 - y1) - x2 * (y3 - y1) + x1 * (y3 - y2)) / ((x2 - x1) * (x3 - x1) * (x3 - x2));
      var B = (x2 + x1) * (x3 * (y2 - y1) - x2 * (y3 - y1) + x1 * (y3 - y2)) / ((x2 - x1) * (x3 - x1) * (x3 - x2)) + (y2 - y1) / (x2 - x1);
      var C = ((x2 * y1 - x1 * y2) * Math.pow(x3, 2) - (Math.pow(x2, 2) * y1 - Math.pow(x1, 2) * y2) * x3 + x1 * x2 * (x2 - x1) * y3) / ((x2 - x1) * (x3 - x1) * (x3 - x2));
      // to create a line we need the equation, so we assume our line will equal y = Ax^2 + Bx + C, with x and y being input and output respectively,
      // A, B, and C are found using a 3x3 matrix containing [[x1^2, x1, 1], [x2^2, x2, 1], [x3^2, x3, 1]] crossed with the 3x1 column vector [A, B, C] set equal to
      // another 3x1 column vector [y1, y2, y3]. by finding the inverse of the matrix we find A, B, and C are equivalent the to the above statements
      function data() {
        // uses A, B, and C to generate our line by generating a number of points equal to interations
        var vals = [];
        var range = Math.abs(x1 - x2); // range in inputs necessary to describe line. this statement is equal to sqrt((x1-x2)^2) (distance formula)
        var iterations = 200; // number of points to generate (inclusive from 0 to iterations) so 1000 iterations = 1001 points
        for (var i = 0; i <= iterations; i++) {
          // loop to genereate points
          var x = range * i / iterations + x1; // x1 is the starting point, range is the total distance between points, so we generate a fraction of range and add it to x1 to define our input
          vals.push({
            x: x,
            y: A * Math.pow(x, 2) + B * x + C // generate y following our assumption of y = Ax^2 + Bx + C
          });
        }
        return vals; // return array of points
      }
      var line = __WEBPACK_IMPORTED_MODULE_3_d3__["e" /* line */]() // use d3 to define a path d-attribute generator, we will give data to this function
      .x(function (d) {
        return d.x;
      }) // set each x = to the given objects x component
      .y(function (d) {
        return d.y;
      }); // set each y = to the given objects y component
      var pointData = data(x1, x2);
      __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#map').append('path') // apend outside of g tags and at the bottom of svg (it sits on top of everything and is unaffected by translations or scales we give to g tags)
      .attr('id', 'line' + String(num)) // use lineNumber to give the lines a unique identifier id='linex' where x is lineNumber
      .attr('d', line(pointData)) // generate d attribute using our path d attribute generator given our array of points on the line (this part connects the points with small lines)
      .attr('fill', 'none').attr('stroke', 'red').attr('stroke-width', 4 + 'px');
      this.afterLineGenerated(num); // pass line num and a boolean for if that arc crosses the atlantic. (dependant on map!!!!!)
    },
    afterLineGenerated: function afterLineGenerated(num) {
      function dashArrayData(numberOfDashes, lengthOfPath) {
        // this will generate our stroke-dasharray data
        // stroke-dasharray is defined by numbers such that each other number signifies the length of a dash and the remaining define the length of the space between the dashes
        // the pattern entered is repeated kinda forever. We will use this to make it appear line our line is moving, when we are actually just moving dashes along the line
        var dashLength = lengthOfPath / (numberOfDashes * 2); // get the dash length (recall a dash and its space need room so the number of dashes really means the number of dash + the number of spaces)
        var stringPrep = '' + dashLength + ', ' + dashLength + ', '; // prep string to copy with the first dashLength being for dash length and the second being for space-between-dashes length
        var dashedData = '';
        for (var i = 0; i < numberOfDashes; i++) {
          // dashedData =+ (i !== 0 && i !== numberOfDashes) ? stringPrep : ((i === 0) ? '' + 0 + ', ' + dashLength / 2 + ',' + stringPrep : '' + 0 + ', ' + dashLength / 2 + ',')
          // the above statement is for those who hate others
          if (i !== 0 && i !== numberOfDashes) {
            dashedData += stringPrep;
          } else {
            if (i === 0) {
              dashedData += '' + 0 + ', ' + dashLength / 2 + ',' + stringPrep;
            } else if (i === Math.floor(numberOfDashes)) {
              dashedData += '' + 0 + ', ' + dashLength / 2 + ',';
            }
          }
        }
        return dashedData + '0, ' + lengthOfPath; // add 0 for a dash of length zero followed by the length of our path.
      }
      var animateTimeBefore = 2000; // amount of time the line will be moving when first generated it moves (milliseconds) on home page
      var animateTime = 2750; // line animation time for mapResults and Partnerships pages
      var delayTime = 2000; // amount of time the line will stay on the page visibily (line lifespan is appox = to 2*animateTime + delayTime) (milliseconds)
      var animateTimeAfter = 3000; // amount of time the line will be moving before deletion it moves (milliseconds) on home page
      if (this.$route.name === 'Home') {
        var stringPrep = '#line' + String(num); // create the unique selector for our current line
        var length = document.querySelector(stringPrep).getTotalLength(); // get the line's length
        var direction = Math.random(); // used to allow lines to move from india to us and us to india
        var dashArray = dashArrayData(20, length); // grab dash data
        if (direction < 0.5) {
          // looks as if the line comes from the U.S. and travels to India
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](stringPrep).attr('stroke-dasharray', dashArray) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', length) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from left to right
          .duration(animateTimeBefore).transition().delay(delayTime).attr('stroke-dashoffset', -length) // animate dash out of view from left to right
          .duration(animateTimeAfter).remove(); // remove elem from DOM
        } else {
          // looks as if the lines comes from India and travels to the U.S.
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](stringPrep).attr('stroke-dasharray', dashArray) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', -length) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from right to left
          .duration(animateTimeAfter).transition().delay(delayTime).attr('stroke-dashoffset', length) // animate dash out of view from right to left
          .duration(animateTimeAfter).remove(); // remove elem from DOM
        }
      } else if (this.$route.name === 'MapResults') {
        var _stringPrep = '#line' + String(num); // create the unique selector for our current line
        var _length = document.querySelector(_stringPrep).getTotalLength(); // get the line's length
        var _direction = Math.random(); // used to allow lines to move from india to us and us to india
        var _dashArray = dashArrayData(20, _length); // grab dash data
        if (_direction < 0.5) {
          // looks as if the line comes from the U.S. and travels to India
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](_stringPrep).attr('stroke', 'white').attr('stroke-dasharray', _dashArray) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', _length) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from left to right
          .duration(animateTime);
        } else {
          // looks as if the lines comes from India and travels to the U.S.
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](_stringPrep).attr('stroke', 'white').attr('stroke-dasharray', _dashArray) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', -_length) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from right to left
          .duration(animateTime);
        }
      } else if (this.$route.name === 'Partnership') {
        var moreThan2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options.state_provinces).length > 2;
        var _stringPrep2 = '#line' + String(num); // create the unique selector for our current line
        var _length2 = document.querySelector(_stringPrep2).getTotalLength(); // get the line's length
        var _direction2 = Math.random(); // used to allow lines to move from india to us and us to india
        var _dashArray2 = dashArrayData(20, _length2); // grab dash data
        if (_direction2 < 0.5) {
          // looks as if the line comes from the U.S. and travels to India
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](_stringPrep2) // cx="637.42" cy="99.15" cx="727.47" cy="368.7"
          .attr('stroke', moreThan2 ? '#d71920' : 'white').attr('stroke-dasharray', _dashArray2) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', _length2) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from left to right
          .duration(animateTime);
        } else {
          // looks as if the lines comes from India and travels to the U.S.
          __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */](_stringPrep2).attr('stroke', moreThan2 ? '#d71920' : 'white').attr('stroke-dasharray', _dashArray2) // make dashes equal to the length of the path
          .attr('stroke-dashoffset', -_length2) // move dash so space between dashes (which is the same length) is visible (i.e. make dash look invisible)
          .transition().attr('stroke-dashoffset', '0') // animate dash into view from right to left
          .duration(animateTime);
        }
      }
    },
    passSlug: function passSlug(slug) {
      if (this.clickDisabled) {
        return null;
      }

      if (this.$route.name === 'Home') {
        this.$router.push({
          path: '/map-results/' + slug
        });
      } else {
        this.$router.replace({
          path: '/map-results/' + slug
        });

        location.reload();
      }
    }
  },
  beforeCreate: function beforeCreate() {
    this.loading = this.$route.name !== 'Home';
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* select */]('#' + this.$refs.map.id).selectAll('g.state').classed('click-disabled', this.clickDisabled).on('click', function () {
      var element = __WEBPACK_IMPORTED_MODULE_3_d3__["f" /* event */].target; // seems to always grab whatever's on top (usually the path). washingtonDC and jammu kashmir both do the false of the below terinary. others do true

      _this.passSlug(element.parentNode.parentNode.id === 'us' || element.parentNode.parentNode.id === 'india' ? element.parentNode.id : element.parentNode.parentNode.id);
    });

    if (this.$route.name === 'Home') {
      this.modMap('Home', this.options);

      this.axios({
        method: 'get',
        url: '/program/state-province'
      }).then(function (response) {
        Array.prototype.slice.call(document.querySelectorAll('g.state')).map(function (stateProvince) {
          var partnershipText = stateProvince.querySelector('title').innerHTML + ' - ';

          partnershipText += response.data[stateProvince.id] === 0 ? 'No' : response.data[stateProvince.id];

          partnershipText += response.data[stateProvince.id] === 1 ? ' partnership' : ' partnerships';

          stateProvince.querySelector('title').innerHTML = partnershipText;
        });
      });
    }
  },

  watch: {
    options: function options(newOptions, oldOptions) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldOptions) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newOptions)) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options.state_provinces).length > 1) {
          this.modMap(this.$route.name, this.options);
        }
      }
    },
    interval: function interval() {
      if (this.interval !== undefined) {
        this.$emit('clicked', this.interval);
      }
    }
  }
});

/***/ }),

/***/ "5F7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SearchInput__ = __webpack_require__("TCsi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyNavbar',
  data: function data() {
    return {
      search: ''
    };
  },
  components: {
    SearchInput: __WEBPACK_IMPORTED_MODULE_0__components_SearchInput__["a" /* default */]
  }
});

/***/ }),

/***/ "5u05":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/unoLogo.87017a2.png";

/***/ }),

/***/ "7HOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestListing',
  computed: {
    usStateProvinceOptions: function usStateProvinceOptions() {
      return this.$root.stateProvinceOptions.US;
    },
    indiaStateProvinceOptions: function indiaStateProvinceOptions() {
      return this.$root.stateProvinceOptions.IN;
    },
    yearEstablishedOptions: function yearEstablishedOptions() {
      var years = [];
      var currentYear = new Date().getFullYear();
      var lastCentury = (currentYear / 100 - currentYear % 100 / 100 - 1) * 100;
      var nextCentury = (currentYear / 100 - currentYear % 100 / 100 + 1) * 100;

      for (var i = lastCentury; i < nextCentury; i++) {
        years.push(i);
      }

      return years;
    }
  },
  data: function data() {
    return {
      success: false,
      failure: false,
      errors: {},
      request: {
        name: '',
        description: '',
        year_established: '',
        end_date: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        website: '',
        type: '',
        sector: '',
        grant_funding: '',
        us_institution: {
          name: '',
          state_province: '',
          unit: ''
        },
        indian_institution: {
          name: '',
          state_province: '',
          unit: ''
        },
        additional_institutions: [],
        terms_agreement: false,
        g_recaptcha_response: ''
      },
      sector_options: [],
      type_options: []
    };
  },
  methods: {
    addAdditionalInstitution: function addAdditionalInstitution(type) {
      this.request.additional_institutions.push({
        name: '',
        state_province: '',
        unit: '',
        type: type
      });
    },
    removeAdditionalInstitution: function removeAdditionalInstitution(index) {
      this.request.additional_institutions.splice(index, 1);
    },
    submitRequest: function submitRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (false) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return _this.$recaptcha('request');

              case 3:
                _context.t0 = _context.sent;
                _context.next = 7;
                break;

              case 6:
                _context.t0 = '';

              case 7:
                _this.request.g_recaptcha_response = _context.t0;


                _this.axios({
                  method: 'post',
                  url: '/program-request',
                  data: _this.request
                }).then(function (response) {
                  _this.errors = {};
                  _this.failure = false;
                  _this.success = true;
                }).catch(function (error) {
                  _this.errors = error.response.data.errors;
                  _this.failure = true;
                  _this.success = false;
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$root.setTitle('Request Listing');

      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(function (response) {
        vm.sector_options = response.data.sort();
      });

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(function (response) {
        vm.type_options = response.data.sort();
      });
    });
  }
});

/***/ }),

/***/ "7qhD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fof-error"}},[_c('error-component',[_c('template',{slot:"title"},[_c('h1',[_vm._v("404 Error")])]),_vm._v(" "),_c('template',{slot:"subtitle"},[_c('h2',[_vm._v("Page not found")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('p',[_vm._v("\n        Missing a Partnership? Add a new Partnership by following the link below.\n      ")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8EsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha_v3__ = __webpack_require__("oHEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha_v3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha_v3__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha_v3__["VueReCaptcha"], {
  siteKey: '6LckNJ8UAAAAAGUkjhG4adl7MGhhab1TnN-dB0gz'
});

/***/ }),

/***/ "8VA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ErrorComponent__ = __webpack_require__("9dHk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FOFError',
  components: {
    ErrorComponent: __WEBPACK_IMPORTED_MODULE_0__components_ErrorComponent__["a" /* default */]
  }
});

/***/ }),

/***/ "8wjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyNavbar_vue__ = __webpack_require__("5F7O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8e489c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyNavbar_vue__ = __webpack_require__("a52l");
function injectStyle (ssrContext) {
  __webpack_require__("eFqj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be8e489c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8e489c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9dHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorComponent_vue__ = __webpack_require__("IRlL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee91b49a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorComponent_vue__ = __webpack_require__("mbW+");
function injectStyle (ssrContext) {
  __webpack_require__("Rc3X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee91b49a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee91b49a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AWDV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DSt2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DgfF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('maps',{staticClass:"maps",on:{"clicked":_vm.setInterval}},[_c('template',{slot:"title-rows"},[_c('b-row',{staticClass:"title-rows"},[_c('b-col',[_c('h3',{attrs:{"id":"explore-title"}},[_vm._v("Explore the Partnerships")])])],1),_vm._v(" "),_c('b-row',{staticClass:"title-rows"},[_c('b-col',[_c('h5',{attrs:{"id":"select-title"}},[_vm._v("Select a state or province to start.")])])],1)],1)],2),_vm._v(" "),_c('div',{attrs:{"id":"lower-search"}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("About Partnership 2020")]),_vm._v(" "),_c('p',[_c('i',[_vm._v("Partnership 2020: Leveraging US-India Cooperation in Higher Education to Harness Economic Opportunities and Innovation")]),_vm._v("\n            is a collaborative agreement between University of Nebraska at Omaha (UNO) and US Department of State (DOS) with Center for Strategic\n            and International Studies (CSIS) playing a key advisory role. This is a two-year project with most of the activities taking place in 2019 and 2020.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            If you have a partnership and do not see it on the site, you can submit a request at\n            "),_c('a',{attrs:{"href":"/request-listing","id":"wrap"}},[_vm._v(_vm._s(_vm.baseUrl + 'request-listing'))])])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"U.S. States","label-for":"us-state"}},[_c('b-form-select',{attrs:{"id":"us-state","options":_vm.usStateOptions,"text-field":"name","value-field":"name"},model:{value:(_vm.usState),callback:function ($$v) {_vm.usState=$$v},expression:"usState"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All U.S. States")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"India States/Provinces","label-for":"india-province"}},[_c('b-form-select',{attrs:{"id":"india-province","options":_vm.indiaProvinceOptions,"text-field":"name","value-field":"name"},model:{value:(_vm.indiaProvince),callback:function ($$v) {_vm.indiaProvince=$$v},expression:"indiaProvince"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All India States/Provinces")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"Sector","label-for":"sector"}},[_c('b-form-select',{attrs:{"id":"sector","options":_vm.sector_options,"text-field":"name","value-field":"name"},model:{value:(_vm.sector),callback:function ($$v) {_vm.sector=$$v},expression:"sector"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Sectors")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"Type","label-for":"type"}},[_c('b-form-select',{attrs:{"id":"type","options":_vm.type_options,"text-field":"name","value-field":"name"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Types")])])],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mr-auto ml-auto",attrs:{"id":"submit-wrap"}},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"","label-for":"submit"}},[_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":function($event){_vm.submitResults()}}},[_vm._v("\n                  Search\n              ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Er0J":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HOV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("dPB5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1844a979_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("DgfF");
function injectStyle (ssrContext) {
  __webpack_require__("AWDV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1844a979"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1844a979_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IRlL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorComponent'
});

/***/ }),

/***/ "IXu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search-input"}},[_c('div',{staticClass:"form-control search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"name":"search","placeholder":_vm.placeholder,"type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('button',{class:(_vm.search === '') ? 'hidden' : '',attrs:{"type":"button"},on:{"click":_vm.clearSearch}},[_c('span',[_vm._v("X")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IsxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__ = __webpack_require__("4+x6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d39e65d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__ = __webpack_require__("pi7S");
function injectStyle (ssrContext) {
  __webpack_require__("r4PC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d39e65d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J0jU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JJZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"partnership"}},[(_vm.invalid_partnership)?_c('div',[_c('error-component',[_c('template',{slot:"title"},[_c('h1',[_vm._v("404 Error")])]),_vm._v(" "),_c('template',{slot:"subtitle"},[_c('h2',[_vm._v("Page not found")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('p',[_vm._v("\n          Missing a Partnership? Add a new Partnership by following the link below.\n        ")])])],2)],1):_vm._e(),_vm._v(" "),(!_vm.invalid_partnership)?_c('div',[(_vm.loading)?_c('div',{staticClass:"loading-screen"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h2',[_vm._v("Loading...")])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.loading ? 'hidden' : 'content'},[_c('maps',{attrs:{"clickDisabled":true,"options":_vm.map_options}},[_c('template',{slot:"title-rows"},[_c('b-row',{staticClass:"title-rows"},[_c('b-col',[_c('h1',{attrs:{"id":"explore-title"}},[_vm._v(_vm._s(_vm.partnershipTitle))]),_vm._v(" "),_c('h2',{staticClass:"partnership-states"},_vm._l((_vm.stateProvinces),function(stateProvince,index){return _c('span',{key:index},[_vm._v("\n                    "+_vm._s((index != (_vm.stateProvinces.length - 1)) ? stateProvince + ',' : stateProvince)+"\n                  ")])}),0)])],1)],1)],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-container',[_c('b-row',{staticClass:"partnership-content"},[_c('b-col',{attrs:{"md":"12"}},[_c('h2',[_vm._v(_vm._s(_vm.partnership.name))]),_vm._v(" "),(_vm.partnership.description)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',[_c('strong',[_vm._v("Description")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.partnership.description)+"\n                  ")])])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('div',[_c('strong',[_vm._v("Year Established")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.partnership.year_established)+"\n                  ")])])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[(_vm.partnership.end_date)?_c('div',[_c('strong',[_vm._v("Expected Tenure")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.partnership.end_date)+"\n                  ")])]):_vm._e()])],1),_vm._v(" "),(_vm.partnership.grant_funding)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('strong',[_vm._v("Funding Sources")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.partnership.grant_funding)+"\n                ")])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('strong',[_vm._v("Sector")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.partnership.sector)+"\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('strong',[_vm._v("Type")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.partnership.type)+"\n                ")])])],1),_vm._v(" "),(_vm.partnership.contact_name || _vm.partnership.email || _vm.partnership.contact_phone)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('strong',[_vm._v("Contact")]),_vm._v(" "),(_vm.partnership.contact_name)?_c('div',{staticClass:"contact-container"},[_vm._v("\n                    "+_vm._s(_vm.partnership.contact_name)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.partnership.email)?_c('div',{staticClass:"contact-container"},[_c('a',{staticClass:"other",attrs:{"href":'mailto:' + _vm.partnership.email}},[_vm._v(_vm._s(_vm.partnership.email))])]):_vm._e(),_vm._v(" "),(_vm.partnership.contact_phone)?_c('div',{staticClass:"contact-container"},[_c('a',{staticClass:"other",attrs:{"href":'tel:' + _vm.partnership.contact_phone}},[_vm._v(_vm._s(_vm.partnership.contact_phone))])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.partnership.institutions.length > 0)?_c('br'):_vm._e(),_vm._v(" "),_vm._l((_vm.partnership.institutions),function(institution){return _c('div',[_c('div',[_c('h2',[_vm._v(_vm._s(institution.name))])]),_vm._v(" "),(institution.contact_name || institution.contact_email || institution.contact_phone)?_c('div',[_c('strong',[_vm._v("Contact")]),_vm._v(" "),(institution.contact_name)?_c('div',{staticClass:"contact-container"},[_vm._v("\n                    "+_vm._s(institution.contact_name)+"\n                  ")]):_vm._e(),_vm._v(" "),(institution.contact_email)?_c('div',{staticClass:"contact-container"},[_c('a',{staticClass:"other",attrs:{"href":'mailto:' + institution.contact_email}},[_vm._v(_vm._s(institution.contact_email))])]):_vm._e(),_vm._v(" "),(institution.contact_phone)?_c('div',{staticClass:"contact-container"},[_c('a',{staticClass:"other",attrs:{"href":'tel:' + institution.contact_phone}},[_vm._v(_vm._s(institution.contact_phone))])]):_vm._e(),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(institution.website)?_c('div',[_c('strong',[_vm._v("Website")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"website",attrs:{"href":institution.website,"target":"_blank"}},[_vm._v(_vm._s(institution.website))])]):_vm._e(),_vm._v(" "),_c('br')])})],2)],1)],1)],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kfvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('b-container',{attrs:{"id":"my-footer"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('b-row',{staticClass:"mr-md-1",attrs:{"id":"navItems"}},[_c('b-nav',{staticClass:"ml-md-auto",attrs:{"id":"navCol"}},[_c('b-nav-item',{staticClass:"navLink",attrs:{"active":(this.$route.name === 'Home'),"href":"/"}},[_vm._v("\n              Home\n            ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navLink",attrs:{"active":(this.$route.name === 'Partnerships'),"href":"/partnerships"}},[_vm._v("\n              Partnerships\n            ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navLink",attrs:{"active":(this.$route.name === 'About'),"href":"/about"}},[_vm._v("\n              About\n            ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navLink",attrs:{"active":(this.$route.name === 'Contact'),"href":"/contact"}},[_vm._v("\n              Contact\n            ")])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"id":"searchItem","align-h":"center"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('search-input',{staticClass:"search",attrs:{"placeholder":"Search Partnerships"}})],1)],1),_vm._v(" "),_c('b-row',{attrs:{"id":"logos","align-h":"center"}},[_c('b-col',{staticClass:"mt-auto mb-auto",attrs:{"cols":"4"}},[_c('a',{attrs:{"href":"https://www.csis.org/","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"mx-auto d-block",attrs:{"id":"csisLogo","alt":"CSIS Logo","src":__webpack_require__("Er0J")}})])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto mb-auto",attrs:{"cols":"4"}},[_c('a',{attrs:{"href":"https://www.state.gov/","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"mx-auto d-block",attrs:{"id":"stateLogo","alt":"State Department Logo","src":__webpack_require__("axf+")}})])]),_vm._v(" "),_c('b-col',{staticClass:"mt-auto mb-auto",attrs:{"cols":"4"}},[_c('a',{attrs:{"href":"https://www.unomaha.edu/international-studies-and-programs/engagement/partnership2020/index.php","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"mx-auto d-block",attrs:{"id":"unoLogo","alt":"UNO logo","src":__webpack_require__("5u05")}})])])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2 message",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"id":"discT","cols":"12","md":"6"}},[_c('p',{staticClass:"text"},[_vm._v("Website created by staff and students at the\n            "),_c('a',{staticClass:"text",attrs:{"href":"https://cist.unomaha.edu","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("College of Information Science and Technology.")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2 message",attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"id":"discT","cols":"12","md":"6"}},[_c('p',{staticClass:"text"},[_vm._v("The University of Nebraska does not discriminate based on race, color, ethnicity, national origin, sex, pregnancy, sexual orientation, gender indentity, religion, disability, age, genetic information, veteran status, marital status, and/or political affiliation in its programs, activities, or employment. Learn more about Equity, Access, and Diversity.")]),_vm._v(" "),_c('div',{attrs:{"id":"reportIssue"}},[_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.footerCopyright)}})])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kkag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




var axiosInstance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://partnership2020.org/api',
  timeoute: 1000
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, axiosInstance);

/***/ }),

/***/ "LU4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchInput__ = __webpack_require__("TCsi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyFooter',
  data: function data() {
    return {
      search: ''
    };
  },
  components: {
    SearchInput: __WEBPACK_IMPORTED_MODULE_0__SearchInput__["a" /* default */]
  },
  computed: {
    footerCopyright: function footerCopyright() {
      return '&#169; ' + new Date().getFullYear();
    }
  },
  methods: {
    submitSearch: function submitSearch() {
      this.$router.push({
        name: 'Partnerships',
        query: {
          search: this.search,
          order: this.$route.query.order,
          country: this.$route.query.country,
          state_province: this.$route.query.state_province
        }
      });

      this.$router.go();
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9d2fa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Y8Tb");
function injectStyle (ssrContext) {
  __webpack_require__("HOV8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9d2fa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MuNy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pagination"}},[_c('paginate',{attrs:{"click-handler":_vm.clickHandler,"container-class":'pagination',"prev-class":'prev-item',"next-class":'next-item',"page-class":'page-item',"page-count":_vm.pageCount,"prev-text":'<',"next-text":'>'},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_axios__ = __webpack_require__("Kkag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_bootstrap_vue__ = __webpack_require__("cQn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_app_scss__ = __webpack_require__("tfUm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sass_app_scss__);









if (true) {
  try {
    __webpack_require__("bgvy");
  } catch (e) {
    console.log('Our analytics tracker failed to load!');
    var a = document.getElementById('erroranalytics');
    a.style.textAlign = 'center';
    a.style.width = '100%';
    a.style.backgroundColor = '#d71920';
    a.style.display = 'inline-block';
  }
  try {
    __webpack_require__("8EsQ");
  } catch (e) {
    console.log('Our analytics tracker failed to load!');
    var _a = document.getElementById('errorcaptcha');
    _a.style.textAlign = 'center';
    _a.style.width = '100%';
    _a.style.backgroundColor = '#d71920';
    _a.style.display = 'inline-block';
  }
}

if (true) {
  __webpack_require__("Zq5b");
}

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] },
  data: function data() {
    return {
      stateProvinceOptions: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.axios({
      method: 'get',
      url: '/state-provinces'
    }).then(function (response) {
      _this.stateProvinceOptions = response.data;
    });
  },

  methods: {
    setTitle: function setTitle(title) {
      document.title = title + ' | US - India Partnership 2020';
    }
  }
});

/***/ }),

/***/ "NwsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnerships_vue__ = __webpack_require__("djPK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5d5aa3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnerships_vue__ = __webpack_require__("nHzF");
function injectStyle (ssrContext) {
  __webpack_require__("obWe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f5d5aa3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partnerships_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f5d5aa3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partnerships_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PkbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FOFError_vue__ = __webpack_require__("8VA1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afe9b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FOFError_vue__ = __webpack_require__("7qhD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FOFError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afe9b16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FOFError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RNO/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RT3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ErrorComponent__ = __webpack_require__("9dHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Maps__ = __webpack_require__("IsxP");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Partnership',
  components: {
    ErrorComponent: __WEBPACK_IMPORTED_MODULE_2__components_ErrorComponent__["a" /* default */],
    Maps: __WEBPACK_IMPORTED_MODULE_3__components_Maps__["a" /* default */]
  },
  computed: {
    partnershipTitle: function partnershipTitle() {
      return this.partnership.name;
    },
    stateProvinces: function stateProvinces() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.partnership.institutions.map(function (institution) {
        return institution.state_province;
      })))).sort();
    }
  },
  data: function data() {
    return {
      partnership: {
        institutions: []
      },
      map_options: {},
      loading: true,
      invalid_partnership: false
    };
  },
  methods: {
    handleError: function handleError(error) {
      /* eslint-disable no-self-assign */
      error = error;
      return null;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$root.setTitle('Partnership');

      vm.axios({
        method: 'get',
        url: '/program/' + to.params.partnership_slug
      }).then(function (response) {
        if (response.data.length !== 0) {
          if (response.data.name !== undefined) {
            vm.$root.setTitle(response.data.name + ' | Partnership');
          }

          vm.partnership = response.data;

          vm.map_options = {
            state_provinces: response.data.state_provinces
          };
        } else {
          vm.invalid_partnership = true;
        }

        vm.loading = false;
      }).catch(function (error) {
        vm.handleError(error);
        vm.invalid_partnership = true;
      });
    });
  }
});

/***/ }),

/***/ "Rc3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchInput_vue__ = __webpack_require__("cKKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04577e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchInput_vue__ = __webpack_require__("IXu9");
function injectStyle (ssrContext) {
  __webpack_require__("DSt2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04577e7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04577e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TE/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('span',[_c('h1',[_vm._v("Contact Us")])]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Soraya Rahmanzai")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n        Partnership 2020 Project Coordinator\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"tel:1+4025542375"}},[_vm._v("+1 (402) 554-2375")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"mailto:srahamanzai@unomaha.edu"}},[_vm._v("srahamanzai@unomaha.edu")])])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n      For more information about the US-India Partnership 2020 initiative,\n      request for proposal instructions for sub-grants to US universities,\n      and access to other resources, please visit:\n  ")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"id":"wrap","target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/index.php'}},[_vm._v(_vm._s(_vm.uno_is_url)+"/index.php")])]),_vm._v(" "),_vm._l(([1,2,3,4,5,6,7,8,9,10]),function(i){return _c('br')})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XT5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y8Tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('my-navbar'),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.name})],1)],1),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YOkb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__("HXef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Contact__ = __webpack_require__("uRks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About__ = __webpack_require__("en7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_MapResults__ = __webpack_require__("wAPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Partnerships__ = __webpack_require__("NwsY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Partnership__ = __webpack_require__("1XGG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_FOFError__ = __webpack_require__("PkbU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_RequestListing__ = __webpack_require__("s2gU");



// Import Pages









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Contact__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_About__["a" /* default */]
  }, {
    path: '/map-results/:state_province_slug',
    name: 'MapResults',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_MapResults__["a" /* default */]
  }, {
    path: '/partnerships',
    name: 'Partnerships',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Partnerships__["a" /* default */]
  }, {
    path: '/partnership/:partnership_slug',
    name: 'Partnership',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Partnership__["a" /* default */]
  }, {
    path: '/request-listing',
    name: 'RequestListing',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_RequestListing__["a" /* default */]
  }, {
    path: '*',
    name: 'FOFError',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_FOFError__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // controls navigation behavior
    if (savedPosition) {
      return savedPosition; // if savedPosition is filled, then navigate there
    } else if (to.hash) {
      return { selector: to.hash // simulated scroll-to-anchor behavior
      };
    } else {
      return { x: 0, y: 0 // else scroll to top
      };
    }
  }
}));

/***/ }),

/***/ "Zq5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bugsnag_js__ = __webpack_require__("WdoM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bugsnag_plugin_vue__ = __webpack_require__("KIXd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bugsnag_plugin_vue__);




var BugsnagClient = __WEBPACK_IMPORTED_MODULE_1__bugsnag_js___default()('273f86df74865279f8762b18720be9cc');
BugsnagClient.use(__WEBPACK_IMPORTED_MODULE_2__bugsnag_plugin_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);

/***/ }),

/***/ "a52l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my-navbar"}},[_c('b-navbar',{attrs:{"toggleable":"xl","type":"dark","variant":"dark"}},[_c('b-navbar-brand',{attrs:{"href":"/"}},[_c('div',{staticClass:"subsite-logos"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"alt":"University of Nebraska Omaha","src":__webpack_require__("1w2/")}})]),_vm._v(" "),_c('div',{attrs:{"id":"div"}},[_c('a',{staticClass:"college wrap",attrs:{"href":"/"}},[_vm._v("University of Nebraska Omaha")]),_vm._v(" "),_c('a',{staticClass:"department wrap",attrs:{"href":"/"}},[_vm._v("US - India Partnership 2020")])])])]),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto pt-2"},[_c('b-nav-item',{staticClass:"top-nav",attrs:{"active":(this.$route.name === 'Home'),"id":"home-nav","href":"/"}},[_vm._v("\n          Home\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"bottom-nav",attrs:{"active":(this.$route.name === 'Partnerships'),"id":"partnerships-nav","href":"/partnerships"}},[_vm._v("\n          Partnerships\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"top-nav",attrs:{"active":(this.$route.name === 'About'),"id":"about-nav","href":"/about"}},[_vm._v("\n          About\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"top-nav",attrs:{"active":(this.$route.name === 'Contact'),"id":"contact-nav","href":"/contact"}},[_vm._v("\n          Contact\n        ")])],1),_vm._v(" "),_c('search-input',{attrs:{"placeholder":"Search Partnerships"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aslb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "axf+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/StateDeptLogo-Sm.f35c2cd.png";

/***/ }),

/***/ "bgvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
  id: 'UA-5438545-32',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/***/ }),

/***/ "cKKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: ''
    };
  },
  methods: {
    clearSearch: function clearSearch() {
      this.search = '';
    },
    submitSearch: function submitSearch(event) {
      if (this.search === '') {
        event.preventDefault();
      } else {
        this.$router.push({
          name: 'Partnerships',
          query: {
            search: this.search,
            order: this.$route.query.order,
            country: this.$route.query.country,
            state_province: this.$route.query.state_province
          }
        });

        this.$router.go();
      }
    }
  },
  props: {
    placeholder: {
      default: '',
      required: false,
      type: String
    },
    value: {
      default: '',
      required: false,
      type: String
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.search = '';
    }
  }
});

/***/ }),

/***/ "cMGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("xJvq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561ec40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("MuNy");
function injectStyle (ssrContext) {
  __webpack_require__("aslb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_561ec40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

/***/ }),

/***/ "cfVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"request-listing"}},[_c('b-row',{staticClass:"request-row"},[_c('b-col',{attrs:{"md":"12"}},[_c('h1',[_vm._v("Request To Add A Partnership")]),_vm._v(" "),_c('p',[_vm._v("\n        This survey is part of a project funded by the U.S. Department of State\n        to capture current tie-ups between American and Indian colleges and universities.\n        Results will be included in this online database accessible to the public.\n        Respondents will be notified about Fulbright program opportunities and new\n        fellowships and grant opportunities.\n      ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"request-row"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-alert',{attrs:{"variant":"success"},model:{value:(_vm.success),callback:function ($$v) {_vm.success=$$v},expression:"success"}},[_vm._v("\n        Your Partnership request has been submitted. It will be reviewed shortly.\n      ")]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"danger"},model:{value:(_vm.failure),callback:function ($$v) {_vm.failure=$$v},expression:"failure"}},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n            "+_vm._s(error[0])+"\n          ")])}),0)]),_vm._v(" "),(!_vm.success)?_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitRequest($event)}}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Partnership Information")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Name of Partnership/Project *","label-for":"name"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                This is the name displayed on the Partnership's listing page.\n                If the Partnership doesn't have a specific name,\n                the names of the participating institutions separated by a\n                hyphen may be used. (i.e. University 1 - University 2)\n              ")]),_vm._v(" "),_c('b-input',{attrs:{"id":"name","type":"text","autocorrect":"off","required":""},model:{value:(_vm.request.name),callback:function ($$v) {_vm.$set(_vm.request, "name", $$v)},expression:"request.name"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Description","label-for":"description"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  This is a brief description of the Partnership to be shown\n                  on the Partnership's listing page. (optional)\n                ")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"description","rows":"5","max-rows":"5","no-resize":""},model:{value:(_vm.request.description),callback:function ($$v) {_vm.$set(_vm.request, "description", $$v)},expression:"request.description"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Year Established *","label-for":"year-established"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  This is the year the Partnership was first established.\n                  "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"year-established","options":_vm.yearEstablishedOptions,"required":""},model:{value:(_vm.request.year_established),callback:function ($$v) {_vm.$set(_vm.request, "year_established", $$v)},expression:"request.year_established"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Expected Tenure","label-for":"end-date"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  Use \"In perpetuity\" or \"N/A\" if there is no\n                  projected end date. (optional)\n                ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"end-date","type":"text","autocorrect":"off"},model:{value:(_vm.request.end_date),callback:function ($$v) {_vm.$set(_vm.request, "end_date", $$v)},expression:"request.end_date"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Website (URL)","label-for":"website"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  If the Partnership has a dedicated website or URL that\n                  should be displayed on the Partnership's listing page,\n                  it may be included here. (optional)\n                ")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"website","type":"text","autocapitalize":"off","autocorrect":"off"},model:{value:(_vm.request.website),callback:function ($$v) {_vm.$set(_vm.request, "website", $$v)},expression:"request.website"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Type *","label-for":"type"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  Choose the type that best identifies your program.\n                ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"type","options":_vm.type_options,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.type),callback:function ($$v) {_vm.$set(_vm.request, "type", $$v)},expression:"request.type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Sector *","label-for":"sector"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  Choose the sector that best identifies your program.\n                ")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"sector","options":_vm.sector_options,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.sector),callback:function ($$v) {_vm.$set(_vm.request, "sector", $$v)},expression:"request.sector"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Funding Source(s)","label-for":"grant-funding"}},[_c('p',{staticClass:"label-help"},[_vm._v("\n                  List or description of Partnership funding source(s)\n                  to be shown on the Partnership's listing page. (optional)\n                ")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"grant-funding","rows":"5","max-rows":"5","no-resize":""},model:{value:(_vm.request.grant_funding),callback:function ($$v) {_vm.$set(_vm.request, "grant_funding", $$v)},expression:"request.grant_funding"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Partnership Contact")]),_vm._v(" "),_c('p',{staticClass:"label-help"},[_vm._v("\n              This is the main contact for the Partnership. This person will be contacted\n              if additional Partnership details are needed. This information will\n              be displayed on the Partnership's listing page.\n            ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Contact Name","label-for":"contact-name"}},[_c('b-form-input',{attrs:{"id":"contact-name","type":"text","autocorrect":"off"},model:{value:(_vm.request.contact_name),callback:function ($$v) {_vm.$set(_vm.request, "contact_name", $$v)},expression:"request.contact_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Contact Email *","label-for":"contact-email"}},[_c('b-form-input',{attrs:{"id":"contact-email","type":"email","autocapitalize":"off","autocorrect":"off","required":""},model:{value:(_vm.request.contact_email),callback:function ($$v) {_vm.$set(_vm.request, "contact_email", $$v)},expression:"request.contact_email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Contact Phone","label-for":"contact-phone"}},[_c('b-form-input',{attrs:{"id":"contact-phone","type":"tel"},model:{value:(_vm.request.contact_phone),callback:function ($$v) {_vm.$set(_vm.request, "contact_phone", $$v)},expression:"request.contact_phone"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"institutions"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h5',[_vm._v("Partner Institutions")]),_vm._v(" "),_c('p',{staticClass:"label-help"},[_vm._v("\n                The universities and other institutions that are part of the Partnership.\n              ")])])],1),_vm._v(" "),_c('div',{staticClass:"institution-group"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h6',[_c('strong',[_vm._v("U.S. Institution")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Institution *","label-for":"us-institution"}},[_c('b-input',{attrs:{"id":"us-institution","type":"text","autocorrect":"off","required":""},model:{value:(_vm.request.us_institution.name),callback:function ($$v) {_vm.$set(_vm.request.us_institution, "name", $$v)},expression:"request.us_institution.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Department/Unit","label-for":"us-institution-unit"}},[_c('b-input',{attrs:{"id":"us-institution-unit","type":"text","autocorrect":"off"},model:{value:(_vm.request.us_institution.unit),callback:function ($$v) {_vm.$set(_vm.request.us_institution, "unit", $$v)},expression:"request.us_institution.unit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"State/Province *","label-for":"us-institution-state-province"}},[_c('b-form-select',{attrs:{"id":"us-institution-state-province","options":_vm.usStateProvinceOptions,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.us_institution.state_province),callback:function ($$v) {_vm.$set(_vm.request.us_institution, "state_province", $$v)},expression:"request.us_institution.state_province"}})],1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.request.additional_institutions),function(additional_institution,index){return _c('div',{key:index,staticClass:"institution-group"},[(additional_institution.type === 'US')?_c('b-row',[_c('b-col',{attrs:{"md":"11"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Institution *","label-for":'additional-institution-' + (index + 1)}},[_c('b-input',{attrs:{"id":'additional-institution-' + (index + 1),"type":"text","autocorrect":"off","required":""},model:{value:(_vm.request.additional_institutions[index].name),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "name", $$v)},expression:"request.additional_institutions[index].name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Department/Unit","label-for":'additional-institution-unit' + (index + 1)}},[_c('b-input',{attrs:{"id":'additional-institution-unit' + (index + 1),"type":"text","autocorrect":"off"},model:{value:(_vm.request.additional_institutions[index].unit),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "unit", $$v)},expression:"request.additional_institutions[index].unit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"State/Province *","label-for":'additional-institution-state-province' + (index + 1)}},[_c('b-form-select',{attrs:{"id":'additional-institution-state-province' + (index + 1),"options":_vm.usStateProvinceOptions,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.additional_institutions[index].state_province),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "state_province", $$v)},expression:"request.additional_institutions[index].state_province"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-form-group',{attrs:{"label":"&nbsp;"}},[_c('b-btn',{attrs:{"block":"","variant":"secondary","type":"button"},on:{"click":function($event){_vm.removeAdditionalInstitution(index)}}},[_vm._v("\n                          -\n                      ")])],1)],1)],1):_vm._e()],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',[_vm._v("\n                Click "),_c('b-link',{attrs:{"variant":"link"},on:{"click":function($event){_vm.addAdditionalInstitution('US')}}},[_vm._v("here")]),_vm._v("\n                to add another U.S. institution\n              ")],1)])],1),_vm._v(" "),_c('div',{staticClass:"institution-group"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h6',[_c('strong',[_vm._v("Indian Institution")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Institution *","label-for":"indian-institution"}},[_c('b-input',{attrs:{"id":"indian-institution","type":"text","autocorrect":"off","required":""},model:{value:(_vm.request.indian_institution.name),callback:function ($$v) {_vm.$set(_vm.request.indian_institution, "name", $$v)},expression:"request.indian_institution.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Department/Unit","label-for":"indian-institution-unit"}},[_c('b-input',{attrs:{"id":"indian-institution-unit","type":"text","autocorrect":"off"},model:{value:(_vm.request.indian_institution.unit),callback:function ($$v) {_vm.$set(_vm.request.indian_institution, "unit", $$v)},expression:"request.indian_institution.unit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"State/Province *","label-for":"indian-institution-state-province"}},[_c('b-form-select',{attrs:{"id":"indian-institution-state-province","options":_vm.indiaStateProvinceOptions,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.indian_institution.state_province),callback:function ($$v) {_vm.$set(_vm.request.indian_institution, "state_province", $$v)},expression:"request.indian_institution.state_province"}})],1)],1)],1)],1)],2),_vm._v(" "),_vm._l((_vm.request.additional_institutions),function(additional_institution,index){return _c('div',{key:index,staticClass:"institution-group"},[(additional_institution.type === 'IN')?_c('b-row',[_c('b-col',{attrs:{"md":"11"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Institution *","label-for":'additional-institution-' + (index + 1)}},[_c('b-input',{attrs:{"id":'additional-institution-' + (index + 1),"type":"text","autocorrect":"off","required":""},model:{value:(_vm.request.additional_institutions[index].name),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "name", $$v)},expression:"request.additional_institutions[index].name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Department/Unit","label-for":'additional-institution-unit' + (index + 1)}},[_c('b-input',{attrs:{"id":'additional-institution-unit' + (index + 1),"type":"text","autocorrect":"off"},model:{value:(_vm.request.additional_institutions[index].unit),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "unit", $$v)},expression:"request.additional_institutions[index].unit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"State/Province *","label-for":'additional-institution-state-province' + (index + 1)}},[_c('b-form-select',{attrs:{"id":'additional-institution-state-province' + (index + 1),"options":_vm.indiaStateProvinceOptions,"text-field":"name","value-field":"name","required":""},model:{value:(_vm.request.additional_institutions[index].state_province),callback:function ($$v) {_vm.$set(_vm.request.additional_institutions[index], "state_province", $$v)},expression:"request.additional_institutions[index].state_province"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-form-group',{attrs:{"label":"&nbsp;"}},[_c('b-btn',{attrs:{"block":"","variant":"secondary","type":"button"},on:{"click":function($event){_vm.removeAdditionalInstitution(index)}}},[_vm._v("\n                        -\n                    ")])],1)],1)],1):_vm._e()],1)}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',[_vm._v("\n              Click "),_c('b-link',{attrs:{"variant":"link"},on:{"click":function($event){_vm.addAdditionalInstitution('IN')}}},[_vm._v("here")]),_vm._v("\n              to add another India institution\n            ")],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',[_c('b-form-checkbox',{attrs:{"id":"terms-agreement","required":""},model:{value:(_vm.request.terms_agreement),callback:function ($$v) {_vm.$set(_vm.request, "terms_agreement", $$v)},expression:"request.terms_agreement"}}),_vm._v(" "),_c('label',{attrs:{"for":"terms-agreement"}},[_vm._v("\n                I agree to allow the above information to be published.\n              ")])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',[_c('b-btn',{attrs:{"block":"","variant":"primary","type":"submit"}},[_vm._v("\n                  Submit\n              ")])],1)],1)],1)],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dPB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Maps__ = __webpack_require__("IsxP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    Maps: __WEBPACK_IMPORTED_MODULE_0__components_Maps__["a" /* default */]
  },
  computed: {
    baseUrl: function baseUrl() {
      return location.href;
    },
    usStateOptions: function usStateOptions() {
      return this.$root.stateProvinceOptions.US;
    },
    indiaProvinceOptions: function indiaProvinceOptions() {
      return this.$root.stateProvinceOptions.IN;
    }
  },
  data: function data() {
    return {
      usState: '',
      indiaProvince: '',
      sector: '',
      type: '',
      sector_options: [],
      type_options: [],
      loading: false,
      interval: undefined
    };
  },
  methods: {
    setInterval: function setInterval(mapsInterval) {
      this.interval = mapsInterval;
    },
    handleError: function handleError(error) {
      return error;
    },
    submitResults: function submitResults() {
      var queryString = '';
      queryString += this.order !== undefined && this.order !== '' ? '&order=' + this.order : '';
      queryString += this.usState !== undefined && this.usState !== '' ? '&us_state=' + this.usState : '';
      queryString += this.indiaProvince !== undefined || this.indiaProvince !== '' ? '&india_province=' + this.indiaProvince : '';
      queryString += this.sector !== 'N/A' && this.sector !== '' ? '&sector=' + this.sector : '';
      queryString += this.type !== 'N/A' && this.type !== '' ? '&type=' + this.type : '';

      this.$router.push({
        path: '/partnerships?search=' + queryString
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(function (response) {
        vm.sector_options = response.data.sort();
      });

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(function (response) {
        vm.type_options = response.data.sort();
      });
    });
  },

  beforeDestroy: function beforeDestroy() {
    if (this.interval !== undefined) {
      this.interval.stop();
    }
  }
});

/***/ }),

/***/ "djPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clean_query__ = __webpack_require__("HrFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clean_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clean_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__ = __webpack_require__("9dHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pagination__ = __webpack_require__("cMGX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Partnerships',
  components: {
    ErrorComponent: __WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_Pagination__["a" /* default */]
  },
  computed: {
    usStateProvinceOptions: function usStateProvinceOptions() {
      return this.$root.stateProvinceOptions.US;
    },
    indiaStateProvinceOptions: function indiaStateProvinceOptions() {
      return this.$root.stateProvinceOptions.IN;
    },
    typeOptions: function typeOptions() {
      return [];
    }
  },
  data: function data() {
    return {
      num_programs: 0,
      programs: [],
      page_programs: [],
      search: undefined,
      order: undefined,
      usState: undefined,
      indiaProvince: undefined,
      sector: undefined,
      type: undefined,
      page: undefined,
      order_options: [{ value: 'asc', text: 'A-Z' }, { value: 'desc', text: 'Z-A' }],
      sector_options: [],
      type_options: [],
      loading: true
    };
  },
  methods: {
    changePage: function changePage(page) {
      page = this.programs[page - 1] !== undefined ? page : 1;
      this.page = page;
      this.page_programs = this.programs[page - 1];

      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.$router.replace({
        path: query !== '' ? '/partnerships?' + query : '/partnerships'
      });
    },
    getResults: function getResults() {
      var _this = this;

      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.axios({
        method: 'get',
        url: query !== '' ? '/program/search?' + query : '/program/search'
      }).then(function (response) {
        _this.programs = response.data.programs;
        _this.num_programs = response.data.num_programs;
        _this.changePage(_this.page);
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        _this.handleError(error);
      });
    },
    goToPartnership: function goToPartnership(slug) {
      this.$router.push({
        path: '/partnership/' + slug
      });
    },
    handleError: function handleError(error) {
      return error;
    },
    updateSelect: function updateSelect() {
      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.$router.replace({
        path: query !== '' ? '/partnerships?' + query : '/partnerships'
      });

      this.getResults();
    }
  },
  watch: {
    order: function order() {
      this.updateSelect();
    },
    usState: function usState() {
      this.updateSelect();
    },
    indiaProvince: function indiaProvince() {
      this.updateSelect();
    },
    sector: function sector() {
      this.updateSelect();
    },
    type: function type() {
      this.updateSelect();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var loadResults = function loadResults() {
        vm.$root.setTitle('Partnerships');
        vm.search = to.query.search !== undefined ? to.query.search : undefined;
        vm.order = to.query.order !== undefined ? to.query.order : undefined;
        vm.usState = to.query.us_state !== undefined ? to.query.us_state : undefined;
        vm.indiaProvince = to.query.india_province !== undefined ? to.query.india_province : undefined;
        vm.sector = to.query.sector !== undefined ? to.query.sector : undefined;
        vm.type = to.query.type !== undefined ? to.query.type : undefined;
        vm.page = to.query.page !== undefined ? Number(to.query.page) : undefined;
        vm.getResults();
      };

      loadResults();
      vm.$root.$on('refreshResults', loadResults);

      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(function (response) {
        vm.sector_options = response.data.sort();
      });

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(function (response) {
        vm.type_options = response.data.sort();
      });
    });
  }
});

/***/ }),

/***/ "eFqj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "en7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("nfpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa439946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("kjng");
function injectStyle (ssrContext) {
  __webpack_require__("XT5Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa439946"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa439946_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hgB+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kjng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about"}},[_c('b-row',{staticClass:"about-row"},[_c('b-col',{attrs:{"md":"12"}},[_c('h1',[_vm._v("About Partnership 2020")]),_vm._v(" "),_c('p',[_vm._v("\n        The Partnership 2020: Leveraging US-India Cooperation in Higher Education to Harness\n        Economic Opportunities and Innovation project goal is to strengthen the strategic\n        partnership between the US and India through collaboration in higher education,\n        research on key issue areas, related economic growth, and people-to-people linkages.\n        This is a two-year project with most of the activities taking place in 2019 and 2020.\n        "),_c('a',{attrs:{"href":_vm.uno_is_url + '/project-team.php',"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Our Project team")]),_vm._v("\n        is experienced in US-India relations. Work products will include a "),_c('a',{attrs:{"href":"/"}},[_vm._v("searchable database")]),_vm._v("\n        of US-India university partnerships,\n        "),_c('a',{attrs:{"href":_vm.uno_is_url + '/policy-recommendations.php',"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("policy recommendations")]),_vm._v("\n        on enhancing US-India partnerships,\n        "),_c('a',{attrs:{"href":_vm.uno_is_url + '/practical-guide-to-partnerships.php',"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("practical guide to successful partnerships")]),_vm._v(",\n        and "),_c('a',{attrs:{"href":_vm.uno_is_url + '/request-for-proposals.php',"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("grants")]),_vm._v(" to eligible US universities\n        to enhance current or start new partnerships with Indian universities. Partnership 2020 is a collaborative agreement between\n        University of Nebraska at Omaha (UNO) and US Department of State (DOS) with Center for Strategic and International Studies\n        (CSIS) playing a key advisory role.\n      ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("For more information about the US-India Partnership 2020 initiative, request for proposal instructions for grants to US universities, and access to other resources, please visit: ")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","id":"wrap","href":_vm.uno_is_url + '/index.php'}},[_vm._v(_vm._s(_vm.uno_is_url)+"/index.php")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{attrs:{"id":"additionalInfo"}},[_c('b-col',[_c('h3',[_vm._v("Additional Information")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/index.php'}},[_vm._v("Project Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/request-for-proposals.php'}},[_vm._v("Request for Proposals")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/project-team.php'}},[_vm._v("Project Team")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/practical-guide-to-partnerships.php'}},[_vm._v("Practical Guide to Successful University Partnerships (Coming soon)")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.uno_is_url + '/policy-recommendations.php'}},[_vm._v("Policy Recommendations (Coming soon)")])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-component"}},[_c('b-row',{staticClass:"error-row"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"12"}},[_vm._t("title")],2)],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"12"}},[_vm._t("subtitle")],2)],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{attrs:{"id":"goHome","variant":"primary","href":"/"}},[_vm._v("\n              Go Home\n          ")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"12"}},[_vm._t("message")],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{attrs:{"id":"goForm","variant":"primary","href":"/request-listing"}},[_vm._v("\n                Add a New Partnership\n            ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nHzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"partnerships"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[(!_vm.loading)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.num_programs)+" partnerships "+_vm._s((_vm.search === '' || _vm.search === undefined) ? '' :  'for "' + _vm.search + '"'))])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('h1',[_vm._v("Loading...")]):_vm._e()])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{attrs:{"id":"partnership-filter"}},[_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',{attrs:{"label":"Order","label-for":"order"}},[_c('b-form-select',{attrs:{"id":"order","options":_vm.order_options},model:{value:(_vm.order),callback:function ($$v) {_vm.order=$$v},expression:"order"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"U.S. States","label-for":"us-state"}},[_c('b-form-select',{attrs:{"id":"us-state","options":_vm.usStateProvinceOptions,"text-field":"name","value-field":"name"},model:{value:(_vm.usState),callback:function ($$v) {_vm.usState=$$v},expression:"usState"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All U.S. States")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"label":"India States/Provinces","label-for":"india-province"}},[_c('b-form-select',{attrs:{"id":"india-province","options":_vm.indiaStateProvinceOptions,"text-field":"name","value-field":"name"},model:{value:(_vm.indiaProvince),callback:function ($$v) {_vm.indiaProvince=$$v},expression:"indiaProvince"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All India States/Provinces")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',{attrs:{"label":"Sector","label-for":"sector"}},[_c('b-form-select',{attrs:{"id":"sector","options":_vm.sector_options,"text-field":"namr","value-field":"name"},model:{value:(_vm.sector),callback:function ($$v) {_vm.sector=$$v},expression:"sector"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Sectors")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',{attrs:{"label":"Type","label-for":"type"}},[_c('b-form-select',{attrs:{"id":"type","options":_vm.type_options,"text-field":"name","value-field":"name"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Types")])])],2)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"no-results"},[_c('b-row',{staticClass:"no-results-text"},[_c('h4',{staticClass:"mr-auto ml-auto"},[_vm._v("Loading Content")])])],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"results-block"}},_vm._l((_vm.page_programs),function(program,index){return (!_vm.loading && _vm.programs.length > 0)?_c('div',{staticClass:"results-content"},[_c('b-row',{staticClass:"results-row",on:{"click":function($event){_vm.goToPartnership(program.slug)}}},[_c('b-col',{attrs:{"md":"12"}},[_c('h2',[_vm._v(_vm._s(program.name))]),_vm._v(" "),_c('strong',[_vm._v("Sector:")]),_vm._v(" "+_vm._s(program.sector)+"\n          "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Type:")]),_vm._v(" "+_vm._s(program.type)+"\n          "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("States/Provinces:")]),_vm._v(" "),_vm._l((program.institutions),function(institution,index){return _c('span',[_vm._v("\n            "+_vm._s((index != (program.institutions.length - 1)) ? institution.state_province + ',' : institution.state_province)+"\n          ")])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Institutions:")]),_vm._v(" "),_vm._l((program.institutions),function(institution,index){return _c('span',[_vm._v("\n            "+_vm._s((index != (program.institutions.length - 1)) ? institution.name + ',' : institution.name)+"\n          ")])})],2)],1),_vm._v(" "),_c('hr',{class:(index !== (_vm.page_programs.length - 1)) ? 'separator' : 'separator-lg'})],1):_vm._e()}),0),_vm._v(" "),(!_vm.loading && _vm.programs.length <= 0)?_c('error-component',[_c('template',{slot:"title"},[_c('h4',[_vm._v("No Partnerships Found! Try a different search term or adjust the filter dropdowns.")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('h4',[_vm._v("Missing a Partnership? Add a Partnership by following the link below.")])])],2):_vm._e(),_vm._v(" "),(_vm.programs.length > 1)?_c('pagination',{attrs:{"click-handler":_vm.changePage,"page":_vm.page,"page-count":_vm.programs.length}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nfpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',
  data: function data() {
    return {
      uno_is_url: 'https://www.unomaha.edu/international-studies-and-programs/engagement/partnership2020'
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$root.setTitle('About');
    });
  }
});

/***/ }),

/***/ "obWe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pi7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"maps"}},[_c('b-container',{staticClass:"map-container"},[_vm._t("title-rows"),_vm._v(" "),_c('b-row',[(this.$route.name === 'MapResults')?_c('b-col',{staticClass:"back-btn-col",attrs:{"md":"1"}},[_c('b-link',{staticClass:"back-btn",attrs:{"to":"/"}})],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":(this.$route.name === 'MapResults') ? 10 : 12}},[_c('div',{attrs:{"id":"us-india-map"}},[_c('svg',{ref:"map",attrs:{"id":"map","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1081.44 480.87","width":"1100px","height":"500px"}},[_c('g',{attrs:{"id":"us"}},[_c('g',{staticClass:"state us-state",attrs:{"id":"washington"}},[_c('path',{attrs:{"d":"M48.12,84.8l-1.6-3.1-3-.5-.3-1.7-1.8-.4-2.1-.4-1.3.7-1.7-2.1.2-2.1,2-.2,1.2-2.9-1.9-.8.1-2.7,3.2-.4-2-2L38,61.1l.4-2.1V53.3L37.12,51l1.7-6.8,1.5.4L42,46.7l2,1.9,2.3,1.4,3.3,1.5,2.2.4,2.1,1.1,2.5.7,1.7-.1V51.9l.9-.8,1.5-.9.2.8.2,1.3-1.5.2-.2,1.5,1.3,1.1.8,1.7.4,1.4,1.1-.1.1-.9-.7-.9-.4-2.3.6-1.3L62,51.5V49.7l1.3-2.6-.8-1.9-1.8-3.5.2-.6,1-.6,3.2,1.1,7,2,6.2,1.4,14.5,4.1,16.6,4.1,10.8,2.5-3.5,12.7-3.3,15-2.5,11.7-.3,6.7-9.3-2.7-11.1-2.5-10.5.1-.8-1.1-4.1,1.5L72,96.8l-1.9-1.3-1.2.4-3-.2-1.2-.9-3.8-1.3-.9-.1-3.5-1-1.4,1.2L51,93.4l-3.3-2.5Zm7-39.9,1.4-.1.4,1L58,44.6h1.6l.6,1.1-1.1,1.2.4.6L59,48.9l-1,.3s-.7.1-.7-.1a11.59,11.59,0,0,1,1.1-1.9l-1.2-.4L57,47.9l-.5.4-1.1-1.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"78.75","cy":"70.68","r":"0.48"}}),_vm._v(" "),_c('title',[_vm._v("Washington")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"oregon"}},[_c('path',{attrs:{"d":"M43.12,150.5l20.4,5.2,19.9,4.7,12.3,2.7,6.4-25.3.9-3.2,1.7-4-.5-.9-1.8.1-.9-1.3.4-1.1.3-2.4,3.4-4.1,1.4-.7.7-.6.5-2,.6-.8,2.8-4.1,2.7-2.9.1-2.4-2.5-1.8-.9-3.3-9.5-2.7-11.1-2.5-10.7.3-.8-.9-3.7,1.3-3.3-.4-1.7-1.2-.9.4-3.4-.2-1.4-1L61,94.1l-.8-.1L57,93.1l-1.3,1.1-4.6-.1-3.8-2.7.1-6.7L46,82.2l-3-.4-.5-1.8-1.7-.5L36.62,81l-1.7,4.7-2.4,7.2-2.3,4.7-3.6,10.1-4.7,9.8L16,126.6l-1.4,2.1-.6,6.2-.9,4.3,2,2.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"63.22","cy":"121.85","r":"0.55"}}),_vm._v(" "),_c('title',[_vm._v("Oregon")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"california"}},[_c('path',{attrs:{"d":"M83.92,314.3l-14.2-2-7.2-1.1-.4-1.3v-6.8l-.2-2.3-1.9-3-.6-1.7-2.8-3-2.1-3.4-2-.1-2.3-.6-.2-.7,1.1-.4-.4-2.3-1.1-1.5-3.5-.6-2.8-1.5-.8-1.7-1.9-3.5-2.1-2.2h-2.1l-2.8-1.5-3.3-1.3-3-.4-1.7-2L26,268l1.3-5.1.6-1.4v-1.7l-1.2-.7-.4-2.1-1.1-1.9-2.5-4.2-.9-2.2-1.1-3.4-1.2-3.8-2.3-3.2-.4-2.1.6-2.8h.8l1.5-1.2.8-2.6-.7-2-2-.4-1.4-1.9-1.5-2.7-.1-5.9.4-1.4.4-1.7.4-1.7-4.1-4.6v-1.5l.2-.4.2-2.3-.9-2.9-1.7-3.5-2-3.3-1.3-2.7.7-2.7.4-4.2,1.3-2.2.2-4.7-.8-2.6L7,171.2l-2-3,.6-2.3,1.1-3,1.3-.6.2-.8,2.2-1.9,3.8-8.5.1-5.3,1.2-3.5,27.9,8.5,18.5,4.8-5.8,22.6L49.82,202l9.1,13.9,30.4,44.9,12.4,18.9-.3,2.2,2,3.8.8,3.9.7,1.1.5.4-.1,1-1,.7-2.5,1.2-1.4,1.5-1.2,2.8-.4,3.4-1.9,1.8-1.7.8-.1,4.5-.4,1.4.7,1.2,2.2.2-.3,1.2-1,1.4-2.8.4Zm-53.3-35.2.9,1.1-.1.9-2.3-.1-.5-.9-.4-1.1Zm1.3,0,.9-.4,2.6,1.5,2.2.9-.7.4-3.3-.1-1-1.3Zm15,14.1,1.3,1.7.6.7,1.1.4.4-1.1-.7-1.3-2-1.4-.8.1.1.9Zm-1,6.4,1.3,2.3.9,1.4-1.1.1-.9-.9a5.7,5.7,0,0,1-.5-1.4v-1.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"40.27","cy":"232","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("California")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"nevada"}},[_c('path',{attrs:{"d":"M83.32,161.1l27.9,6.1L130,171l-7.7,38.3-3.9,21.5L116,242l-1.5,8-1.9,11.9-1.2,2.2-1.2-.1-.9-1.9-2-.4-.9-.8-1.3.1-.7.6-1.3.9-.2,5.3-.2,1.1-.4,9-.8,1.3-12-18.4L59.22,216l-9-13.7,6.2-23.5,5.8-22.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"90.62","cy":"199.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Nevada")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"arizona"}},[_c('path',{attrs:{"d":"M91.92,317l-.2,1.1.4.7,13.7,7.7,8.7,5.5,10.6,6.2,12.1,7.2,8.9,1.7,18.4,2,4.3-28.5,5.1-38.3,3.2-22.4-17.8-2.6-43.8-8-.1.8-1.9,11.9-1.5,2.7-2-.1-.9-1.9-1.9-.3-.9-.8-.8.1-1.5,1.2-.2,4.9-.2,1.1-.4,9-1.1,1.7-.3,2.4,2,3.6.8,4,.5.8.8.7-.3,1.7-1.2.9-2.5,1.2-1.2,1.3-1.2,2.6-.4,3.5-2.2,2.1-1.4.7-.1,4.2-.4,1.2.4.6,2.8.3-.7,2.2-1.2,1.7-2.7.3Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"136.27","cy":"294.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Arizona")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"utah"}},[_c('path',{attrs:{"d":"M159.22,256.6l17.8,2.6,1.4-9.9,5.1-36.4,1.7-15.9L162,194.5l1.6-9.5,1.3-7.7-25-4.4-9-1.8-7.7,38.1-3.9,21.7-2.4,11.1-1.2,6.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"150.97","cy":"215.65","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Utah")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"idaho"}},[_c('path',{attrs:{"d":"M120.92,55.8l-3.5,12.6-3.2,15.1-2.5,11.7-.3,7,.9,3.2,2.5,2-.1,2.8-2.8,3.2-3.3,4.8-.7,2.1-.9.8-1.3.6-3.1,3.8-.3,2.2-.3.8.4.7,1.9-.1.8,1.7-1.7,4.2-.9,3-6.4,25.4,15,3.3,28.5,5.7,25.2,4.3,3.5-21.1,2.7-17.4-2-1.7-.3-1.9-.6-.8-1.5.7-.5,1.9-2.3.4-2.8-1.2-2.7.1-1.8.5-2.5-1.1-1.7.1-1.7,1.4-1.4-.8-.5-2.9.5-2.1-1.8-2.1-2.4-1.9-2-9.5-.1-3.4-.2-.1-.1.3-3.7,2.5-1.2-.1-2.1-2.5-.1-2.2,5.1-12.4-.3-1.4-2.5-.8-.4-.9-1.9-2.5-3.3-7.4-2.3-1.1-1.4-3.5.9-3.3-2.3-5.5,3.2-15.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"128.31","cy":"139.79","r":"0.59"}}),_vm._v(" "),_c('title',[_vm._v("Idaho")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"montana"}},[_c('path',{attrs:{"d":"M254.92,87l-3.8,41.2-.9,11-42.6-4.8-35.3-5.1-1,8.1-1.4-1.2-.3-1.8-.9-1.4-2.4,1.1-.5,1.8-1.7.2-2.7-1.2-3,.1-1.7.5-2.3-1.1-2.2.1-1.5,1.4-.7-.4-.5-2.5.5-2.3-2-2.3-2.4-1.8-1.8-9.1-.1-3.8-1.2-.6-.4.7-3.3,2.3-.9-.1-1.7-2-.1-2,5.1-12.4-.4-2-2.5-.8-.3-.7-2-2.5-3.3-7.5-2.3-1.2-1.3-3.1.9-3.3-2.3-5.5,3.2-15.4,23.5,5,13.3,2.5,23.2,3.8,21.2,2.9,21.1,2.5,22.3,2.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"192.12","cy":"98.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Montana")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"north-dakota"}},[_c('path',{attrs:{"d":"M334.22,127.1l-.3-4.5-1.3-5.3-1.3-9.8-.4-7-1.4-2.3-1.2-3.8V86.9l.4-2.8-1.3-4-20.6-.3-13.4-.4-19.2-.9-18.1-1.7-.7,10.4L252,123.9l41,2.8,41,1.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"293.92","cy":"100.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("North Dakota")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"south-dakota"}},[_c('path',{attrs:{"d":"M334.22,166.5l-.7,2.3.3,2.2,1.9,1.4-.9,3.9-1.3,3,1.1,2.4.5.8-.9.1-.5-1.2-.4-1.4-2.4-1.3-3.5-1.1-1.8-.9-2.1.1-2.8.3-2.7.9-3.8-2.7-2-1.7-7.9.6-29.9-1.7-25.6-1.6,1.1-17.9,2-24.5.3-3.6,41,2.8,41,1.2v2l-.9,1.1-1.4,1.1-.1,1.6.8,1.6,3,2.5.4,2v25.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"292.92","cy":"150.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("South Dakota")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"nebraska"}},[_c('path',{attrs:{"d":"M333.62,183.3l-.7-1.7-.4-1.2-2.1-1.2-3.5-1.1-1.6-.9-1.9.1-2.7.3-3,.9-4.3-3-1.6-1.4-7.7.4-29.9-1.7-25.6-1.6-3.1,31.5,23.8,2.4-1,15.3,15.7.7,29.2.9,31.6.4h3.3l-1.6-2.2-1.9-2.8.1-1.7-1-2-1.4-3.8-.3-4.8-1-3-.4-3.6-1.7-2.7-.7-3.4-2-5.7-.7-3.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"299.52","cy":"196.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Nebraska")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"kansas"}},[_c('path',{attrs:{"d":"M344.92,223.1l-31.6-.4-29.2-.9-15.7-.7-3.1,46.7,17.6.7,32.2,1.5,33.4.4,9.1-.2.5-25.2-.9-8-1.8-1.4-1.7-2.2-1.7-2.6.4-2.2,1.2-1v-1.4l-.6-.5-1.9-.1-2.5-2.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"312.22","cy":"246.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Kansas")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"oklahoma"}},[_c('path',{attrs:{"d":"M291.52,277.5l-1.3,17.5-.7,13,.1,1.2,2.9,2.6,1.2.7h.7l.7-1.5,1.1,1.4,1.2.1.2-.1.1-.8,2,1-.3,2.5,2.7.4,1.8.7,3,.4,1.7,1.2,1.8-1.2,2.5.5,1.6,2.2.9.1v1.7l1.5.5,1.8-1.5,1.3.4,2,.1.5,1.7,3.2,1.3,1.2-.2,1.4-3h.9l.8,1.5,3,.6,2.5.9,2.2.6,1.2-.5.5-2h3.3l1.4.7,2-1.4h1l.4,1h2.6l1.4-1.3,1.7.4,1.2,1.6,2.2,1.2,2.5.7,1.4.9-.2-27.1-1-7.9-.1-6.2-1.1-4.8-.4-4.9.1-3.1-9.1.2-33.4-.4-32.2-1.5-29.9-1.3-.3,7.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"323.77","cy":"292.8","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Oklahoma")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"texas"}},[_c('path',{attrs:{"d":"M198.42,342.9l26.6,2.6,21.2,1.4,5.3-70.4,39.2,1.7-1.2,16.8-.7,13,.1,1.4,3.2,3,1.4.8h1.3l.4-.9.5.7,1.7.1.8-.4v-.1l.7.4-.3,2.7,3.3.5,1.7.7,3,.5,1.9,1.3,2-1.4,2,.4,1.6,2.2.6.1v1.5l2.4.8,1.8-1.5,1.1.4,1.5.1.4,1.5,3.8,1.4,1.7-.4,1.4-2.9h.1l.8,1.4,3.3.7,2.5.9,2.3.7,1.7-.9.5-1.7h2.6l1.5.7,2.2-1.4h.3l.4,1h3.4l1.4-1.3.9.3,1.2,1.5,2.4,1.4,2.5.7,1.8,1,2,1.4,2.2-.9,1.5.6.5,14.5.5,6.9.4,3,1.9,3.2.7,3.3,3,4.3.2,2.2.4.6-.5,5.6-2.1,3.5.9,1.9-.4,1.7-.6,5.2-.9,2.2.2,3-4,1.2-7.2,3.3-.7,1.4-1.9,1.4-1.5,1.1-.9.6-4.1,3.8-2,1.5-3.8,2.3-4.1,1.7-4.6,2.5-1.3,1.1-4.2,2.6-2.5.4-2.8,4-2.9.2-.7,1.4L323,420l-1.1,4-.9,3.3-.8,2.8-.6,3.3.6,1.7,1.3,5.1.7,4.4,1.3,2-.7,1.1-2.2,1.4-4.1-2.8-4-.8-.9.4-2.3-.4-3-2.2-3.8-.8L297,440l-1.5-2.8-.9-4.7-2.3-1.4-.4-1.7.4-.4.2-2.5-.9-.4-.4-.7.9-3.2-1.2-1.7-2.3-.9-2.5-3.2-2.6-4.8-3-1.9.1-1.4-3.8-8.9-.6-3-1.3-1.4-.1-1.1-4.3-3.8-1.9-2.2v-.8l-1.9-1.5-4.9-.8-5.3-.4-2.4-2.3-3.3,1.3-2.6,1.1-1.7,2.3-.7,2.7-3.2,4.4-1.7,1.7-1.9-.7-1.3-.8-1.4-.4-2.8-1.7v-.4l-1.3-1.4-3.8-1.5-5.3-5.6-1.7-3.4v-5.9l-2.3-4.7-.4-2-1.2-.7-.8-1.5-3.6-1.5-.9-1.2-5.1-5.7-.9-2.3-3.4-1.7-1.1-3.2-1.9-2.1-1.2-.4Zm125.8,102.2-.4-5.1-2-5.2-.4-5.1,1.1-5.9,2.4-5,2.5-3.9,2.3-2.6.4.1-3.5,4.8-3.2,4.7-1.4,4.8-.2,3.8.7,4.4,1.9,5.2.4,3.8.1,1.1Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"299.77","cy":"360","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Texas")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"wyoming"}},[_c('path',{attrs:{"d":"M249.12,152.7,248,171.1l-3.2,31.7-2-.2-60.1-6.6-20.2-2.2,1.4-8.7,5-29.5,2.7-17.5.9-8.1,34.7,5.1,42.6,4.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"206.67","cy":"166.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Wyoming")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"colorado"}},[_c('path',{attrs:{"d":"M268.72,205.8l-25.9-2.5-57.1-6.2-1.6,16L179,249.4l-1.4,9.9,24.5,2.8,27,3.2,25,2.2,10.3.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"223.67","cy":"233","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Colorado")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"new-mexico"}},[_c('path',{attrs:{"d":"M189.32,345.7l-12.1-1.9-.9,6.9-11.4-1.4,4.3-28.6,5.1-38.4,3.2-22.3,24.5,2.8,26.9,3.2,23,2-.2,7.8-1-.1-5.3,70.4-20.5-1.3-27.4-2.7.5,4.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"210.02","cy":"303.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("New Mexico")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"alaska"}},[_c('path',{attrs:{"d":"M110.62,363.1l-.2,61.6,1.2.7,2.2.1,1.1-.8h1.9l.1,2.1,5.1,4.9.4,1.9,2.5-1.4.4-.1.2-2.2,1.1-1.2.8-.1,1.4-1.1L131,429l.4,2.1,1.4.8.8,1.7,2.8,1.3,2.5,4.3,2,2.8,1.7,2,1.1,2.7,3.6,1.3,3.8,1.5.7,3.2.4,2.2-.7,2.5-1.3,1.7-1.2-.6-1.1-2.2-2-1.1-1.3-.8-.6.6,1.1,2,.1,2.7-.8.4-1.4-1.4-1.5-.9.4,1.2.9,1.3-.6.6a1.54,1.54,0,0,1-.9-.7,12.65,12.65,0,0,1-1.5-2.5l-.7-1.7s-.2.9-.7.7a3.1,3.1,0,0,1-.9-1.1l1.3-1.4-1.1-1.1v-3.6h-.6l-.6,2.5-.8.4-.7-2.7-.4-2.7-.6-.4.2,4.1v.8l-1.1-.9-2.6-4.3-1.5-.4-.4-2.7-1.2-2.1-1.2-.8v-1.7l1.5-.9-.4-.2-1.9.4-2.5-1.7-1.9-2.1-3.5-1.9-2.9-1.9.9-2.3v-1.3l-1.3,1.2-2.1.8-2.7-.8-4.1-1.7h-4l-.4.4-4.7-2.8-1.5-.2-2-4.2-2.6.2-2.6,1.1.4,3.3.8-2.1.7.2-1.1,3.2,2.3-2,.4,1.2-2.8,3.2-.9-.2-.4-1.4-.9-.6-.9.8-2-1.3-2.2,1.5-1.3,1.5-2.5,1.5-3.4-.1-.4-1.5,2.7-.4v-.9l-1.7-.4.7-1.7,1.7-2.8v-1.3l.1-.6,3.2-1.7.7.9h2l-.9-1.9-2.7-.2-3.6,2-1.7,2.5-1.3,1.9-.8,1.7-3,1.1-2.2,1.9-.2,1.2,1.7.7.6,1.5-2,2.3-4.7,3-5.6,3-1.5.8-3.8.8-3.8,1.7,1.3.9-1.1,1.1-.4.8-2-.7-2.3.1-.6,1.7h-.7l.2-1.7-2.6.9-2.1.7-2.5-.9-2.1,1.4H30l-1.5.9-1.2.6-1.5-.2-1.9-.8-1.7.4-.7.7-1.2-.8v-1.4l2.2-.9,4.6.4,3.2-1.2,1.5-1.5,2.1-.4,1.3-.6,2,.1,1.2.9.7-.2,1.7-2,2.2-.7,2.5-.4.9-.2.4.4h.7l.9-2.7,2.9-1.1,1.4-2.7,1.7-3.3,1.2-1.1.2-1.9-1.2.9-2.5.4-.4-1.7-.9-.2-.7.7-.1,2.1-1.1-.1-1.1-4.2-.9.9-.8-.4-.2-1.4-2.9.1-1.5.8-1.9-.2,1.1-1.1.4-1.9-.4-1.4,1.1-.7.9-.1-.4-1.3v-3.1l-.7-.7-.6,1.1h-4.2l-1.1-.9-.4-2.8-1.5-2.6v-.7l1.5-.6.1-1.5.8-.8-.6-.4-.9.4-.8-2,.7-3.6,3.3-2.3,1.9-1.2,1.4-2.7,2-.9,1.9.8.2,1.7,1.4-.2,2.3-1.7,1.2.4.7.4h1.2l1.7-.9.6-3.2s.2-2.1.7-2.5a2.34,2.34,0,0,0,.7-.7l-.8-1.4-1.9.6-2.3.6-1.4-.4-2.6-1.3-3.6-.1-2.6-2.7.4-2.8.4-1.7-1.5-1.3-1.4-2.7.4-.6,4.9-.4h1.5l.7.7h.4l-.1-1.2,2.8-.4,1.9.2,1.1.8L51,375l-.4,1.1,2,1.2,3.6,1.3,1.3-.7-1.7-3.2-.7-2.3.7-.6-2.5-1.4-.5-.7.4-1.2-.6-2.8-2.1-3.4-1.7-3,2.1-1.4h2.3l1.3.4,3-.1,2.7-2.6.8-2.2,2.7-1.7,1.2.7,2-.4,2.7-1.5.8-.1.7.6,3.3-.1,2-2.2h.8l2.6,1.7,1.4,1.5-.4.8.4.8,1.2-1.2,2.8.2.2,2.7,1.4,1.1,5.1.4,4.6,3,1.1-.7,3.8,1.9,1.5-.4,1.4-.6,3.5,1.4Zm-83,20.9,1.5,3.8-.1.7-2.1-.2-1.3-2.9-1.3-1.1h-1.7l-.1-1.9,1.2-1.6.8,1.7,1.1,1.1Zm-1.8,24.2,2.7.6,2.7.7.6.7-1.2,2.7-2.2-.1-2.5-2.6Zm-15-10.2.8,1.9.8,1.2-.8.6-1.5-2.2v-1.4ZM1,450.8l2.5-1.7,2.5-.7,1.9.2.4,1.2,1.4.4,1.4-1.4-.2-1.2,2-.4,2.1,1.9-.8,1.3-3.2.8-2-.4-2.7-.9L3.12,451l-1.2.2Zm35.2-3.3,1.2,1.4,1.5-1.2-1.1-.9Zm2.1,2.2.8-1.7,1.5.2-.6,1.4Zm17-1.5,1.1,1.3.7-.8-.6-1.4Zm6.4-9,.8,4.2,2.1.6,3.6-2.1,3.2-1.9-1.2-1.7.4-1.7-1.5.9-2.1-.6,1.2-.8,1.4.6,2.8-1.3.4-1.1-1.7-.6.6-1.4-2,1.4-3.4,2.6-3.5,2.1ZM92.22,425l1.7-1.1-.7-1.3-1.3.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"79.77","cy":"389","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Alaska")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"hawaii"}},[_c('path',{attrs:{"d":"M162.62,410.5l1.4-2.6,1.7-.2.2.6-1.5,2.2Zm7.4-2.6,4.4,1.9,1.5-.2,1.2-2.8-.4-2.5-3-.4-2.9,1.3Zm22.1,7.2,2.7,4,1.7-.2.8-.4,1.1.9,2.7-.1.7-1.1-2.1-1.3-1.4-2.7-1.5-2.6-4.2,2.1Zm14.6,6.4.9-1.4,3.4.7.4-.4,4.4.4-.2.9-1.9,1.1-3.2-.2Zm3.8,3.7,1.4,2.8,2.2-.8.2-1.2-1.2-1.5-2.7-.2Zm5-.9,1.7-2.1,3.4,1.7,3.2.8,3.2,2v1.4l-2.6,1.3-3.5.7-1.7-1.1Zm12,11.3,1.2-.9,2.5,1.2,5.5,2.6,2.5,1.5,1.2,1.7,1.4,3.2,2.9,1.9-.4.9-2.8,2.3-3,1.1-1.1-.4-2.2,1.3-1.7,2.3-1.7,2.1-1.3-.1-2.6-1.9-.2-3.3.4-1.7-1.2-4.1-1.5-1.3-.1-1.9,1.7-.7,1.5-2.2.4-.7-1.2-1.3Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"232.27","cy":"442.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Hawaii")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"minnesota"}},[_c('path',{attrs:{"d":"M329.52,84.1l-.4,2.8v7.4l1.2,3.6,1.4,2.4.4,7.2,1.3,9.7,1.3,5.3.3,4.6v3.8l-1.2,1.3-1.3.9v1.1l.7,1.2,3,2.5.5,2.3v25.9l43.5-.4,15.3-.5-.4-4.3-1.3-1.5-5.2-3.3-2.6-3.8-2.5-.7-1.4-2h-2.3l-2.5-2.7-.4-5.1.1-2.8,1.1-2.2-.5-2-2-2.2,1.6-4.4,3.9-2.9.9-1-.1-5.8.1-2.2,1.9-2.2,2.7-2.1.9-.1,3.3-3.6,1.3-.6,1.7-2.8,1.7-2.6,2.2-1.9,3.5-1.4,6.7-3,2.8-1.3.4-1.7-3.2.3-.5.8H407l-1.3-2.2-6.4.2-.7.6h-.7l-.4-.9-.6-1.3-1.9.4-2.3,2.3-1.2.6h-2.2l-1.9-.7V91.7l-.9-.1-.4.4-1.9-.9-.4-2.1-1.1.4-.4.7-1.7-.4-3.8-1.7L374,86.1h-2.1l-.9-.7-1.7.4-.8.8-.2.9h-3.5V86l-4.6-.2-.3-1.4h-3.5l-1.2-1.2-1.1-4.4-.6-4-1.4-.6-1.7-.4-.4.1-.2,5.9H328Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"358.62","cy":"123.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Minnesota")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"iowa"}},[_c('path',{attrs:{"d":"M396.12,168.3l1.5,1.5.2.5-1.4,2.2.2,2.9,1.9,3,2.2,1.2,1.7.2.7,1.3.1,1.7,1.8.7.7.8.4,1.2,2.7,2.4.4,1.4-.5,2.2-1.2,2.7-.4,1.7-1.5,1.2-1.2.4-4.1,1.1-1.2,3.5.6,1.3,1.2,1.1-.1,2.5-1.4,1-.5,1.3V211l-1,.3-1.2,1-.4,1.2.3,1.2-.9.7-1.7-2-1-2-6,.6-7.2.4-35.5.9-1.2-3.1-.3-4.8-1-3-.5-3.8-1.6-2.7-.7-3.3-2-5.6-.8-4-1-1.4-.9-2.1,1.2-2.7.9-4.4-2-1.6-.2-1.7.5-1.7,1.3-.2,44.1-.4,15.3-.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"370.07","cy":"189.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Iowa")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"missouri"}},[_c('path',{attrs:{"d":"M422.22,280.2l.4-4.3,3-2.5,1.4-.7v-2.1l.5-1.2-.8-1.2-1.7.2-1.5-1.8-1.2-3.3.7-1.9-1.4-2.3-1.3-3.3-3.3-.5-4.9-4-1.6-3,.6-2.4,1.6-4.3.4-2.2-1.4-.7-5-.4-.8-1.4v-3l-3.8-2.5-5.2-5.6-1.7-5.3-.4-3,.5-1.7-1.9-2.2-.9-1.7-5.6.6-7.2.4-35.2.9.9,1.9-.1,1.6,1.7,2.6,2.2,2.8,2.2,2.2,1.9.1,1,.8v2.1l-1.3,1.2-.4,1.7,1.5,2.3,1.7,2.2,1.9,1.5.9,8.4L358,274l.4,4.1,17.1-.1,16.8-.5,23.4-.9,1.6,2.7-.6,2.2-2.2,1.8-.4,1.3,3.8.4,3-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"384.27","cy":"247.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Missouri")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"arkansas"}},[_c('path',{attrs:{"d":"M418,285.5l-4.6-.5.7-2.2,2.2-1.9.4-1.7-1.3-2.1-23,.9-16.8.5-17.1.2,1.1,5,.1,6.1,1,7.9.2,27.5,1.5,1.2,2.2-.9,2.1.9.3,7.3,18.2-.1,19.4-.6.7-1.4-.2-2.7-1.2-2.2,1.1-1-1-1.6.5-1.7.8-4.3,2-1.7-.6-1.6,2.9-4,1.8-.8-.1-1.2-.4-1.2,2.1-4.2,1.8-.8.1-2.4,1.5-1,.7-3-1-2.9,3-1.7.2-1.5.9-3,.7-2.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"386.52","cy":"303.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Arkansas")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"louisiana"}},[_c('path',{attrs:{"d":"M374.52,386.4l5.9-.2,7.4,2.6,4.7.8,2.7-1.1,2.3.8,2.3.7.6-1.5-2.3-.8-1.9.4-2-1.2.6-1.1,2.2-.7,1.3,1.1,1.3-.7,2.3.4,1.1,1.7.2,1.7,3.3.2,1.3,1.3-.6,1.2-.9.6,1.2,1.2,6.1,2.6,2.6-.9.7-1.7,1.9-.4,1.3-1.1.9.7.6,2.1-1.8.6.4.4,2.5-.9,1.7-2.5.6-.4-1.5-.2.6-1.2-.1-1.1,1.5-.4.8-.9.4.6.4,2.2,3,.4,2.9,1.4.7,1.1h2.1l.8.7,1.7-2.2v-1.1h-.9l-2.5-2-4.2-.6-2.3-1.7.8-2,1.7.2.1-.4-1.3-.7V384H432l1.3-2.2-.9-1.4-.2-2-1.1.1-1.4,1.5-.4,1.9-2.2-.4-.7-1.3,1.3-1.4,1.4-1.2-1.6-4.7-2.5-2.5.7-5.3-.1-.4-.9.1-23.8,1-.6-1.7.6-6.1,6.2-10.7-.7-1.9,1-.3.3-1.4-1.6-1.4.1-1.4-1.4-3.2-.3-3.7.1-.5-19.1.6-18.2.1.3,7,.5,6.9.4,2.7,1.9,3.3.7,3.2,3.1,4.3.2,2.2.4.6-.5,6-2,3.3.9,1.7-.4,1.9-.6,5.3-1.3,2.3.1,2.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"391.27","cy":"373","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Louisiana")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"mississippi"}},[_c('path',{attrs:{"d":"M430.32,376.6l1.9-3,1.3.6,4.9-1.4,1.5.2,1.1.6h3.8l.3-1.2-1.2-10.7-2-13.7.7-32.5-.1-12.1.1-4.6-3.5.2-14.2,1.2-9.4.3-.1,2.3-2,.9-1.9,3.7.4,1.2.1,1.7-2.1.8-2.5,3.7.6,1.7-2.2,1.8-.7,4.1-.4,1.4,1.2,1.8-1.1,1,1.1,2,.2,3-.9,1.8-.1.7.3,3.6,1.4,3.3-.1,1.2,1.7,1.4-.5,2.2-.7.2.4,1.4-6.2,10.8-.6,5.9.4,1.1,17.5-.5,5.9-.5,1.4-.2.4,1-.7,5.1,2.4,2.4,1.6,4.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"424.62","cy":"334","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Mississippi")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"tennessee"}},[_c('path',{attrs:{"d":"M478.32,295.3l-9.5.9L452,297.8l-27.1,2-8.5.3.7-.4.7-3.3-.9-2.6,2.8-1.7.3-1.8.9-3.1,2.2-6.9.4-4,.2-.1,8.9-.1,9.8-.6.1-2.8,2.5-.1,22-2.4,38.9-3.8,7.4-1.1,5.5-.1,1.7-1.4.9.2-.1,2.4-.3,1.2-1.7,1.6-1.2,2.6-1.4-.3-1.7.7-1.6,2.4-1-.1-.6-.9-.8.3-3.1,2.9-.6,2.2-3,1.6-3.1,2.6-2.7,1.1-3.2,2-.4,2.6-1.8.4-1.4,1.2-.1,3.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"464.02","cy":"283.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Tennessee")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"kentucky"}},[_c('path',{attrs:{"d":"M432.42,275.2l9.1-.5.1-3h3.1l22-2.3,32.5-3.1,4-2.6,2.8-1.5.1-1.4,4.3-5.6,3-2.6,1.5-1.7-2.4-1.4-1.8-2-2.2-2.7-.4-1.6-1.9-1-.7-1.4-.1-4.4-1.9-1.4-1.4-.8-.4-1.7-.9.2-1.4.9-1.8,2-1.4-1.2-1.8-.4-1.7,1H491l-1.3-1.4-4-.1-1.3-3.3-2.1-1.1-1.5.6-3,.1-.4,1.5.9,1.1.2,1.5-2,1.4-2.7,1.3-1.9.3-.4,3.3-3.5,2.6-1.9,2.7.1,1.6-.7,1.7-3.3-.1-.9-.9-2.8,1.6.1,2.4-1.7.4-.6-1-1.2-.9-2,.8-1.3,2.5-1.6-.7-1-1.2-2.7.3-4,.7-2,.9-.9,2.5-.7.7,1.1,2.7-3,1-1.4,1-.3,1.6.9,1.7v1.6l-1.2.3-4.4-1.8-1.7.7-1.4,1-.6,1.3,1.2,1.7-.7,1.3-.1,2.4-1.7.9-1.5,1.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"478.42","cy":"253.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Kentucky")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"illinois"}},[_c('path',{attrs:{"d":"M440.72,190.5l-.6-1.9-.9-2.7-1.2-1.3-1.1-1.9-.3-4-11.5,1.3-12.6.7h-8.9l.1,1.5,1.6.7.8,1,.3,1,2.8,2.5.5,1.7-.5,2.4-1.2,2.7-.6,2-1.7,1.4-1.4.4-3.8.9-.9,3,.4.8,1.4,1.3-.1,3.1-1.5,1.2-.4.9v2l-1.3.4-1,.9-.3.9.3,1.4-1.2.9-.7,2,.2,2.8,1.7,5.1,5.1,5.5,4.1,2.7V237l.5.9,4.8.4,2,1-.5,2.5-1.6,4.5-.6,2.2,1.4,2.7,4.6,3.8,3.5.6,1.6,3.7,1.4,2.5-.7,2,1.1,2.7L425,268l1.2-.2.7-1.6,1.7-1.2,2-.7,4.4,1.8.4-.1v-.8l-.9-2,.3-2,1.7-1.2,2.5-.9-.4-.9-.6-1.4.9-.9.7-2V251l.3-3.5,1.8-2.2,1.3-2.7,1.8-2.9-.4-3.8-1.3-2.3-.2-2.4.6-3.8-.5-5.2-.8-11.4-1-11.1-.7-8.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"421.42","cy":"216.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Illinois")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"indiana"}},[_c('path',{attrs:{"d":"M443.82,191.9l1.1.7.8-.2,1.5-1.4,1.8-1.3,10.3-.8,13.3-1.3,1.2,11.2,3.5,30.7-.4,2.1.9,1.2.1.9-1.7,1.2-2.6,1.2-2.3.3-.4,3.5-3.4,2.6-2.1,2.9.1,1.7-.4,1h-2.3l-1-1.2-3.8,2.2.1,2.2-.7.1-.4-.7-1.7-1.2-2.6,1.1-1,2.1-.9-.4-1.2-1.3-3.2.4-4.1.7-1.8.9v-2l.3-3.4,1.7-2.1,1.3-2.8,2-3-.4-4.2-1.3-2.2-.2-2.3.6-3.8-.5-5.1-.7-9.1-1.8-21.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"459.72","cy":"217.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Indiana")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"wisconsin"}},[_c('path',{attrs:{"d":"M384.92,115.2l2.1.4,2.1-.4,5.3-2.3,2.1-1.4,1.5-.6,1.4,1.1-.8.8-1.4,2.2-.3,1.4.7.4,1.3-.7.8-.1,2,.6.4.8.8.1.4-.8,2.9,3.8,5.9.9L418,123l1.9.8,8.9,1.9,1.2,1.7,2.6.9,1.2,7.4,1.2,1,1.1.7-.8,1.7-1.3,1.2-1.5,3.4-.9,1.7.1,1.3,1.1.2.8-1.4,1.1-.6.6-1.7,1.4-1.3,2-2.9,3-4.6.6-.4.2.7-.1,1.7-2.1,4.9-2,4.1-.4,2.3-.4,1.9.6.9-.1,2-1.4,1.7-.4,1.3.4,2.6.4,2.5-1.1,1.9-.6,2.1-.7,2.2.8,1.7.4,4.4,1.2,3.3-.1,2.2-11.5,1.3-12.6.7h-9.2l-.5-1.1L401,179l-1.9-.9-1.7-2.7-.2-2.6,1.4-2.1-.4-1-1.5-1.6-.6-2.4-.4-4.9-1.5-1.8-5.1-3.3-2.7-3.9-2.5-.7-1.6-2H380l-2.1-2.4-.4-4.7.1-2.7,1.1-2.2-.6-2.3-1.8-2,1.3-3.9,3.8-2.7,1.2-1.4-.1-5.9.1-2,1.7-2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"411.62","cy":"147.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Wisconsin")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"michigan"}},[_c('path',{attrs:{"d":"M459.42,188.2l13.8-1.4.1.8,7.2-1.1,8.7-1.2.1-.4.1-1.1,1.5-2.7,1.4-1.2-.1-3.7,1.2-1.2.8-.2.1-2.6,1.1-2.2.8.4.1.4.6.1,1.4-.7-.3-6.6-2.3-5.9-1.7-6.6-1.7-2.3-1.9-1.3-1.2.8-2.8,1.3-1.4,3.6-2,2.7-.8.4-1.1-.4s-1.9-1.1-1.7-1.5c.2-1.2.3-2.4.4-3.6l2.5-.9.6-2.5.4-1.9,1.7-1.2-.2-7.2-1.2-1.7-.9-.6-.6-1.5.6-.6,1.2.2.1-1.2-1.9-1.6-.9-1.9h-1.9l-3.3-1.1-4-2.5h-2l-.4.4-.8-.3-2.2-1.7-2.1,1.3-2.1,1.7.2,2.6.7.2,1.5.4.4.6-1.9.6-1.9.2-1.1,1.3-.2,1.5.2,1.2.2,4-2.6,1.5-.4-.1v-3l.9-1.7.4-1.7-.6-.6-1.4.6-.7,3-2,.8-1.3,1.4-.1.7.4.6-.4,1.9-1.7.4v.8l.6,1.7-.8,4.4-1.2,2.9.4,3.4.4.8-.6,1.7-.2.6-.2,2L452,165l2.1,4.7,1.1,3.5-.6,3.4-.7,4.3-1.7,3.8-.2,2-2.3,2.2Zm-24.1-52.3-.9-.8-1.3-7.5-2.7-.9-1.2-1.7-9.1-2-2-.8-5.9-1.6-5.6-.7-2.8-3.8.5-.4,2-.6,2.6-1.7v-.7l.4-.4,4.3-.7,1.7-1.4,3.2-1.5.1-.9,1.4-2.1,1.3-.6.9-1.3,1.7-1.7,3.2-1.7,3.4-.4.8.8-.2.7-2.7.7-1.1,2.2-1.7.6-.4,1.7-1.7,2.3-.2,1.9.6.4.7-.8,2.6-2.1.9.9h1.7l2.3.7,1.1.8,1.1,2.2,2,2,2.8-.1,1.1-.7,1.2.9,1.2.4.9-.6h.8l1.2-.7,2.9-2.6,2.5-.8,4.8-.2,3.3-1.4,1.9-.9,1.1.1v4.1l.4.2,2.1.6,1.4-.4,4.4-1.2.8-.8,1.1.4v5.1l2.3,2.2.9.4.9.7-.9.2-.6-.2-2.7-.4-1.5.4-1.7-.1-2.3,1.1h-1.3l-4.2-.9-3.8.1-1.4,1.9-5.1.4-1.7.6-.8,2.2-.9.8-.4-.1-1.1-1.2-3.3,1.7h-.4l-.8-1.2-.6.1-1.4,3.2-.7,2.9-2.3,5ZM414,95.2l1.3-1.5,1.6-.6,3.9-2.8,1.7-.4.4.4-3.7,3.7-2.4,1.4-1.5.7Zm62.1,23.1.4,1.8,2.3.1.9-.9s-.1-1.1-.3-1.2a17.72,17.72,0,0,1-1.2-1.4l-1.6.1-1.2.1-.2.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"470.02","cy":"156.45","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Michigan")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"ohio"}},[_c('path',{attrs:{"d":"M473.22,188.3l1.2,11.2,3.5,29.6,2.8-.1,1.7-.6,2.6,1.3,1.2,3,3.9.1,1.3,1.4h1.2l1.7-1,2.2.4,1.1.9,1.3-1.4,1.7-1,1.7-.3.4,2,1.2.7,1.9,1.4.6.1,1.4-.1.9-.4V234l1.2-1.1.1-3.5.8-3,1.4-.9.7.5.7.8.5.1.3-.3-.7-2V223l.8-1,1.8-2.6.9-1.1,1.6.4,1.5-1.1,2.2-2.4,1.6-2.7.1-3.9.4-3.6v-3.3l-.9-2.3.9-1.3.9-.9-.4-2L522,176.7l-4.5,2.7-2.8,1.7-2.5,2.7-2.9,2.8-2.3.6-2.1.4-4,1.9-1.5.1-2.5-2.2-3.8.4-1.9-1-1.6-.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"499.87","cy":"206.85","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Ohio")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"west-virginia"}},[_c('path',{attrs:{"d":"M541.92,219.3l4.2-4.3,1.9-.6,1.2-1.1,1.1-1.6.8.2,2.2-.1,3.3-2.6,1.1-.4.9.7,1.9.9,2.2,2.2-.3,3.1-3.9-1.9-3.5-1.3-.1,4.3-1.9,4.1-2.1,1.7-.6,1.7-2.2.4-1.2,5.9-2,.1-.8-.7-.9-1.4-1.6.4-.4,3.7-1.3,3.7-3.6,8,.7,1-.1,1.4-1.6,1.8-1.2-.3-2.2,1.7-2-.6-1.3,3.5-2.7.7-1.8-.9-1.8,1.4-1.7.5-2.3-.6-2.7-3.3-2.5-1.6-1.8-1.8-2.1-2.7-.4-1.7-2-1.2-.4-.9-.1-4,.2.1,1.7-.1,1.3-.7v-1.6l1.2-1.1.1-3.8.7-2.6.8-.5.3.2.7.8,1.2.4.8-.9-.7-2.2v-1.2l2.2-3.3.9-.9,1.4.4,1.9-1.3,2.2-2.5,1.7-3,.1-4,.4-3.5V202l-.8-2.2.7-.9.6-.5,3.1,14,3.1-.6,8.1-.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"529.77","cy":"228.85","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("West Virginia")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"south-carolina"}},[_c('path',{attrs:{"d":"M541.92,334.2l-1.5-.7-1.4-4-1.8-1.7-1.8-.4-1.1-3.3-2.2-4.7-3-1.3-1.4-1.3-.9-1.9-1.7-1.4-1.7-.9-1.6-2.1-2.3-1.7-3.2-1.2-.3-1-1.7-2-.4-1.1-2.7-3.9-2.5.1-2.8-1.8-.9-.9-.1-1,.4-1.2,2-.9-.6-1.4,4.6-2,6.7-3.3,5.1-.7,11.9-.4,1.7,1.4L538,290l3.3-.6,9.1-1.1,2,.6,9,5.3,7.3,6-3.8,3.9-1.9,4.4-.4,4.6-1.2.6-.8,2-1.7.4-1.5,2.6-2,2-1.7,2.5-1.2.6-2.6,2.5-2.1.1.7,2.3-3.6,3.8-1.7,1.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"540.27","cy":"304.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("South Carolina")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"georgia"}},[_c('path',{attrs:{"d":"M535.62,356.3l-4-.5-1,1.2,1.2,3.4-.2,2.8-1.6-.4-.1-2.2h-3.8l-3.8.5-23.2,1.4-5.6-.2-1-.9-1.8-3.1-.6-2.4-1.2-.7-.4-.4.7-1.6-.3-4-1.2-3.3.6-3.5,1.2-3.5-.1-1.8-1.4-.4-.3-2.3-2-2.5-1.4-4.5-1.1-5.1-1.2-3.5-2.7-11.6-2.5-5.8-.6-3.8.1-1.7,2.4-.2,9.8-1.2,13.4-1.4,4.6-.8.4,1-1.6.7-.7,1.6.3,1.4,1,1.2,3.1,2,2.3-.1,2.3,3.4.4,1.2,1.7,2,.4,1.2,3.4,1.3,2.2,1.6,1.7,2.2,1.7.9,1.4,1.3,1,2,1.5,1.4,3,1.3,2,4.3,1.2,3.7,2,.5,1.5,1.4,1.4,4.1,2.1,1.2,1.2-.6.3.9-2.4,4.5.4,1.9-1.1,3-1.7,7.2.6,4.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"510.47","cy":"331","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Georgia")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"florida"}},[_c('path',{attrs:{"d":"M535.62,357l-3.8-.5-.5.6,1.1,3.2-.3,3.8-3-.7-.1-2h-3l-3.8.5-23.3,1.4-5.9-.2-1.2-1.2-1.8-3h-4.3l-4.8.4-25.5,3-.2,2,1.2,1.2,2.1,1.4.2,6.1,2.4-.4,4.3-1.5,4.3-.4,3.2-.4,5.5,1.3,5.9,2.8,1.2,1.1,2.1.8,1.2,1.4.2,2,2.3-.9h2.8l2.6-1.4,2.7-2.6,2.2.1.4-.8-.6-.7.1-1.4,2.9-.6h1.9l2.1,1.1,3,1.1,1.7,2.7,2,.7.8,2.5,2.5,1.2,1.2,1.9,1.4.4,3.8.9.9,2.2,2.2,2.7v6.9l-1.1,3.4.2,2,.9,3.5,1.3,2.9.6-.4,1.1-3.3-1.9-.7-.2-.4,1.2-.4,3.3.7.1,1.2-2.3,4-1.5,1.7,2.6,2.7,1.9,2.2,2.1,3.8,2.1,2.8,1.5,3.6,1.3.2,1.2-1.5,1.3.8,1.9,2.9.4,2.6,2.2,3.2.6-.9,2.8.2,2.6,1.7,2.5,3.8.6,2.5.2,2.1.8.7.9.4,1.7-.7,1.1-1.2,2.8-.1,2.2-1.1,2-2.3-.4-1.4-.2-1.7.4-1.4-.2-1.4,1.7-.9.2-2.5-.4-1.3-.4-8.7-.9-5.5-3.3-5.9-2.6-4.2-1.9-3.8-2.1-2.1-2.1-5.3.5-1,.8-.9-1.2-2.1-3-3.3-3.5-4-2.7-4.6-3.8-6.8-2.7-7-1.7-5.3Zm12.8,95.8,1.7-.4.9-.1,1.1-1.7,1.7-1.2.9.4,1.2.2.3.8-2.5.9-3,1.1-1.7.9Zm9.6-3.6.9.8,2-1.5,3.8-3,2.7-2.8,1.8-4.8.7-1.2.1-2.5-.5.4-.7,2-1.1,3.3-2.3,3.8-3.2,3-2.5,1.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"537.32","cy":"383.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Florida")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"alabama"}},[_c('path',{attrs:{"d":"M447.82,372.4l.4.1.9-2,1.1-3.2,1.7.4,2.2,4.3v.7l-2,1.4,2,.2,3.8-1.8-.2-5.5-1.8-1.3-1.4-1.4.3-2.9,7.6-1.1,18.6-2.1,4.8-.4,4,.1-.4-1.6-1.1-.6-.7-.8.7-1.9-.3-3.8-1.2-3.3.6-3.7,1.2-3.5-.1-1.2-1.3-.5-.4-2.6-2-2.5-1.4-4.7-1-4.8-1.3-3.6-2.7-11.6-2.5-5.7-.6-4,.1-1.6-6.5.6L452,298.1l-8.8.6-.1,4.6.1,12.1-.5,22.4-.2,10.2,2,13.6,1.2,10.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"463.02","cy":"325.8","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Alabama")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"north-carolina"}},[_c('path',{attrs:{"d":"M561.92,293.9l-9.2-5.6-2.2-.6-12,1.5-1.2-2.2-2-1.6-12.1.4-5.3.7-6.7,3.3-4.9,2-4.5.9-9.7,1,.1-3,1.2-.9,2-.5.5-2.7,2.8-1.8,2.8-1.1,3.3-2.7,3.2-1.7.5-2.3,3-2.7.5.7,1.8.1,1.7-2.6,1.2-.3,1.9.2,1.3-2.9,1.8-1.7.4-1.3.1-2.5,3.2.1,27.7-4,41.4-9.1,1.4,3.5,2.6,4.7,1.7,1.7.4,1.7-1.7.1.6.4-.2,3-1.9.9-.4,1.5-.9,2.1-2.7,1.2-1.7-.2-1.1-.1-1.2-.9.2.9v.7H591l.6.9-1.4,4.6h3l.4,1.2,1.7-1.7.9-.4-1.4,2.6-2.2,3.5h-.9l-.8-.4-2,.4-3.8,1.7-4.7,3.8-2.5,3.4-1.4,4.7-.4,1.7-3.4.4-3.7,1.1Zm35.6-18.8,1.9-1.8,2.3-1.9,1.1-.4.1-1.4-.4-4.5-1.1-1.7L601,262l.5-.1,2,4,.3,3.2-.1,2.5-2.5,1.1-2,1.7-.8.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"560.52","cy":"274","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("North Carolina")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"virginia"}},[_c('path',{attrs:{"d":"M596.62,227.2l-.1,2-2.1,2.7-.3,3.3.4,2.5-1.3,3.6-1.6,1.4-1.1-3.3.3-3.9,1.2-3,.5-2.4-.1-1.2ZM553,259.3l-27.8,4-3.5-.1-1.6-.2-1.8,1.4-5.3.1-7.4,1.2-4.8.4,3-1.9,3-1.7v-1.4l4.1-5.3,3-2.7,1.6-1.8,2.6,3.1,2.7.7,2-.7,1.4-1.1,1.7.9,3.3-.9,1.2-3.2,1.7.5,2.3-1.7,1.2.3,2-2.3.1-2-.6-.9,3.5-7.6,1.3-3.8.4-3.4.5-.1.8,1.2,1.1.9,2.8-.1,1.2-5.9,2.2-.4.6-1.9,2-1.6.8-1.5,1.3-3.1.1-3.3,2.6,1,4.8,2.2.2-3.8,2.5.9-.4,2.1,6.2,2.2,1,1.3-.6,2.4-.9.9-.4,1.2.4,1.7,1.4.9,2.8,1,2.1.7,3.5.7,1.6,1.5,2.3.3.7.9-.3,3.4,1,.8-.4,1.4.9.6-.1,1-2-.1.1,1.2,1.7,1.1.1,1,1.3,1.3.4,1.8-1.9,1,1.2,1.1,4.2-1.2,2.7,4.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"561.52","cy":"241.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Virginia")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"maryland"}},[_c('path',{attrs:{"d":"M596.62,226.5l1.2-2.7.4-3.5-4.6.8-4.2.2-2.7-12.1-1.7-4-1.1-3.3-16,3.1-27.1,5.5,1.4,7.5,3.5-3.5,1.8-.5,1-1.1,1.3-2,1.2.5,1.9-.1,1.9-1.5,1.4-1.1,1.5-.4,1.1.8,2,1,1.4,1.3.9,1,3.5,1.2-.4,2.1,4.2,1.5,1.5-1.9,2.7,1.8-1.5,2.4-.5,2.4-1.3,1.9v1.5l.2.6,1.4.9,2.5.8,3.1-.1,2.2.7,1.5.2.7-1.5-1.1-1.5v-1.3l-1.7-1.5-1.5-4,.9-3.8-.1-1.5-.9-.9s1.1-1.2,1.1-1.7a8.74,8.74,0,0,1,.4-1.5l1.4-.9,1.4-1.2.4.7-1.1,1.2-.9,2.7.2.8,1.3.2.4,4-1.5.7.2,2.6.4-.1.8-1.4,1.2,1.3-1.2.9-.2,2.5,1.9,2.5,2.8.4,1.2-.6,2.3,3,.7.3Zm-10.5.1.8,1.8.1,1.3.8,1.4s.7-.7.7-.9-.5-2.2-.5-2.2l-.5-1.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"573.52","cy":"210.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Maryland")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"washington-dc"}},[_c('g',[_c('path',{attrs:{"d":"M572.82,218.9l-.8-1.2-.7-.6.8-1.2,1.6,1.1Z"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"572.42","cy":"217.5","r":"3.6"}})]),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"572.52","cy":"218.2","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Washington D.C.")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"delaware"}},[_c('path',{attrs:{"d":"M596.32,214.2l-.7.4-2.6-1.7-1.3-3.4-1.4-2.6-1.7-.7-1.5-2.6.4-1.4.4-1.7.1-.8-.4.1-1.2.7-1.4,1.2-.1.2,1,3,1.7,4,2.7,11.6,3.6-.2,4.3-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"592.07","cy":"215.85","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Delaware")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"new-jersey"}},[_c('path',{attrs:{"d":"M588.62,200.5l.1-1.1,2-.9,1.2-2,1.2-1.7,2.4-2.3v-.8l-4.4-3-.7-2-2-.2-.1-.7-.5-1.6,1.6-.8.1-2.1-.9-.9.1-.9,1.4-2.2v-2.2l1.8-2.2,4,1.8,4.6,1.4,1.8.9.1,1.3-.4,2,.3,3.3-1.5,1.4-.8.7.4.4,2-.2.8-.6,1.2,2.5.1,6.8.4.8-.8,4-2.2,4.7-2,2.9-.6,3.5-1.5,1.7h-.6l-.2-2,.6-.7-.1-1.1-2.9-.4-3.5-1.7-2.3-2.1-.7-1.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"598.72","cy":"194.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("New Jersey")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"pennsylvania"}},[_c('path',{attrs:{"d":"M525.72,174.5l.9-.4,4.1-4,.5,5,24.1-4.7,26.6-5.6,1.7,1.7,2.2.3,1.4,4,1.7,1.4,2,.3.1.1-1.9,2.3v2.2l-1.4,2.2-.1,1.4.9.9-.1,1.4-1.7.8.7,2.5.1.8,2,.2.7,1.8,4.3,2.8v.3l-2.2,2.2-1.1,1.6-1.2,2-2,.9-1,.2-1.5.9-1.2,1-16.2,3.1-27.9,5.6-8.2,1-2.8.5-3.7-16.2-3.1-18.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"556.77","cy":"189.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Pennsylvania")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"new-york"}},[_c('path',{attrs:{"d":"M602.72,180.2l.4-2-.1-1.7-2.2-1.1-4.7-1.4-4.3-1.9-.4-.3-2-.2-1.4-1.1-1.6-4.2-2.4-.4-1.7-1.7-27.7,5.9-22.8,4.3-.4-4.7,1.2-.9.9-.8.7-1.2,1.3-.8,1.4-1.3.4-1.2,1.5-2,.8-.7-.1-.7-.9-2.2-1.3-.1-1.4-4.4,2.1-1.3,3.2-1.1,2.9-.9,2.3-.4,4.6-.1,1.4.9,1.2.1,1.5-.9,1.9-.8,3.8-.4,1.5-1.3,1.3-2.3,1.2-1.4h1.5l1.4-.8.1-1.7-1.1-1.5-.2-1.1.8-1.5v-1.1H566l-1.5-.5-.6-.8-.1-1.8,4.2-4,.4-.6,1.1-2.1,2.1-3.3,2-2.7,1.5-1.7,1.7-1.3,2.2-.9,4-.9,2.3.1,3.3-1.1,5.3-1.6.5,3.5,1.7,4.7.6,3.6-.7,3,1.9,3.3.6,1.4-.7,2.3,2.7,1.2,2,7.4v4.2l-.4,7.9.6,3.9.5,2.6,1.1,5.3v5.9l-.8,1.6,1.5,2,.4.7-1.4,1.3.2.9.9-.2,1.1-.9,1.7-1.9.8-.4,1.2.4,1.7.1,5.7-2.8,2.1-2,.9-1.1,3,1.2-2.5,2.6-2.8,2.1-5.1,3.8-1.9.7-4.2,1.4-2.9.8-.7-.3Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"585.42","cy":"150.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("New York")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"connecticut"}},[_c('path',{attrs:{"d":"M609,173.7l2.6-2.3,1.4-1.5.6.4,2-1.1,3.8-.8,5.1-2.5-.4-3-.6-3.2-1.2-4.3-3.1.8-15.8,3.4.4,2.2,1.1,5.3v6l-.7,1.5,1.2,1.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"614.47","cy":"164","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Connecticut")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"rhode-island"}},[_c('path',{attrs:{"d":"M624.62,162.7l-.6-3.2-1.2-4.3,4.1-1.1,1.1.9,2.5,3.1,2,3.2-2,1-.9-.1-.8,1.3-1.7,1.4-2,.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"626.27","cy":"158.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Rhode Island")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"massachusetts"}},[_c('path',{attrs:{"d":"M634.62,160.4l-.4-1.7.6-1.1,2.1-1.1.6,2.2-.4,1.3-1.7,1.1v.7l1.4-1.1,2.8-3.3,2.8-1.4,3-1.1-.2-1.7-.7-2.1-1.4-1.7-1.3-.6-1.5.1-.4.4.7.9,1.1-.6,1.5,1.2.6,2-1.3,1.3-1.7.7-2.6-.4-2.8-4.3-1.7-1.9h-1.3l-.8.6-1.4-1.9.2-1.1,1.7-3.8-2.1-3.2-2.7,1.3-1.3,2.1-13.2,3.5-10,1.8-.4,7.7.5,3.5,15.9-3.5,8.1-2,1.4,1.2,2.5,3.1,2.1,3.4Zm9.1,1,1.6-.5.4-1.2.7.1.7,1.7-.9.4-2.8.1Zm-6.8.5,1.7-1.9h1.2l1.3,1.1-1.7.7-1.6.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"623.82","cy":"148.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Massachusetts")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"vermont"}},[_c('path',{attrs:{"d":"M595.12,116.1l1.7,4.7.6,3.8-.7,2.8,1.8,3.2.7,1.7-.5,1.9,2.4,1.1,2.1,7.8v3.8l8.3-1.5-.7-.8.4-1.4.1-3.1-.7-1,.1-3.4.6-6.7v-6.1l-.8-1.3v-1.2l2-.8,2.5-3.2v-2.6l-1.4-2-.2-4.2-18.9,4.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"605.42","cy":"128.4","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Vermont")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"new-hampshire"}},[_c('path',{attrs:{"d":"M630.42,137.8l.8-2.3-2-.9-.4-2.2-3-.8-.2-2.2-8.5-27-.5.1-.4,1.2-.4-.4-.7-.7L614,104l-.1,1.7.4,6.1,1.4,2v3.1l-2.8,3.5-1.7.7v.5l.8,1.4v6.2l-.6,6.7-.1,3.4.7,1-.1,3.4-.4,1.1.7.8,3.7-.9,10-2.5,1.2-2.1,2.9-1.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"618.42","cy":"132.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("New Hampshire")])]),_vm._v(" "),_c('g',{staticClass:"state us-state",attrs:{"id":"maine"}},[_c('path',{attrs:{"d":"M618.92,102.2l1.1.3v-1.8l.6-4,1.9-3.4,1.1-2.9-1.4-1.7V84.4l.6-.7.6-2-.1-1.1-.1-3.5,1.3-3.5,2.1-6.4,1.5-3h.9l.9.1v.8l.9,1.7,2,.4.6-.6v-.7l2.9-2.1,1.3-1.3,1.1.1,4.3,1.7,1.4.7L651,86.6h4.3l.6,1.4.1,3.5,2.1,1.7h.6l.1-.4-.4-.8,2-.4,1.4,1.5,1.7,2.7v1.4l-1.5,3.4-1.4.4-2.5,2.2-3.5,4h-.9c-.4,0-.7-1.5-.7-1.5l-1.3.1-.7,1.1-1.7,1.1-.7,1.1,1.2,1.1-.4.4-.4,2-1.4-.1v-1.2l-.2-1-1.1.2-1.3-2.3-1.5.9.9,1.1.2.8-.6.9.2,2.2.1,1.2-1.2,1.9-2.1.4-.2,2.1-3.8,2.2-.9.4-1.2-1.1-2.2,2.6.7,2.3-1.1.9-.1,3.2-.8,4.6-1.6-.7-.4-2.2-2.9-.8-.1-1.8-8.5-26.9Zm26.3,11.3,1.1-1.1,1,.8.4,1.7-1.2.7Zm4.9-4.3,1.3,1.4s.9.1.9-.1.1-1.4.1-1.4l.7-.6-.6-1.3-1.4.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"637.42","cy":"99.15","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Maine")])])]),_vm._v(" "),_c('g',{attrs:{"id":"india"}},[_c('g',{staticClass:"state india-state",attrs:{"id":"jammu-and-kashmir"}},[_c('g',[_c('path',{attrs:{"d":"M740,2.4l.9,1,1.7-.1,1.2-.1,1.1-.9,1.2-.4,1.2.6,1.2,1.8,1.4,2.1,1.9,2.2.7,1.6,2.5,1.6,2.4,1.2,2,1.9,2.4.8,1.9,2,1.2,1,2,.2,1.7,1.8.1,1.3-.4,1.1.5,1.4.9,1.3,2,.6h2.4l2.7.8,1.6,1.4.7,1.9.7,1.3,2.5.3,2.9-1.3,2.5-.7h2l1.4-2.3,1.7-1.4,2-.4,1.6-.7,1.4-1.1,2.5-.2,2.1.7,1.3.7.9-.5V23l.8-.9,1.3-.4,1.8,1.4.9,1.1,1.2.3,2.2.5,1.7.5,1.4-.7,1-.4.9,1.5.9,1.4,1.2.7,1.5,1.1.4,1.2-.4,1.2.2,1.3-.1.9-.7,1.2-.1.9-.7,1-.1,1.1.1,1.9-.5,1.4-.6,1.4-.4,1-.3,1.6-1.1.6-1.2.5-1.5.7v1.4l-.6.9-1.4-.1-1.5.1-.7.7.1.8L811,52l.4,1.5-.7,2.7-1.4,1.6-.9.4-1.4-.4-1.6-.6-1,.4-1.4.3-.9.3-.4.9.3,1.2.6,1.2.7,1,1,1.6-.3,1-.8.7-1.1.4-.2,1,.1,1.2-.4.5,2.2,2,.1,1.2,1.7.7,3.4.2.1.6-.9,2.1v.9l1.4,1.6.4,1.5.9.8.5,1.6-.3,1.2-1.4.4-2,1.7-.8-.7-.9.2-1.2.9-.4,1.7-.9-.2-1.1.7-.9-.4-2-2-.3-1.7.2-.6-.5-1.7-1.4.9-.4.7-1.2-.1-.9.7-.5-.1-.6.4v.8l-.4-.3-1.1.9-.5-.6.3-.4v-.9l1.4-.8-.4-.9.1-1.6-1.3.4.1.4-1.2.8-.9-.1-.5.7-.4-.4-.4.7-.5-.2v.6l-.8.1-1.2-1.9.2-1.3-.5-.1-.5-.9-1.3-.7.4-.7-1.2-1.2-.7-.2-.2.5-1,.3-.9,1H780l-.4.4-1-.4-.4,1.1-.4.1-.4-.6-.7-.4-.3.2-.1-.6-.8-.7-.4.3-.1-1.2-.9.1-.6-.5-.6.2-1.2-.8-.6-1.4h-.5l-.7-.8.4-1.7-.4.1-.4-.4-.4.1-.4,1.2-1.6.3-.7-.8-.5-.1-1.2.5-1.2-.1-1.7,1.5-.6,1.3-2.2.5-.1.7-2.1,1.5-1.2-.8h-.9l-.2,1.1,1.2,1,.6,1-.2,1.2.4.9-.8,1.2-1,1.6-.9.2-.5,1-2.7,1.2-.4,1.3-.1-.6-.4-.1.1-.4-.9.3-1.4-.2-2-1.2-.1-.4-.7.2-.9-1.2-.7-.2-.9.8-2.2-.9-2.1.2-.9-2.2.5-.9-.4-1.1.7-2.2-.9.3-.4,1.2-1.2.3-.9.5-2.1-.2-1-.7-1.5-.7-1.2-1.1-1.8-.7-1.5-1.1H723l-.5-1.1-.8-.7-1.1-.9.4-1.8-.7-1.3-.2-2.2.8-.9-.6-2.3.4-.9.1-1.1-1.1-1.1.1-1,.7-.9-.6-2.2-1.1-1.1.1-2.1-.2-1.7-.7-1.8.3-1.8V48.2l.9-1,1.6-.4,1.2-.5.1-1.4.9-1.7,1-.1,2.5-.1.9-.7.6-2.2.7-1.4V37.3l-1.3-1.2-1.8-.8-1.4-.4-.9-.7-.5-1.1.3-1.2,1-.7.4-.9-.7-1.6-1.5.1-1.7-.2-1.4-.4-2.5-.2-1.4-1.2-.7-1.3-.5-1.9-2-.9-2.2-.5-1.4.9-1.6.1-.5-.9-.1-1.6.4-.8-.4-1.2.3-1.2.7-1.7,1.7-1.2,1.8-1.5,1.7-1.8,1.6-2,.7-2,1.4-.9,2.2.2,2.8.3,3.2.1,1.5-.4-1.4-1.5-1.2-.7.6-.9,1.4-.2,1.3,1.2,1.9.4.9-1.2,1.3-.3,1.2-.6,1-.5,1.6-.8,1.1-.9,1.6-.1,1.2.2Z"}}),_vm._v(" "),_c('path',{staticClass:"JammuKashmirDashedLines",attrs:{"d":"M728.47,38.8s15.2-6,24.3-4.3,23.8-1.8,25.8-4.3"}}),_vm._v(" "),_c('path',{staticClass:"JammuKashmirDashedLines",attrs:{"d":"M781.77,31.7s9.3,19.2,19.9,26.1"}})]),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"764.27","cy":"58.3","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Jammu and Kashmir")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"himachal-pradesh"}},[_c('path',{attrs:{"d":"M755.17,83.6l.8-1.2-.4-.9.2-1.2-.6-1-1.2-1,.2-1.1h.9l1.2.8,2.1-1.5.1-.7,2.2-.5.6-1.3L763,72.5l1.2.1,1.2-.5.5.1.7.8,1.6-.3.4-1.2.4-.1.4.4.4-.1-.4,1.7.7.8h.5l.6,1.4,1.2.8.6-.2.6.5.9-.1.1,1.2.4-.3.5.5.1.6.3-.2.7.4.4.6.4-.1.4-1.1,1,.4.4-.4h.5l.9-1,1-.3.2-.5.7.2,1.2,1.2-.4.7,1.3.7.5.9.5.1-.2,1.3,1.2,1.9.8-.1v-.8l.5.2.4-.7.4.4.5-.7.9.1,1.2-.8-.1-.4,1.3-.4-.1,1.6.4.9-1.4.8v.9l-.3.4.5.6,1.1-.9.4.3h0l.5.2-.1.7,1.2.7-.9,1.2v1.2l-.4.7,1.5-.1.8.6-.3,1.1.4.7.8.3,1.3,1.7.6.1-1.2,3.7.5.5-.2.4.4.9h.7l.8,1.3-1.9,1.7.1.6.5-.1.7.7-.3.9.8.4v.9l1.2,1.2h0l.1.6.9.8.4,1.1-1.9.1-.8-.7-.4-1-2.2.2-.2-.5-.6-.3-.9.5-1,.1-.4-.7-.4-.3-.4.2-.7-.8-.9.1-.1.4-.4-.1-.6.7-1.3.1-.9.7-.9.1-.2.5-.9-.4-1,.4-.7,1.3-.7.4.4.9-.4.7.3.3-.8-.4-.4.3.1.7h.7l-.2,1.2-.7-.4v.9l-.9,1.1.8,1-.1.4.7.4.1.8-.8.4.5.7h.7l.1.5-.1.4-1.8,1-1.4.4-.3.4h0l.2.4h0l-.5-.2-.5-.9-.4.7-1.1.1.6-.6-.1-.4-.7.8-.8-.7-.5.1-.9-.6-.7.1-.3-.8-.8-.3-.3-.4.7-.6-.1-1.6-1.2-.9-.7-.2-.3.2-.4-.6.1-.7-.3.3-.4-.2-.8-1.5-.7.4.3-1.1-.1-.6-.6.4h0l-.9-1-1.6-.7v-.9l.4-1-.6-.3V108l.7-.5-.1-.3-.7.2.3-.6-.5-.5-.5.4v-.5l-.3.4-.1-.4-.4.1-.4-.7-.6.5.3-.4-1-1.5-.2-.9-.1.4-.7.2.3.9-.6.2v.4l-1.9.2-.1-.7-.5-.4.3-.9-2.3-4.1-1.2-3,.7.1-1.2-2.4-1.7-.8-1.4-1.2-.6-.3-.8.2-.3-.3,1.2-1.4-.7-.4v-.9l1.7-.7,1.7-1.9,1.3-.7-1.2-1.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"776.67","cy":"97.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Himachal Pradesh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"punjab"}},[_c('path',{attrs:{"d":"M755.17,83.6l-.3,1.2,1.2,1.7-1.3.7-1.7,1.9-1.7.7v.9l.7.4-1.2,1.4.3.3.8-.2.6.3,1.4,1.2,1.7.8,1.2,2.4-.7-.1,1.2,3,2.3,4.1-.3.9.5.4.1.7,1.9-.2v-.4l.6-.2-.3-.9.7-.2.1-.4.2.9,1,1.5-.3.4.6-.5.4.7.4-.1.1.4.3-.4v.5l.5-.4.5.5-.3.6.7-.2.1.2-.7.5v.9l.6.3-.4,1,.1.9,1.6.7.9,1h0v.5l.9.8.3.7-.3.5h0l-.5-.1.1-.4-.4.1-.1-.4-1,.7.5,1.2,1,.4.4-.3h0l.2.5.4-.4-.1.7.9.7-.4,1,.5.4-.5.6v.7l.6.9-.7.5V122l-.7-.8-.4.4-.8-.4-.9.8.1.5.4.1-.4.4-.6.1-.9.9-.9.1-.2.7.8-.5.4.4-.1.3.5.1-.2,1.7-.4.4-.4.1-.3-.4-.8.4-.1-.4-.6-.1-.7-1.7-.4.4.3.4-.2.5-.9-.4.4.4-.4.4-1.1-.2-.7-.7.1.4h-.3l.9.5-.9,1.2.3.2-.4.2.2,1.2-.6.3.3.7.9.4-1.9,1.2-.6-.1-.7,1-.3-.1-.8.4-1.3-.3-.7-1.2-.6.1-.4-.3-1,.3-.1.9-1.1-.3-.2.4-.7.1-.2-.4-.7.1-1-.8-1,1.7-.7.3.2.6-.5-.2-.6,1,.4.4-.1.4-1.1.4v-1l-.7-.4-.2-.6.6-.4v-.7l.6-.4-.7-1.5-.4.3v.7l-.9-.4.3-.4-.4-.4.4-.4-.3-.7-.3.7-1.2.4-1.2-1.6-.4.2-.1-.5-.5.1-.7-.6-1.2.5-.5-.1-.8.8.1.3-2-.7h0l-9.5-.4.1-1.4,1.1-1.3V125h0l-.1-1.2-1.3-1.9.5-.9.4-.1.1-.7.4.1.3-.7.7-.7.7.1-.1-.4.4-.4v-.7l.3.1.1-.4h.5l1.2-1.5.7-.2-.3-.7.5-.3-.2-.3.4-.9h.7v-.7l.8-.4.8-1.1,1-.5.3-1.3.9.4.7-.3.4-.6-.3-.7-.7.1-.1-.3-.4.1-.1.7-.5.1-.1-.7-.6-.3.1-2.4.7-.4,1.4-2.8-.2-.4-.9-.3.6-.6-.1-.6-1.3-2.7v-.4l.5-.1.1-1.4.7-1,.4.1.6-.7.7-.1.1-.6.4.4.2-.3.9-.1.1-.7.7-.4-.1-.3.8-.3,1.2.7,1.7-.9.7.3.5-.9.7.5,1.9-2.6.1-.6-.7-1.2h0l1.4.2.9-.3-.1.4.4.1.1.6.4-1.3,2.7-1.2.5-1,.9-.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"749.12","cy":"114.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Punjab")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"uttarakhand"}},[_c('path',{attrs:{"d":"M805.37,105.3l.8,1-.2.7.6.4.2,1.1.6.7.9.2.5,1.4h1.3l.4,1.2.9.6,1-.7.8.1.6-.4.9.5h.7l.9,1.5,2,.9.9,1.2.8-.6.5.9h.5l.2.5-.3.7-.6.5.4.4.1,1.2,1.4.2.9.7.5-.1,1.9,1.4.9-.6,2.3,1.6,1.2,1.4,3.2,1.2v.3l-.4-.1-1.2.4-.7.9.2.7-1.7,1.4-.2.7-1.1.9h-1.1l-.8,1.9-.9.9-.9-.1-1,.9.2,1.3.6.7-.2.7-.4.6-.6.1.1.6-.9.7.2.4-.9.1v.6l.5.4.1.8.6.6-.3,1.9-.9-.4.4,1.4-.6.4-.7-.3-.6.6-.1,1.7-.3.4-.3-.1-.7,1.2.2,1.5h0l-.7.5.2.3-.4.8-.7.4-.7-.3-.5-.9.2-.3-.9-.1.5-.1-.3-.4H815l-.1.6-.5.1.4-1-.5-.5-.9.2-.7.6-.8-.4-.9.4-.2-.8-.4.5-1.4.1-.1-1.3-.4-.1-.3-.6-.1.3h-.8l-1.4-1.3-.7.1.1-.5-.4-.3-.1-1-1.6-.7-.1.9-.9-.9-.3.3h-.7v-.9l-.7-1-.8.1-1.3-1,.7-.6.5.4.3-.9.3.3.7-.4.8-1.1-2.1-.4-2.7-1.5-1.2-1.1-.6-2-1.2-.5-1.2-.4-1.5,1.6-.6-.1-.8.6-.9,1.3-.6.1-.1.7-.7.1-.1-.7-.6-.1.1-.4.4.1-.4-1.6-1.2.1-.7.6-.6-.2.1-.3-.6-.3.1-1.2-.9-1.5.5-.7-.2-.4.4-.6-.2-.4.7-.7-.2-.4.4-.9.4.2.4-.4,1.4-2.4-3.3-1.6-1.2-1.2-1.1.1h0l.3-.4,1.4-.4,1.8-1,.1-.4-.1-.5h-.7l-.5-.7.8-.4-.1-.8-.7-.4.1-.4-.8-1,.9-1.1v-1.7l.7.4.1-1.2h-1l-.1-.7.4-.3.8.4-.3-.3.4-.7-.4-.9.7-.4.7-1.3,1-.4.9.4.2-.5.9-.1.9-.7,1.3-.1.6-.7.4.1.1-.4.9-.1.7.8.4-.2.4.3.4.7,1-.1.9-.5.6.3.2.5,2.2-.2.4,1,.8.7,1.9-.1-.4-1.1-.9-.8-.1-.6h0l.3-1.3,1-.6.9-1.9,1.2.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"805.77","cy":"125.9","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Uttarakhand")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"haryana"}},[_c('path',{attrs:{"d":"M768.77,113.1l.6-.4.1.6.6.4.7-.4.8,1.5.4.2.3-.3-.1.7.4.6.3-.2.7.2,1.2.9.1,1.6-.7.6.3.4.8.3.3.8.7-.1.9.6.5-.1.8.7.7-.8.1.4-.6.6,1.1-.1.4-.7.5.9.5.2h0l.3.2-.4,1-.7.5-.8,1.7-.7.4-.4.9.2.2-2.2,1-.1.8-1.2,1.7-.4,2-.5.4.4,1.2-.9,1.8.4.8-.7.2.8,1.6-.2.6.3.4-.4.2.1.4.5.2-.4,1.1.2.5-.3.3.2.7-.3,1.3,1.4,1.7-.4.9.5.9-.6.2.1.4h0l-.7.4-.1-.4-.8-.3-.7.8-1.4.3.2,2-.6.8.2.4h-.9l-.4.8h-.3l.1.6.7.8,1.4-.3.6.2V154l.7.5.4-.1.5.4.1.9.7.6,1.2-.4-.2-.6.2-.4,1.4-.4h0l2.1,1.7.3.9-.4.4.5.5-.1.4-.4.2,1.1.4-.4.3.1.5-.4-.2.1.4.8.1-.7.4-.1,1.1-.2-.1-.1.4.1.7.9.9-.4.4.4.1-.3.2h-.8l-.1.8-.7-.2v.7h-1.1l-.9.9h0l-.2-.1-.5.5-.6-.7-.4.7.2-.4-.4-.1v.4l-.4.3-1.3-.7-.3.7.7.2.2.4-1.3-.1-.4,1.4-.6-.3-.5.3-.3-.7h.5l-.4-.5.3-1.7h.4l.2-1.4-.3-.1v-1.2l.7-2.5-1.7-1.4-.7.3-.1.9-2.1,1,.1,1.3-.9.1-.9.7v-1.2l-1.3-.2.7-.3-.7-.5.2-.3.6.1-.4-.8-1.4.3-.7-.7h-.9l1.2.9-.9.4.9.4-.2.7-.7.1-.2-.6-.4-.2-1.2.2.6.4-.9.6.4.4-.2,1,.5.3-.1.6.4.4-.7.6-1.3-1-.6.4-1.3-.3.2-.8-.7-.1-.1-.3.2-.3.4.2.4-.8-.4-.3.5-.1-.3-.4.6-.1-.1-.3.4-.4-.3-.3-.5.7-.1-.5-.7-.2,1.4-1.4.6.1v.4l.4-.2-.7-.8.1-.4-.8-.3.1-.7-.9-.7-.5-.9-.5-.4-1.8-.2.1-.9-2.2-1.5-.1-.9-.9-.2-.4-2.3-.4-.7.2-.9-.7-1.5.7-.9-.1-.7-1.2-.1-.1-.8-.7-.1.2-1-.5-.2.6-.8-.1-1.2-.6.1-.2.5-.4-.1.1-1-1.4,1-.7-.6-1.1.7-.4-.1-.6-.9-.7.3-.6-.1-.4-1.4-1.3-.7-1.3.8-1.6-.3-.1.7-.7.1v-.4l-.6-1-.4-.1v-.4l.2-.3.6.1.5-1.2-.7-.7.6-3.3-.3-.3-.9.4-.8-.1-.1-.7,1.3-1.4-.3-.7-.4-.1.2-.7h0l2,.7-.1-.3.8-.8.5.1,1.2-.5.7.6.5-.1.1.5.4-.2,1.2,1.6,1.2-.4.3-.7.3.7-.4.4.4.4-.3.4.9.4v-.7l.4-.3.7,1.5-.6.4v.7l-.6.4.2.6.7.4v1l1.1-.4.1-.4-.4-.4.6-1,.5.2-.2-.6.7-.3,1-1.7,1,.8.7-.1.2.4.7-.1.2-.4,1.1.3.1-.9,1-.3.4.3.5-.1.7,1.2,1.3.3.8-.4.3.1.7-1,.6.1,1.9-1.2-.9-.4-.3-.7.6-.3-.2-1.2.4-.2-.3-.2.9-1.2-.9-.5h.3l-.1-.4.7.7,1.1.2.4-.4-.4-.4.9.4.2-.5-.3-.4.4-.4.7,1.7.6.1.1.4.8-.4.3.4.4-.1.4-.4.2-1.7-.5-.1.1-.3-.4-.4-.8.5.2-.7.9-.1.9-.9.6-.1.4-.4-.4-.1-.1-.5.9-.8.8.5.4-.4.7.8v.4l.7-.5-.6-.9v-.7l.5-.6-.5-.4.4-1-.9-.7.1-.7-.4.4-.2-.5h0l.1-1.4h0l.3-.5-.3-.7-.9-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"763.27","cy":"144","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Haryana")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"delhi"}},[_c('path',{attrs:{"d":"M775.07,148.4l.4.6-.3.7.4.1.9,1.3.6-.1-.2,1.2.4.7-.7.7.7,1h0l-1.4.4-.2.4.2.6-1.2.4-.7-.6-.1-.9-.5-.4-.4.1-.7-.5v.5l-.6-.2-1.4.3-.7-.8-.1-.6h.3l.4-.8h.9l-.2-.4.6-.8-.2-2,1.4-.3.7-.8.8.3.1.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"773.77","cy":"152.8","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Delhi")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"rajasthan"}},[_c('path',{attrs:{"d":"M726.47,125.4v1.3l-1.1,1.3-.1,1.4,9.5.4h0l-.2.7.4.1.3.7-1.3,1.4.1.7.8.1.9-.4.3.3-.6,3.3.7.7-.5,1.2-.6-.1-.2.3v.4l.4.1.6,1v.6l.7-.1.1-.7,1.6.3,1.3-.8,1.3.7.4,1.4.6.1.7-.3.6.9.4.1,1.1-.7.7.6,1.4-1-.1,1,.4.1.2-.5.6-.1.1,1.2-.6.8.5.2-.2,1,.7.1.1.8,1.2.1.1.7-.7.9.7,1.5-.2.9.4.7.4,2.3.9.2.1.9,2.2,1.5-.1.9,1.8.2.5.4.5.9.9.7-.1.7.7.3-.1.4.7.8-.4.2v-.4l-.6-.1-1.4,1.4.7.2.1.5.5-.7.3.3-.4.4.1.3-.6.1.3.4-.5.1.4.3-.4.8-.4-.2-.2.3.1.3.7.1-.2.8,1.3.3.6-.4,1.3,1,.7-.6-.4-.4.1-.6-.5-.3.2-1-.4-.4.9-.6-.6-.4,1.2-.2.4.2.2.6.7-.1.2-.7-.9-.4.9-.4-1.2-.9h.9l.7.7,1.4-.3.4.8-.6-.1-.2.3.7.5-.7.3,1.3.2v1.2l.9-.7.9-.1-.1-1.3,2.1-1,.1-.9.7-.3,1.7,1.4-.7,2.5v1.2l.3.1-.2,1.4h-.4l-.3,1.7.4.5H770l.3.7.5-.3.6.3.4-1.4,1.3.1-.2-.4-.7-.2.3-.7,1.3.7.4-.3V167l.4.1-.2.4.4-.7.6.7.5-.5.2.1h0l.4.3v1.3l.6.4.1.7-.5.7.6.3-.3.4.1.7.7.2.2.7.5.3-.2.7.2.4,1,.3,1.2.9.6-.3-.4.7.8,1-.1.4.5.3-.3.4-.7.1-.2.8-1.4.4.4.4.7-.2-.1.7,1.1.4.7-.6.4.9h.3l.1-.5.4.1-.3.6-1.3.2-3.4,1.8.2.8-.1.8h.5l-.2.4.7-.4-.2-.4.3-1,.4.4,1.3-.2,1.7-.8.1-.6.5-.4,2.1.8.1-.6.7.4,1-.2.2.9.4-.2-.1-.7.9.1.1-.8,1.4.2.1-.3.7.5-.6.7-.5-.1.3.9h0l-.7.1.2.6-1.2-.1.2.7-.4.3-.1.9-1.4-.4-.7.7-.8.1-.2.7-.9.4-.1.7-1,.1-.4.7-.7-.1-2.2,1.6-1.4.1.1.7-1.4.1-.7,1-1.4.9h-1.2l-.5.8-.9.1-.7.8-1.5.7-.9,1.1.1.3-.5,1-.8.2.1.4-.4.4-1.3-.1-.3.7-.5-.1-.9,1.3v1.1l-.7.3-.1.4.5.4.1,2.4.7,1.4.4.2.2.7,1.2.7,1.3.1.1.4,1.1-.3.7.1.7.8.2-.4,1-.1.8-.7,2,.4.2-1,.9-.9.4-.2.9.4-.4,1.4.5.1-.4.8.9.7.1.6-.4.1.1,1.2-1.4.5-.6-.6-1.4.1-.9.7-.6.2-1.3-.4-2.1,1.2.6,1.5.4.1-.1.5.5.3-.4.4-1.4.1-.4.4.7,1.2.9.1.7-.3.3.6.8.4.5,1.2.1,1.2-.2.7h-.3l-.4.9-.6.3-.8-.4v-.9l-.5.3-.2-.4-.8.2.6,1.1-.2,2,.5,1.1,1.1,1.1-.4.3-.2.9-.7-.1-.9.3-.7-.9h-.8l-.4-.4.4-.9-.1-.6-1.2.4v.4l-.4-.1.1.4-.5.5.2.4-.7.3-.9-1.1-.2.2-.4-.1-.1.3-1.3-.7-.7.7h-1l-.3-1.1.2-.4-.3-.4-.7.8.1.7-.5.8.2,1.7-1.3.4-1.3.8.2,1.5-1.4.8-.3-.2-1,.4-.3.4-.4-.6-.7-.2-.1.4.5.3-.1.7h-.4l-.1.9-.5-.7h-1l-.4-.4.3-.3-.2-.3-1.6-1,.1-1,.7-1.1.8.4.3.5.8-.1.5-.6.5,1.1.9-.5.3-1.1.8-.2v-.6h-.7l-.2-.5h-.5l.4-1.4.8-.4-.2-.9-.7-.1-.4-.7-.1-.9.4-.1-.1-.3.7-.8.9.9.9-.7.1-.6-.3-.3.5-.4-.3-.3.1-.4-.7-.7-.4.3-.1-.3.3-.7-.3-.3.1-.9-1.2-.6-2.2,1.3-.5-.6-2,.5-2.8-.7-.7.1-.5-.7.3-.7.7-.4-.8-.8.1-.4.2.4.4-.1-.4.6.8.1.4.7,1.7-.9.1-.5-1.5.1-.2.3-.7-.4.5-.6-.4-.7.1-.2.6,1.3.3-1-.3-.7.5-.3-.1-.3-2.8-.1.1.9-.7.4.1,1.3-.9.1-.2.4-1.9-.6-.1-.6-.4-.4-.3.2-.3-.7-.4.7.5,1.2-.1,1,.1-.4.9.4,1.4-.1.2.7H742l.1.7-.6.1-.3.7-.7.1-1.4-2.3-.4,1.8.7.3-.8.7.1.4-.7.2.1.7-.7.7,1,.4.6-.1v.5l.6-.1-1.1,1.6-.1.9-.5.6h1.8l.4.3.2.4-.4.4,1.7,3-1.1,1.5-.2,1,.5,2.3-.5.9.5.9-.5.1-.9,1.2-.7.4-.3-.2-.8.8-.5-.1-.7.7-.7.1-.6.7-.1.7-.8.8.5.7.3-.3,1.2.7.9-.2.3.5-.4.4.8-.1v.4l-.4.3-.7-.1-.9.9-.9.2-.5.7-1.8-.4-1,.8h0l-.6-.5.1-.4-.7-1.2-.6-.1-.4.7-.9-.4.1-1.5-.5-.4h-.9l-.1-.6-.7-.1-.3-.7-.4.1-.1.5-.7.1-.9-1.8-.7.2-.3-.4-.6.7-.4-.7-.8.3-.3-.2.4-.9-.3-.7.4-1.2-1.3-.5-.9.7-.1-1.4-.4-.1-.9-1.2-.7.2-.2-.4v-1.3l.9-1.2-.3-1,.1-1-.7-.6.1-.7-.6.2-.1.7-.7.8-.7.3-.7-.7.4-.8-1.7-.7-.5-.7.9-2,.6.1.2-.7.3.1.3-.5-.3-.1-.7.4-1.3-.7.4-.5-.2-1.2-.7.5-.6-.3-.2.2-.6,1.4.4.4-1,.7-.9-.7-2,.1-.6-.9.1-.7-1.7-.3-.7-.6-.7.9.1.7-.7.1-.4-.9.1-.7h0l-.8.1-.5-.9h0l-.9.2-.7-.7.4-.4.7.2.4-.5-.6.1-1.3-.4-.3.4h-.7l-.6-.5v-.7l-.5-.1-1.6,1.4-.4-.7-.7-.1-.3,1.2-.7-.3-.2-.8-2.1.7-.3-1.2-2-.1-1.6.9-.5-.5-.8.7-2.9-1.2h0l-2.5-4.2-.7-3.5-2-2-.4-.9-1.1-1.2.2-2.2-.4-3-.7-.1-1.2.5-2,.2-1.9-.7-2.7-4-.2-2.2,1.4-2.9.1-4-.2-1.1-1.5-.8-2.8.3-.9-.2-1.4-1-3.3-1.6-.4-1,.4-3.5,1-2.5,4.3-4,1.1-1.7,1.2-.9,1.4-3.6.7-1.2,3.2-3,1.8-.4,1.2.2,1.7,1.8.1,1.3,1.2,2.1,2,.3,5.9-2.5,2.1-.4,3.8-.1,3.6-1.5.6-2.9.9-1.4,2.9-2.6,1.8-5.3,1.2-1.7,4.9-3,3.5-1.6.9-2.1,1.4-1.7,2.7-5.3,1.8-6.6,3.3-1.4,2.7-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"725.32","cy":"186.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Rajasthan")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"gujarat"}},[_c('path',{attrs:{"d":"M660.87,255.2l.4.5-.3.4-.7-.5Zm-7.4-.3.1.2-.9.7.1-.7Zm13.2-1.9.3.4-1.1.3.1-.4Zm-21.9-11.7.8.3v.4l-.7.1v.3l-.6-.4.4-.1Zm.4-1,.4.4v.4l-.6-.4-.1-.4Zm-1.6-1.7.4.4-.1.9-.4-.2.1-.6-.6.6-.1-.1Zm.1-1.9v.6l-.8.9.1-.8Zm-.4-.5.1.4-.4.2-.1-.5Zm-1.5-3,.6.4.4-.1-.6,2.3L641,237l-.6-.1.3-.1-.3-.3-.5.2.1.3h-.2l.1-.3-.4.1-.2-.4.3-.4h1l.9-1.2Zm-.6.2.1,1.1-.7.5v-1.4Zm2.7-.6.3,1.2-1.2.3.3-.6-.1-.5Zm-1.6-.5h.4l.2.9-.9-.1-.1-.4Zm.8-1.2v1.1l-1-.1-.4.5.1-.8Zm1.3,0,.4.4.4.1-.9.9-.4-.1.1-.4.7-.5Zm-.7-.9.6,1.2-1.2,1.2.4-1.4-.2-.3-.4.1.3-.7.5-.1Zm-.8-.1-.3,1-1,.6-.1,1.4-.2.2-.3-.3-.6.5v1.7l-.4.2-.7-.8.7-.7-.4-1h.4l.7-1.3.9-.1.4-1,.6.2.3-.6Zm40.4-11.2,2.9,1.2.8-.7.5.5,1.6-.9,2,.1.7.7,2.1-.7.2.8.7.3.3-1.2.7.1.4.7,1.7-1.3.5.1v.7l1.2.7h.7l.3-.4,1.3.4.6-.1-.4.5-.7-.2-.4.4.7.7.9-.2h0l.4.9.9-.1h0l-.1.7.4.9.7-.1-.1-.7.7-.9.7.6,1.7.3-.1.7.6.9,2-.1.9.7,1-.7-.4-.4.6-1.4.2-.2.6.3.7-.5.2,1.2-.4.5,1.3.7.7-.4.3.1-.3.5-.3-.1-.3.7-.6-.1-.9,2,.5.7,1.7.7-.4.8.7.7.7-.3.7-.8.1-.7.6-.2-.1.7.7.6-.1,1,.3,1-.9,1.2v1.2l.2.4.7-.2.9,1.2.4.1.1,1.4.9-.7,1.3.5-.4,1.2.3.7-.4.9.3.2.8-.3.4.7.6-.7.3.4.7-.2.9,1.8.7-.1.1-.5.4-.1.3.7.7.1.1.6h.9l.5.4-.1,1.5.9.4.4-.7.6.1.7,1.2-.1.4.6.5h0l.7,1.4-.4.3.3.5.6.6.8-.4.4,1.1-1.2,2.1-.3,1.4H732l-1.7,2.1-1.3-.6-.5.7.1.3.7-.3-.1.7h.4l.3.7.3-.6.2.4.4-.2.1-.6.2.7.7.1.6.7-.6-.1-.4.7-.3-.1-.2.7-.9-.1-1.4-1.1-.6.2-.2,1.2.5.7-.2.4.7.1.1,1.9.4-.1.4.3-1.2,1.2.9.4-.1.5h0l-5.1,2.1.5.5-.2.4,1,1-.1.9-1.4.4.6.4.6,1.7,3.2-1h1.7l.4.4.4-.3.5.2.5-.5.4.4v.7l-1.2.5-.3-.3-.1.4-1.4-.1-.3.3-.7-.6-.3,1-1.2.4-.2-.1-.1,1.7-.9.6-.9-.1-.1,1.5-1.2.1-.1.4-.9-.2-.7.3-.4-.7-.4.1,1.1.9,1.4-.1-.1.9.5.7.5-.2.1.4,1.4.2-.1.7.7,1.6.1,1.6-.4.3-.5-.1-.4.6h-.6l.4.4-.1.8-1.4.8-.7-.1-.4.3-.5-.3-.4-.9-1-.6-.6.4-.2-1-.4.1-.2.7-.6.4.6.8.6.2v.7l.3.1-1.1,1.9-.6.4.5.6.1,2.3-.9.2-.1-.4-.2.2-.7-.1-.4.9-1.1.4H715l.5-.7-.3-.3-.9-.1.1.6-.4.3-.4-.3-.1.3-.1-1.2h.5l.7-.9.3.1-.3-.5-.7.2-.1-.9-.2.6-.7-.1-.1.5-.4-.4v.4H712l-.1.4-.6-.4-.4.2.7,1.1h0l-1.4-.2-.6.7v.7l-.5-.1v.4l-.9-.2h0l.3-2.5,1-1.3.9-2.1.2-1.4-1.7-5v-.9l-.4.1-.7-1.8.7-.3-1-.1.2-1.1-.8-.2-.1,1.1-.5.2-.1-2.2-.4-1.1.6-1.4,1.1-1.4-.8.5.4-1.4.4-.2-.4-.1-.9.8-.4-.9.5-1,1.1-.6,1.3.1.7-.4-.9.1-.7-.4-3,.4-.4-.6.5-.6.4-1.4-.8-.5-.2-1.6.7-3.2.5-.8,1-.3,1.6.7.9-1.2,1,.4.3-.2.2-.7-.3.5-.4.1-.4-.7-1.4.9-.9-.1-.8-.7-1.4.7-.1-.5-.8,1.2.1-.7h-.4l-.6-1-.5-.4.3-.7-.5-.4-.3.2.5.4-.3.7.6.2.1,1.2-.3.4-.7-1.2.1,1.1.4.6-.2.3-.3-.6-.2.9-.3-.1-.7,3.2-.6-1.9.7-.4.1.1V261l-1,.9v.7l-.2,1.1.5.8.2,2.6.7,1.8L700,272l-1.4,1.7-.2.8-.5-.3.3.4-.2.5.5.8-1.4.7-.1.4.1-.9-.5,1.1-2.4.8-.4.2.1.3-1.4.3-2.3,1.2h-.8v.4l-1.2.9-.9-.1.1.3-2.7.9-.8.4-.1.4h-.9l-.2.4-1.7-.1-1.1.5h0l-.5-.7h0l-.1-.1h.4v-.5h.5v-.5l-1.2-.4,1.3-.6-.1-1-.7-.4-1.2.1-.4-.4-.9,2.4-.1,1.3h0l-.9-.4-2.7-1.4-5.1-4-5.9-6.9.8-.8-.4-1.2-.2.3-.7-.1.7.6-.4.1.4.4-.3.5-7.2-6.5-4.2-4.8-.4-1.2.7-1.7,1.2-1.1.3.1-.7.7.4.6,1.9-.4.1.4-.7,1.4,1.2.9,1.3-.6.2-.7,1.3.2,1-.4.6-.9-.4-.8.8.5.1.8,1.4-.1.1-.6h.5v-.8l-.4-.1.9-.4.2.7.2-.2.6.7.6-.9.5.1.9-1,.4.2-.1-.6,1.3-.6.4.3,1.4-.1,1.2-1.8.1-1.2.7-.4.8-1.9,1.1-1,1.1-2.3-.9.2-.6.5-.2,1.4-.6.3-1.7-.8-.3.4-.9.2-.6-.3.1.6-5.1,1.2-.7.5-.7,1.3-.9-.4-.7.1-.7-.6-1.2.3-1.8-.9-2.4-.1-5.8-3.8-.9-.2-2.5-2.2-.1-.3,1.3-.6-.5.1-.1-1.3-.5-.6-.7-.1v-.5h-.4l-.5-.7-.2-2.7.1-.4.3.1.1-.6,1.7-1.1.5-.8,1.1-.6-.3-.2-1.7.3-1.2,1.3-.1-1.1.5-.1.4-.7,1.4-.7-.7.1-.4-.4-.1.3H644l-.4-.4.1-.3h3l.4-5.5.8-.2.4,1.7.6.2.9-1.4.8.9,1.4-.7,1.6.6,1.7-.7,2.9.4,1.5-.4,1.9,1.7,4.2.1.9-.4.9-1.6,6.9-2.2.6.4-.6.9.2.6v.8l1.2.4h2.3l1.3-.6-.1-.6,1.2-.9.6-.2.7.2,1.3-.9-.2-.5-1.7-.2.1-1.3-.2-.3.4-1.4,1.3-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"694.27","cy":"246.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Gujarat")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"daman-and-diu"}},[_c('path',{attrs:{"d":"M676.77,282.7l.1-1.3.9-2.4.4.4,1.2-.1.7.4.2.9-1.2.6,1.2.4v.5h-.4v.5h-.4l.7.9h0l-.3-.1.1.2-.8.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"678.52","cy":"281.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Daman and Diu")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"dadra-and-nagar-haveli"}},[_c('path',{attrs:{"d":"M715.07,292.9l-.4,1.1-.7-.5-1.2-.2-.1.5-.7-.7.1-.4-.4.4-.2-.3.2-.7-.2-.7h0l-.7-1.1.4-.2.6.4.1-.4h.4v-.4l.4.4.1-.5.6-.1.2-.6.1.9.7-.2.3.5-.3-.1-.7.9-.5.1.1,1.2.2-.3.5.3.4-.3-.1-.6.9.1.3.3-.5.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"712.59","cy":"291.95","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Dadra and Nagar Haveli")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"maharashtra"}},[_c('path',{attrs:{"d":"M729.17,263.4l.8.4,1.4-.1.2-.5.8-.2.5-.7.9-.1.1.9.7.3.5.7-.4,1.7.1,1.3.7.1.1.6,3.5,1.2,1.7-.3,2.4,1.1.9,1.7,1.6.8,1.2-.1v.4l.9-.2.6.4,1.1-.2,1.2.4.9-.4.9.2,3.3-.3,1.2.1,1.3.7.7-.4.9,1.9-.2.4.4.8-.1.3-.8.1.9,1.3,1.4-.1.3.3h1.4l1.2-.6.5-1.3,2,.1.6-1.4-.6-.9,2.4-2.1.1-.4-.4-.5.4-.3.1-.9.6.1.3-.4.7.2,2.6-2,1.3.1.2-.2.6.6.3-.4.9-.1.1-.7,2.9-.1,1,1.2.4,1.2v1l.6.3-.6.2-1.7-.4-.6.4.3,1,.5.3.3,1.3,1.4.2.3-.1-.1-.4h.7l.2.4.4-.4.2.7.4-.1.2-.4.7-.1.1-.4,1.2.6.9-.1,3.5-1.8.1-.9,1.3-.2-.1-.6.6.4.5-.3.4.2.3-.7.7.3.1,1.6,1.2-.4.9.2.3.4,2,.4.4-.4.4.4.2-.4,1.4.1.2-.3.6.2.1-.4-.6-.7.4-.1-.2-.5,1.2-.4.2.3h1.2l.9-1,1.1.1.1-1.2,1.8.7.7.1.3-.3,1.1.3.7,2.1,1.7-.2,1.3-.7,1.9,1.2.9.1.3-.5.9.4,1.1-.4.8-.9,1.1-.4,1.1.2,1.7,1.6.6,1.4-.6.5.2.5.6.1.1-.5.6.1,1.7,1.2.9-.1h0l.2.5-.6.8-2.7,1.2-.4,1.2.2,1-.4.4.5,1.2h1.3l.1,2.7.5,1.3-1.1.4-.4.6.4.5.9-.4.9.1-.6,3.3.5,1-1.2.4-.5.6-2,.4.5.8-.2.7.1.3,1.6.1.7.4.1.7v1.2l-.4.9-.6.1-.6-.4-.6.4v.4l1.2.1.2.5-1,.9-.5-.1-.1.4h.9l.4.4-.1-.9,1.1.1-.1.7,1.9,1.3-.1,1.3.9.1.7.7.9.1.3.5.5.1.2.9-1.6.7.9,1.1-1.4,1.2-.9.1-.2-.7-.9.3-.7-1.5-1.4,1.1-.8,1.1-.8.4.1.8-.9.7-.1,1.1-.8,1.4v.9l1.2,1.7-1.1.9-.5.1.4.7h0l-1,.4-.2.4-.4-.4-.7.3-1.5-1.4-1.5-.7-.6-.7.7-.4-.1-2.6-.3-.4-.9.2v-1.1l1.3-1.1-.4-.9.7-1.2.1-1.7-.5-1-1.7-1.2-.7-.9-.7-.1-1.5.4-.7,1.2-.7-.3-.1-.4-1.1.8-1.5-1.2-.9.1-.1-.4-.9-.4-.1,1.4-.4.6.2.4-.7.1-1.2-1.1-1.2-.2-.4-.4-.6.1.4-.5-.1-1-.8-.3-.9.2-.2-1.7-.9-.4-1,.2-1.7-.8-1.2-.1-.5.4-.3-.4-1.2-.3-.2-.7-.7-.1-.2-.5-.4,1.1.7.1.4.9-.4,1.1-.9.4-.2.4.7.9v.5l-.5.2.4,1.6-2,.7.2,1.3-.4,1.5-1.3-.3-.5.2-.1-.4-1.4-1.2-1.3.7v.3l.7.3-.6.2-.3.9.2.3-.4.7.2.7-.7-.2-.1.8-.6-.1-.1.5.1.7h.7l-.1.5.7-.1-.2.7.7.1.9,1.4-1.6.2-.8,2-.4-.4-.4.5.1,2-1.2.4-.1-.4-.8.1.1,1.2-.4-.1-.4.4.6.3-.9.3.4.1-.6,1.1.7.5-.2.4h0l-.6-.2v.4l-.7.3-.4-.7-1.2-.1.8-1.2-.6-.2v-.7l-.4.3-.4-.4-1.2.7.1.6-.7.9.1.6-.5-.1-.3,1-.8.4.2.7h-.7l-.4-.5-.1.4-.6-.4-.5.1-.5,1.1.7.3-.3.4.1.5-.6.1v1.9l-1.7.7-.9-.4-.1.7.8.5-.4.7-.7.1.2.7-.4.1-.1.7-.4-.1-.7-1.3-.7,1v-.9h-.7v.7h-.6l.1.9-.9.3-.2.7-1.3.1.1.8.4.4-.4.4h.5l-.7.4.1.6h.6l-.1.9.7.1-.4.9h-.4l-.1-.7-1,.3-.5-.7-1.1.4.1.8-.2-.7-.7-.4-.7.6-.4-.2-1.9.4-.6-.4-.1-1-.4.5-.6-.6-.4.8-1-.8-.7.1-.2-.7-.7-.3-.3,1.4-.6.1.1.5.4.1-.1.7.8.7v.9l-.5.6.7,1.2v.5l-.5.4h.4v1.2l-.4.1-.5-.3V343l-.5-.1-.1.7-1.2.4-.4-.7-.6.4-.6-.2-.7.4h-.9l-.1,1.3-1,.5H744l.1-.5h-.7l-.8-1.2-.9.4v-.3h-1.4l-.1.2.6.3-.1.4-.8.4.1,1.4h-1l-2.4.9v.7l-.6.6.4.5h-.7l-.1.5-.9.4-.4-1.3-.8.1-.3-.6-.1.9-1,.4-.2.8-.4-.1.1-.3-.6.1-.2.8-.6-.7.1.7-.5.1.2.3.5-.4-.1.7.7.1.1.8.4.1-.1.4-.3-.4-.3.1v.9l.4.5-.2.4.3-.4,1,.1v.4l1.2.4.1.7-.4.7.1.9-.8-.4-1,.9.4.3.7-.4.5.3-1.2,2.2.3.7h-.1l-.3-.7-.4.7.7.1-.4,1.1-1.1.5h-.1l-.4-.7-.4.5-1.1.6.1.7-.6.1.4.3h0l-1.4.7-.4-.1-.4-.5L726,363l-.9-.1-.2-.7-.5.9-2.3.2h0l-.5-.4.4-.1-1.3-2.5-1.2-.4-.4-1.5-.4-.3.2-.3-.5-2-.7-2.5h-.3l.6-.7-.6.1V352l-.8-1.5v-.7l.4-.1-.4-.6.4-.6-.3-.1-.1-2.6-.5-1.4.3-1.4H716l.2-.4-.4-.2.7-.8-.5-.6-.7-2.5-.5-.5.5-.1.1.4.2-.4-.6-1.2-.6-.4.6-.5-.3-.1v-1.2l-.7-.8.5-.4-.7-.9-.2-.9.3-.4-.7-1.4-.2-1.4-.2.1-.5-.9.1-.7-.7-1.1.2-.4-.5-.9.2-1-.9-.4.1-.9h.4l.2.6,1.3.3-.2.6.5.6-.1-1.2-.4-.7-.9-.1-.7-1-.6-.3.2-.5-.4-1.4.5-1.1-1.2-2.5.2-1.7.7.2.4-.6.4.6.2-.3.1-.9-.9.2-.3-.8.7-.1-.3-.6.2-.4.4.2.8-.6h-.4l-.1-.9h-.4l-.1.5-.7.6-.7-.2-.3,1.2-.6.5.2-.8-.5-.1.4-1.2.2.1.1-.4-.4-.1.1-.8-.7-1.2v-1.7l.3-.8-.7-.7-.2-1.4.6-.4.1-.6.1.3-.7-.6-.1-.9h.4l-.8-3.1-.6-.7v-.3l.4-.1-.3-1.1.8-.7-.1-1.6.4-1.1h0l.9.2v-.3l.5.1v-.6l.6-.7,1.4.2h0l.2.7-.2.7.2.3.4-.4-.1.4.7.7.1-.5,1.3.2.7.5.4-1.1h0l1.1-.4.4-.9.7.1.2-.2.1.4.9-.2-.1-2.3-.5-.6.6-.4,1.1-2-.3-.1v-.7l-.6-.2-.6-.8.6-.4.2-.7.4-.1.2,1,.6-.4,1,.6.4.9.5.3.4-.3.7.2,1.4-.8.1-.8-.4-.4h.6l.4-.6.5.1.4-.3-.1-1.6-.7-1.6.1-.7-1.4-.2-.1-.4-.5.2-.5-.7.1-.9-1.4.1-1.1-.9.4-.1.4.7.7-.3.9.2.1-.4,1.2-.1.1-1.5.9.1.9-.6.1-1.7.2.1,1.2-.4.3-1,.7.6.3-.2,1.4.1.1-.4.3.3,1.2-.5v-.7l-.4-.4-.5.5-.5-.2-.4.3-.4-.4h-1.7l-3.2,1-.6-1.7-.6-.4,1.4-.4.1-.9-1-1,.2-.4-.5-.5,5.1-2.1Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"761.17","cy":"298","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Maharashtra")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"goa"}},[_c('path',{attrs:{"d":"M722.07,362.3l2.3-.2.5-.9.2.7.9.1.4,1.5.4.5.4.1,1.4-.7h.7l.2-.4.4.5.3-.3.4.2.2.7-.2.7.5.7-.5.6.4.7v.9l.7.4.2,1.2-1.3.6.7.5.2.6-.5.7-.1.7.4.9-.6.8.1.4-.9.7-.6-.4.1.7-.6-.2-.7.4h0l-.8-.4.1-.7-1.3-1.7-.9-.3.6-.9-.8-2.9-.3-.6-.5.1-.9-.8,1.4.2.3-.3-.7-.6-.9-.1.3-.5h-.6l-.4-1.9Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"727.47","cy":"368.7","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Goa")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"karnataka"}},[_c('path',{attrs:{"d":"M728.87,363.5l-.4-.3.6-.1-.1-.7,1.1-.6.4-.5.4.7h.7l1.1-.6.4-1.1-.7-.1.4-.7.3.7h.3l-.3-.7,1.2-2.2-.5-.3-.7.4-.4-.3,1-.9.8.4-.1-.9.4-.7-.1-.7-1.2-.4v-.4l-1-.1-.3.4.2-.4-.4-.5V352l.3-.1.3.4.1-.4-.4-.1-.1-.8-.7-.1.1-.7-.5.4-.2-.3.5-.1-.1-.7.6.7.2-.8.6-.1-.1.3.4.1.2-.8,1-.4.1-.9.3.5.8-.1.4,1.3.9-.4.1-.5h.7l-.4-.5.6-.6v-.7l2.4-.9h1l-.2-1.4.8-.4.1-.4-.6-.3.1-.2h1.4v.3l.9-.4.8,1.2h.7l-.1.5h.5l1-.5.1-1.3h.9l.7-.4.6.2.6-.4.4.7,1.2-.4.1-.7.5.1v.5l.5.3.4-.1v-1.2h-.4l.5-.4v-.5l-.8-1.2.5-.6v-.8l-.8-.7.1-.7-.4-.1-.1-.5.6-.1.3-1.4.7.3.2.7.7-.1,1,.8.4-.8.6.6.4-.5.1,1,.6.4,2-.5.4.4.7-.6.7.4.2.7-.1-.8,1.1-.4.5.7,1-.3.1.7h.4l.4-.9-.7-.1.1-.9h-.6l-.1-.6.7-.4H763l.4-.4-.4-.3-.1-.8,1.3-.1.2-.7.9-.3-.1-.8h.6v-.6h.7v.9l.7-1.1.7,1.3.4.1.1-.7.4-.1-.2-.7.7-.1.4-.7-.8-.5.1-.7.9.4,1.7-.7v-1.9l.6-.1-.1-.6.3-.4-.7-.3.5-1.1.5-.1.6.4.1-.4.4.5h.8l-.2-.7.8-.4.3-1,.6.1-.1-.6.7-.9-.1-.6,1.2-.7.4.4.4-.3v.7l.6.2-.8,1.2,1.2.1.4.7.7-.3v-.4l.6.2h0l.8.2-.6,1.2.5.8.1.8-.8.7.7.7.8.3.1.4-.1.4-.3-.2-.1.9-.5-.1.1.6h-.4l-.4.9-.4-.1-.2.4-.1.3.9.3-.1.3-1.7.9-.1,1.7.7.2.1.4.4-.5.3.4.7-.2v.5l1.4.4v.5l-.6-.1.1-.4-.2.4-.4.1v.4l-.6-.1v.4h-.9l.4.4-.1.5-.4.3-.7-.3-.3,1.3.3.2-1.2.9.3.1-.6.7,1.6.9.6,1.5-.7,1.5.3,2-.5-.1-.2,1.1.7.1v.5l-.7.2.2.4.6-.1-.1,1-1.1.3.4.7-.6.1-.2.4-1.1-.1-.8.9-.9.1.7,1,.9.4,1,.3,1.2-.2,1.4.6v.8l-.4-.1-.5.6-.5-.1-.2.3v.4h.4l-.4,1,.1.7.4.2-.3,1.2.3.4v1.3h0l-4-.6-1.6.3-1.2.7-.7,1.1.7.1-.3,1.4,1.2,1.2-.1.5-.5-.4-.8.3-.1,2.1-.9-.1v.2l.9.9.5,1.7.7-.1.1.6.5.1.2.4-.7.6.6.4v.7l-.4.1.4.4-1.2,1.9-.6-.1.1-.4h-.7l-.3.3-1.6-.3-1.2-.9-.4.3.1.9-.3.7.9.3.6-.2-.2,2.5-1,.4.3.7-.6,2.1.6,1.2.4.1.7.9,1.6-.1-.4.5v.7l-.4-.2-.4.4-.1.7,1.1.8-.4.4.2.5h1.7l.4.5.4-.1.1-1.2.6-.8,1.2.4.7-.3v.9l1.2.1-.1.6.4.6.5-.3-.6-1.3.1-.4.9.2.2.6h.7l.1,1.9-1.7-.2-.2.6-.4.1-.1.4.7-.4.1.2-1,1.2.9.2-.1.6h.9l-.4.5.3.4-.5.4v-.3h-.5l.1-1.3-.6-.7-2.5.5-.4-.8-1.4-.1-.2-.7.1-1.2-1.2-.2-.1.4-.7.1-.1.4.7.1.7.9-.8.6,1.6,1.5.1.4-.4.1-.7,1.2.4,1.1.3.1.2-.6.5.5.5-.4,1.1.1-.1-1-.6-.4.6-.1-.1-.7.3-.3v.9l.4-.4.1.3.4-.5.2.9.9-.3.2.5.6-.3,1,.1-.2.6h.7l-.1,1.9.5-.1.1-.4.4.4.1-.9.6.4.6-.4.4.2.2-.1-.4-.3.6-.3h.3l-.1.4.5-.1.2.4.1-.9,1-.4v-.4l.8-.4-.3-.7.2-.4,1,.1.4.5.9-.8.1.9-.5.2v.9h.3l.3-.7.8.1.1-.5,1.1.7.1,1-.5.7.4.4-.2.3-.7-.1-.1.4.4.5,1.1-.2.1.4.5.1-.1.9.7-.5,2.5.1-.5,3.5.7.4-.4.2.4.2.5-.2.1.4.6-.1.7.8.5-.7.3.6-.1.9-.4.3.4.5-.9.6.3.4-.4.2.1.4-.8.4.1,1.1-.5-.1.2,1.1-.9.1-.5-.5-.7,1.2h-.9l-.3,1.4h0l-1.5-.3-1.2-1.1-.5-.1-.2.8h-.3l-.6-.9-.3.6-.2-.1.4-.5-.2-.4-2,.7.2.7-1,1.9-.4-.1-.4.4-.4-.4-.9.2.1.6-.4.9.1.8.4.1-.5.5.7-.1-.1,1.1-.2.9-.9,1.1-1.1.4-.1.9,3.9.5.7.9-1.2,1.4-.4,1.1-2.7.1-.1.9-.4-.2.1.7-.6,1.4-.9-.4-.5.3-.7-.6-.7-.1-.2.3-1.9.3.1.8-.6-.2-.2-.8-.5.2.1-.3-.4-.3h-1.2l-.2.6-.9-.3-1.1,2.2.4.7-.2.4-.3-.4-1.1-.2h-2.8l-.3-.9-.6-.4-.9.1-.4-.1h0l-.4-.7.4-.2-.1-.6-1.1.4-.9-1.1-.8.1-.5-.9-1.2.2v-2.1l-1.7.7-1.8-.3-.8-.7-.4-1.3-1.2.1-.2-.6-.6.1-.4-.8-.9-.1-1.4-2.1h-.8v-1l-.9-.6V413l.9-.1-.1-.6-1.1.7-.1-.5-.8-.4-.1-.7.8-.4-.8-.4-.8.7-.3-.9-.7.1-.2-.2.1-.7-1-.4-.1.5-.5.1v-.9l-.7.1.1-.2-.4-.1.4-.5-.2-.4-1.9.6h0l-.7-1.5-1.9-7.7-.4-4.4-.9-3.6-.6-1.2-.6-.3-.4-.9-.4-2.5-.4-.7-1.3-4.3.6-.4-.4-.4-.1.5h-.7l-.2-1.2-.4-.4.2-.2-.3-1.2-.5-.5-.4.5-1.7-1.2.4-.1.1-.7h-.3l-.2-.7h0l.7-.4.6.2-.1-.7.6.4.9-.7-.1-.4.7-.8-.4-.9.1-.7.5-.7-.2-.6-.7-.5,1.3-.6-.2-1.2-.7-.4v-.9l-.4-.7.5-.6-.5-.7.2-.7-.2-.7-.4-.2-.3.3-.4-.5-.2.4h-.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"755.77","cy":"384.3","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Karnataka")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"kerala"}},[_c('path',{attrs:{"d":"M740,408.2l1.9-.6.2.4-.4.5.4.1-.1.2.7-.1v.9l.5-.1.1-.5.9.4-.1.7.2.2.7-.1.3.9.8-.7.8.4-.8.4.1.7.8.4.1.5,1.1-.7.1.6-.9.1v.7l.9.7v1.2h.9l1.4,2.1.9.1.4.8.6-.1.2.6,1.2-.1.4,1.3.8.7,1.8.3,1.7-.7v1.8l1.2-.2.5.9.8-.1.9,1.1,1.1-.4.1.6-.4.2.4.7h0v.6h-.7l-.4.6-.8.3-.4-.4-.7.4.2,1.6.6-.2.7.4.2-.2,1.2.4.6.8.9.5.4-.1.1.9-1.4.9.1.8.5-.4,2,.3,1.2-.7.4.4-.5,1,.7.4v1.2l.9.1-1.3.1-.9,1.7,2.5.9.4.8.7.1.1.4-.7,1.4.3.7-1,.1.4.7-.4,2.6.5.9-.3,1,.3.3.4-.2v.4l.7.7,1,.2,1-.6.2-.6,1.7-.9.9.1-.1.5.6.8-.1.5.5.2-.3,1.4-1.1.4.9,1.1.1,1-.4.1-.5,1.2.4.3-.2.5.4.4-.4.1v.9l-.3.1-.6,1.7h.7l.9.6.7-.4.3.4.2-.5.1,1.1.7.4-.3.7-.7.3-.4,1.6h-.4l-.3.6v1.2l-.4.4.2.6-.9.9-.2.8-.7.4.7,1v.5h.4l.6.9-.4,1.3-.6.7-.3-.1,1.7,3-.3.6-.9.1.4.9-1.2.9.4,1-.6-.1-.4.4h0l-1.8-1.3-5.2-6.9-1.3-1-.4-1.7-2.7-6.1-1.5-8.4.2-.1.7,1.2,1,1v1.9l.4.3-.5,2.4.4.3v-.3l1.8-.1-1.3-.5.2-.7-.1-.6-.3.1.1-.7-.5-.1-.1-2.5-.6-.9-.2.1.2.4-.2-.1-1-2.2.2-.7-.9-1,.6,2.5-.3.1-1.9-6.1-2.9-6.3-.8-3.5-1.9-5.1-.8-1.4-1-.4-1.2-3.1-2.1-2.4-.8-.4-1.4-2.2-.5-.3-.4.3-.3-1.4-3.2-6.2-1.6-4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"762.87","cy":"444.59","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Kerala")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"tamil-nadu"}},[_c('path',{attrs:{"d":"M807.17,460.7l.4.2-.3.4.1.3,1.7,1.6-2.2-1.4-1.3-.1-.1-.4.2-.2h.7l.8-.4Zm-16.5-52.4.1.6-.6.5,1.2-.1.4.6,1.2.7,1.4-.1v-.7h.4l.1-.7h.3l.1.4.4-.1v-.9l.6-.4.7-2.3h.3l-.5-.9.6-.6.7.2.1-.8.7.1,2-.7.1,1h.7l-.5-.2.3-.5,1-.1,1.4.9,1.3.1.6-1.2.4-.3v-.4l.7-.1.6.7.7-.5-.1-.5,1.2-.4v-.4l.4-.1-.1-.2-.4.3.2-1.1-.8-.4.8-.3,1.6.2.2.7.5.4,1.3-.6.1.8.4-.1-.1.4.5-.2.3.4.6-.4-.9-.7.5-.5.4.3.3-.4h.8l1.2-.5.4-.6-.3-.5.4-.2v-.6l.5-.1.1-.4.4.1-.1-.3-.7-.1.1-.3,1.2-.1,1.2.9h1.2l.7,1.4.6.3v-.8h0l.5,2.3-.7,2.1-.7,5.5-1.5,4.8-4.1,6.2-.7,2h0l-1.2-.5-.9.9-.3-.9.6-.2-.3-.2-.4.3-.4-.7-.5.5h0l.9.2-.3.6.4.1.3.6-.1.2-.5-.4-.4.6.7.4.7-.4.1.6.4-.2.3.5h0l-.7,3.8,1.2,3.2.2,5.8h0l-.8-.1-.3.3-.8-.3.2.7-.7-.1.4.9,1.2.4.1.8h.6l.4,8-.7.3h-1.4l-5.4-.7-1.4.9-1,1.8v.8l.6.8-1.8,1.7-.5,1.2-2,2.2-.9,1.5-.6,2,.7,1.2,1.9,1.6,2,.3-1.4.4-2.1-.2-1.2.2-2.2.7-.1.3h-.9l-.2.3.2.2-1.2.4-2.5.3-3,2.3-.6,1.2-.1,1.7.4-.1.7.4-.9.1-.9,1.4-.1,1.1.7-.1-.1,1.4-1,1.2-.2.6.3.1-4,1.9-.9,1.1-2.6.7-.4.9-3.5-.7-3.3-2.7h0l.4-.4.6.1-.4-1,1.2-.9-.4-.9.9-.1.3-.6-1.7-3,.3.1.6-.7.4-1.3-.6-.9h-.4v-.1l-.7-1,.7-.4.2-.8.9-.9-.2-.6.4-.4v-1.3l.3-.6h.4l.4-1.6.7-.3.3-.7-.7-.4-.1-1.1-.2.5-.3-.4-.7.4-.9-.6h-.6l.6-1.7.3-.1v-1l.4-.1-1-.9.2-.5-.4-.3.6-1.2.4-.1-.1-1-.9-1.1,1.1-.4.3-1.4-.5-.2.1-.5-.6-.8.1-.5-.9-.1-1.7.9-.2.6-1,.6-1-.2-.7-.7v-.4l-.4.2-.3-.3.3-1-.5-.9.4-2.6-.4-.7,1-.1-.3-.7.7-1.4-.1-.4-.7-.1-.4-.8-2.5-.9.9-1.7,1.3-.1-.9-.1v-1.1l-.7-.4.6-.9-.4-.4-1.2.7-2-.3-.5.4-.1-.8,1.4-.9v-.9l-.4.1-.9-.5-.6-.8-1.2-.4-.2.2-.7-.4-.6.2-.2-1.6.7-.4.4.4.8-.3.4-.6h.7V425h0l.4.1.8-.7.6.4.3.9h2.8l1.1.2.3.4.2-.4-.4-.7,1.1-2.2.9.3.2-.6h.5l.4.3-.1.3.5-.2.2.8.6.2-.1-.8,1.9-.3.2-.3.7.1.7.6.5-.3.9.4.6-1.4-.1-.7.4.2.1-.9,2.7-.1.4-1.1,1.2-1.4-.7-.9-3.9-.5.1-.9,1.1-.4.9-1.1.2-.9.1-1.1-.7.1.5-.5-.4-.1-.1-.8.4-.9-.1-.6.9-.2.4.4.4-.4.4.1,1-1.9-.2-.7,2-.7.2.4-.4.5.2.1.3-.6.6.9h.3l.2-.8.5.1,1.2,1.1,1.5.3Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"792.47","cy":"434.95","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Tamil Nadu")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"puducherry"}},[_c('path',{attrs:{"d":"M815.47,438.2h-.6l-.1-.8-1.2-.4-.4-.9.7.1-.2-.7.8.3.3-.3.8.1h0Zm-.8-15.2-.3-.5-.4.2-.1-.6-.7.4-.7-.4.4-.6.5.4.1-.2-.3-.6-.4-.1.3-.6-.8-.2.5-.5.4.7.4-.3.3.2-.6.2.3.9.9-.9.6.4h0Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"814.17","cy":"421.85","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Puducherry")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"andaman-and-nicobar-islands"}},[_c('path',{attrs:{"d":"M947.67,453.3v.4l.6.2.1,1.8.9,1.3h-.5l.5.7-.4.1-.3.7.1,1.4-.3.3-.5-.4-.4.9-.4-.1.1-.8-.4-.2-.1-.9-.6-.5.1-.6-.8-.8-.4.1-.1-1.4.3-.2-.3-.2.4-.9.7.1.4-.4.7.2.1-.5.5-.3Zm-2-3,.7,1.3-1.7,1.8-.4-1,.1-.9,1.2-.4.1-.8Zm-5-8.7.4.3.1.7.3-.1.5.6-.1.9-.6-.5-1,.3-.2-.4.2-.4-.6.1.1-1.1Zm2.5-.1.6.6-.1.9-1.1-.9.4-.6.3.4-.1-.4Zm.4-1.5.2,1.3-.5-1.2.3-.1Zm-.8-1.5.3.5-.7.7.7.9v.8l-.3-.2-.4.2-.1.6-.2-.7.3.1.1-.4.1.4.2-.5-.7.4.1-.6-.4-.4-.1-.8Zm-4.4-.6.1.7-.3-.4Zm-1.7-1.4.3.1-.3,1.1,1.2.9-.1.4-1.2-.4-.6-.7.1-1.1Zm-1.2-1.7.2.5-.4-.1Zm8.7-1.5.4,1.6h-.2l-.1.7ZM931.77,423l.6.7.4-.2-.4.2.1.8-.7.4-.9-.1-.1-1.4h.7l.1-.7Zm-4.1-25.2.2.5V398l.4.4v.9l.4.2.1,1.7-.9,1,.4.5-.9,1-1.2-.6-.7.2.5-1.2-.6-.8-.1-1.7.3.4.9-1.5.7-.4.1.4.4-.7Zm1.8-9.3.7,1.2-.6.4.7.3v.3l-1.4.4-.3-.3.1-.5.6-.1-.1-1.1.3-.6Zm-.6-.5-.2.1.1-.7Zm-5.7-.8.8.1v.9l-.9-.1Zm4.8-.2.4.2-.6.5.2-.7Zm7.2-3.7.8.1-.4.4-.5-.2Zm-.8-2.9.2-.1.4.4.7,1.8-.1.4-.7-1.1h-.4l-.7-.7.6-.7Zm.3-1,.1.9-.5-.4-.1-.5Zm.6-.8.3,1.7-.6-.5v-.5l-.8-.5.4-.1.3.4.4-.5Zm.7-.8.4,1.1-.3.9-.6-.7Zm-5.5-.5.1,1.1.7-.1-.4,1.4.9.4-.3.4-.4-.3-.1.4.5.3-.7.6.1,1.7.4-1.2.6-.1.1.5-.5,3-.2-.1-.1.4-.6-.3.1.6-.7.2.1.4.2-.2.1.3.5-.6-.1-.4.5.3-.7,2.9-.2-.4-.8-.2v-.8l-.4.1-.1-.9.4.1.1-.3-.2-.2-.4.2-.3-1.3-.4.4-.2-2.2-.4.1-.1-.4.7-1.5.4.9.2-.1v.6l.1-.2.2-3.5,1.3-2Zm.5.3h.3l-.1.5-.4-.1Zm2.4-.6.2.5-.4-.1-.1.3-.1-.4.4-.3Zm2.7,0,.1.4.3-.4-.1.9-.6-.4Zm-2.1-.3-.3.8-.3-.9.4.1.1-.4Zm-2.4-.5.9.3.4-.2.4.6-.4.3.4.8h-.5l.1.6-.4-.1-.3.5.1.4-.7.7-.4-.5.4-2.2-.4-.1.1-.4.2.1.3-.4-.2-.4Zm16-.2.5.5.1.8-.9-.1-.2-.7.5-.5Zm-13.4-1.4-.4.9-.2-.1.1-.8Zm-3.6-6.4.1,1.7-.4-1.2Zm2.8-1.3.4.1-.2.4h.4l.4,1.2-.3.5.7,1-.4,1,.1,2.2-.6.2v.2h.4l-.7.4v.6l-1.3-.4.9,1.7-.9.3-.9-.3-.2.4-.5-.1-.3-.4.1-4.1-.4-.1h.3l.7-.9-.4-.4.3-.4-.4-1.6.2.3,1.2-1.4.5.4h0l.4-.1h0l.5-.7Zm-3-1.2.4.2v1.4l-.3.7-.4.1.2.3-.3.5-.3-1.2.3-1.6.4-.4Zm4.6-.1-.4.4.1.5-.5-.1.1-.7.2.3.5-.4Zm.3-8.9.2.7-.1,1.4.1.5.2-.3.1.2-.2.4.5.7-.4.5-.5-.7-.4-.1-.3.4-.2-.5-.3.2.9.4.1.7.5-.1v.4l.3-.2-.5,1.4.1,1.5-.5.8-.6-.1.1.4-.6-.7-.3.1-.2.5.6.8-.4.4-.1-.6H933l-.4.9.3.7h0l-.4.1h0l-.7-.6v-1.1h.4l.1-.4-.6-.1.1-1.1.4-.1-.2-.5.6-.2-.6-.2.3-1.3.4-.3-.5-.3.3-.4-.3-.1.3-1,.4-.1-.4-.2h.4l.2-.4-.2-.7.9-.5-.2-.5.7-.1.4.3v-.7l.4.5.2-.7Zm-.1-1.6.2.8-.8-.4Zm9.4-18.9-.4,1v-.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"932.27","cy":"372.15","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Andaman and Nicobar Islands")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"andhra-pradesh"}},[_c('path',{attrs:{"d":"M852.77,346.7l-.3,1.8-.6-.8v-.6l.9-.4Zm-.6,0-.1-.4-.2.3-.9.1v-.5l-.7.4,1.2.6h0v.7l.3.1.5,1.1-5.6,2.7-3.4,1.3-2.7-.8-2.2.3-2,.9-1.9,4.1.1.7-2.1,2.2-.2.4.3.7-.7.6-2.2.3-.7-1.1.2-.6h.3l-.1-.4-1.8-.7-2.2.4-1.6.8-1.4.9-1.1,1.2-1,3.3-1.5,2.5-.8,3.6,1,5.4,1.3,2.2-1,7.2,1.7,4.7-.1,2.7,1.2,3.2-2.2-4-.4-.2-.1,1.4-.4-.4.2-.4-.3-.1-.9,1.3,1.7,1.5h1.2l1.2,1h0v.9l-.6-.3-.7-1.4h-1.2l-1.2-.9-1.2.1-.1.3.7.1.1.3-.4-.1-.1.4-.5.1v.5l-.4.2.3.4-.4.6-1.2.5h-.8l-.3.4-.4-.3-.4.7.9.7-.6.4-.3-.4-.5.2.1-.4-.4.1-.1-.8-1.3.6-.5-.4-.2-.7-1.6-.2-.8.3.8.4-.2,1.1.4-.3.1.2-.4.1v.4l-1.2.4.1.5-.7.5-.6-.7-.7.1v.5l-.4.3-.6,1.2-1.3-.1-1.4-.9-1,.1-.3.5.5.2h-.7l-.1-1-2,.7-.7-.1-.1.8-.7-.2-.6.6.5.9h-.3l-.7,2.3-.6.4v.9l-.4.1-.1-.4h-.4l-.1.7h-.4v.7l-1.4.1-1.2-.7-.4-.6-1.2.1.6-.5-.1-.6h0l.3-1.4h.9l.7-1.2.5.5.9-.1-.2-1.1.5.1-.1-1.1.8-.4-.1-.4.4-.2-.3-.4.9-.6-.4-.5.4-.3.1-.9-.3-.6-.5.7-.7-.8-.6.1-.1-.3-.5.2-.4-.2.4-.2-.7-.4.6-3.5-2.5-.1-.7.5.1-.9-.5-.1-.1-.4-1.2.2-.4-.5.1-.4.7.1.1-.4-.4-.4.5-.7-.1-1-1.1-.7-.1.5-.8-.1-.3.7h-.3v-.9l.6-.2-.2-.9-.8.9-.4-.5-1-.1-.2.4.3.7-.8.4v.4l-1,.4-.1.9-.2-.4-.5.1.1-.4h-.1l-.6.3.4.3-.2.1-.4-.2-.6.4-.6-.4-.1.9-.4-.4-.1.4-.5.1.1-1.9h-.7l.2-.6-1-.1-.6.3-.2-.5-.9.3-.2-.9-.4.5-.1-.3-.4.4v-.9l-.3.3.1.7-.6.1.6.4.1,1-1.1-.1-.5.4-.5-.5-.2.6-.3-.1-.4-1.1.7-1.2.4-.1-.1-.4-1.6-1.5.7-.7-.7-.9-.7-.1.1-.4.7-.1.1-.4,1.2.3-.2,1.2.2.7,1.4.1.4.8,2.5-.5.6.7-.1,1.3h.7v.3l.6-.4-.3-.4.4-.5h-.9l.1-.6-.9-.2,1-1.2-.1-.2-.7.4.1-.4.4-.1.2-.6,1.7.2-.1-1.9h-.7l-.2-.6-.9-.2-.1.4.6,1.3-.5.3-.4-.6.1-.6-1.2-.1v-.9l-.7.3-1.2-.4-.6.8-.1,1.2-.4.1-.4-.4h-.4l-.2-.5.4-.4-1.1-.8.1-.7.4-.4.4.2v-.9l.4-.5-1.6.1-.7-.9-.4-.1-.6-1.2.6-2-.3-.7,1-.4.2-2.5-.6.2-.9-.3.3-.7-.1-.9.4-.3,1.2.9,1.6.3.3-.3h.7l-.1.4.6.1,1.2-1.9-.4-.4.4-.1v-.7l-.6-.4.7-.6-.2-.4-.5-.1-.1-.6-.7.1-.5-1.8-.9-.9v-.2l.9.1.1-2.1.8-.3.5.4.1-.5-1.2-1.2.3-1.4-.7-.1.7-1.1,1.2-.7,1.6-.3,4,.6h0l1.4.1.8.6.9-.1,1.2.4,1.4-.5,1.7.6.5-.7.4.9.7.3.2-.4h.6l.2-.8.9-.4.3-1.6h.9l1.4-.8,2.3.4.9-.7,1.4,1.2.9.1.9-1v-1.1l.4.1.1.7.6.1-.1-1.2.3-.3,1.6-.7,2.2.4.7-.4.1-4.2.6-.8,2.5-.4,1.1-.7,2.3-.5,2-1.1.5.7.8-.1.6.9.9-.1,1.4-1.6.3-1.1-.6-.6-.7-.1.3-.7.6-.9,1.3-.3.7-.9.3.5.9.1.6.9.3,1.4.6.2.2.7.4-.6.8.6.1.4,1.6.4.7-.4-.7-.6.1-.7.4-.1-.1-.8-1.4-.4-.1.5-2-.8.4-.7-.3-.7.4-.4.4.8.4.1.6-.5.2-.9.9-.5,1.4.8-.3.5,1.3-.1,1.6.7.4-.4.1-1.5h.7l-.1-.9,1.3.4.9-.5,1.7-.3.3-1.4h1.3l.9-1.1.7.5.7-.1,1.2-1.4.1-1.4.4-.5-.3-.3,1-1.5.1-.6,3.1-1.7.1-.4-.5-.7h0l.7-.7,2.3-.9,1.1-1,2,.2.3.5.9.5.4-.1v-1.5l.4-.2.1.4.4-.1.1-1.6.4.3.1-.2-1.1-.5.4-.3.1-.8.5-.1.3-.5-.9-.1.7-.8-.4-.7,1.7-2,.4.6h.4l.1,1.1.4-.1-.3.7,1,.4.1.4-.5.7.1.6.7.7.5-.9,1.7-.7.4-1-.2-.4.4-.3.7.4.6-.1.1.7.6.2,1.3-.5.6.1.1-.9-.3.1-.4-.4,1.2-1.4-.9-.1-.1-.3.4-.3h-.7l.1-.8.6-.2,1.2-1.9,1,.5.1.4.2-.8.7.1.2-.5,1.2-.1.1-.5h.6l.2-.4-.9-1.1.5.1-.5-.5-.2.7-.4-1.2.7-.4.9.2.7.8-.1-.9h.4l.1-.4-.3-.8.2-.1.3.4.2-.2.1.7h-.3v.3l.6.1.2-1.1.5.4.4-.6-.1-.5.4-.5,1.1,2.2.4.1-.3.4.6,1.1.5.1-.6-1.1.7-.5,1.2,3,1.1.4,1.3-.1.8.9.7-.1.4-.4,2.7-.3.1-1.2.4.3.1-.3-.3-.3.6.1-.4-.3.5.1.5-.4-.2-.4.4-.4-.4-.7.9.5.3-.7,1.2-.7.3.8.4-.7h.7v-.4l-.5.1-.4-.7h1l.1-.6.6.1-.1.5.4.4h0l.7.4-2.7,3.1-.4,1.3L886,315.5l-1.7,2.5-3.5,3.3v.7l-6.1,3.1-2.2,1.5-.7,1.1-1.8,1.7v.7l-1,1.4-2,2.1-9.2,4.6-3.6,2.8-1.1,1.4-.6,1-.4.1.1.7.9.7.7-.2-.1,1.8-.7.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"821.87","cy":"353.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Andhra Pradesh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"telangana"}},[_c('path',{attrs:{"d":"M780.57,322l.2-.4-.7-.5.6-1.1-.4-.1.9-.3-.6-.3.4-.3.4.1-.1-1.2.8-.1.1.4,1.2-.4-.1-2,.4-.5.4.4.8-2,1.6-.2-.9-1.4-.7-.1.2-.7-.6.1.1-.5h-.7l-.1-.7.1-.5.5.1.1-.8.7.2-.3-.7.4-.7-.2-.3.3-.9.6-.2-.7-.3v-.3l1.3-.7,1.4,1.1.1.4.5-.2,1.3.3.4-1.5-.2-1.3,2-.7-.4-1.7.5-.2v-.5l-.7-.9.2-.4.9-.4.4-1.1-.4-.9-.7-.1.4-1.1.2.5.7.1.2.7,1.2.3.3.4.5-.4,1.2.1,1.7.8,1-.2.9.4.2,1.7.9-.2.8.3.1,1-.4.5.6-.1.4.4,1.3.2,1.2,1.1.7-.1-.2-.4.4-.6.1-1.4.9.4.1.4.8-.1,1.5,1.2,1.1-.8.1.4.7.3.7-1.2,1.5-.4.7.1.7.9,1.7,1.2.5,1-.1,1.7-.7,1.2.4.9-1.3,1.1v1.1l.9-.2.3.4.1,2.6-.7.4.6.7,1.2.3,1.5,1.4.7-.3.5.4.2-.4,1-.4h0l1.2,2.1,2.2-.7,2.2,1.7.3.7.7.6-.1.3.5.1-.1.4.4,1.3.7.7-.9.6v.7l.9.1.5-1.1.6.4-.3.1.2,1,1.7-.6-.4,1.4,1.4,4.6.7.1,1.3-1.1,1.4.7,2,.1h0l1.2-.3.4.4,1.3-.4.7.2.8-.9.4-.1.2.4.9-.5h0l.5.7-.1.4-3.1,1.7-.1.6-1,1.5.3.3-.4.5-.1,1.4-1.2,1.4-.7.1-.7-.5-.9,1.1h-1.3l-.3,1.4-1.7.3-.9.5-1.3-.4.1.9h-.7l-.1,1.5-.4.4-1.6-.7-1.3.1.3-.5-1.4-.8-.9.4-.2.9-.6.5-.4-.1-.4-.8-.4.4.3.7-.4.7,2,.9.1-.5,1.4.4.1.8-.4.1-.1.7.7.6-.7.4-1.6-.4-.1-.4-.9-.6-.4.6-.2-.7-.6-.3-.3-1.4-.6-.9h-1l-.3-.5-.7.9-1.3.3-.6.9-.3.7.7.1.6.6-.3,1.1-1.4,1.6-.9.1-.6-.9-.8.1-.5-.7-2,1.1-2.3.5-1.1.7-2.5.4-.6.9-.1,4.1-.7.4-2.2-.4-1.6.7-.3.3.1,1.2-.6-.1-.1-.7-.4-.1v1.1l-.9,1-.9-.1-1.4-1.2-.9.7-2.3-.4-1.4.8h-.9l-.3,1.6-.9.4-.2.8h-.6l-.2.4-.7-.3-.4-.9-.5.7-1.7-.6-1.4.5-1.2-.4-.9.1-.8-.6-1.4-.1h0v-1.3l-.3-.4.3-1.2-.4-.2-.1-.7.4-1H780v-.4l.2-.3.5.1.5-.6.4.1v-.8l-1.4-.6-1.2.2-1-.3-.8-.4-.7-1,.9-.1.1-.3,1.1.1.2-.4.6-.1-.4-.7,1.1-.3.1-1-.6.1-.2-.4.7-.2v-.5h-.7l.2-1.1.5.1-.3-2,.7-1.5-.6-1.5-1.6-.9.6-.7-.3-.1,1.2-.9-.3-.2.3-1.3.7.3.4-.3.1-.5-.5-.4h.9V335l.6.1v-.4l.4-.1.2-.4-.1.4.6.1v-.5l-1.4-.4v-.4l-.7.2-.3-.4-.4.5-.1-.4-.7-.2.1-1.7,1.7-.9.1-.3-.9-.3.1-.3.2-.4.4.1.4-.9h.4l-.1-.6.5.1.1-.9.3.2.1-.4-.1-.4-.8-.3-.7-.7.8-.7v-.8l-.5-.8.6-1.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"803.27","cy":"328.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Telangana")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"odisha"}},[_c('path',{attrs:{"d":"M921.17,282.5H923l.1.9-1,.1h0l-1.4.9-.2-.4h0l-.5.1.4.4-.7-.1.7-1.8.8-.1ZM878,254.2l2,.8.3,1.2.7.4h.8l.7.6,2.1-.2.3-.5.4-.1V256l.7-.2,3.3.1.1-.4.9-.1.4.4.7-.3.3.4.8-.5.1.2,1.7-.7.1,2.1.3.1-.1.4h.4v.4l-.7.3-.7,2.6-.7.4.4.1.7-.5.8.2.4.5.6-.1.2.4v-.2l.6.4.3.7,1-1.7.4-.3.5.1.1-.6.5-.1,2.2,1.2.8.2.8-.3.6.7,1.8-1,.4.6h-.7l-.4,1.4,2.2.4.1-.7.4-.2.9-1.4.4-1.2-.9-.9,1.1-1-.5-.1.2-.3-.4-.1.4-.6-.2-.8-.9-.5.2-.7.8-.4.2-.7,1,1.3,2.6.7,1.1,1.7,1.2.7.1-.4.9-.3.5.7h.7l.2.4.8.2.1.4,1.1.3h0l-.1,1.2,1.2-.1.7.9,1.9.2.9.7.2.9-.6,1.3.5.7.9.1v-.8l.9-.4.1-.7,1,.3.4,2.3,1.4.4.3.4H930v.5l.4.4-.2,1,.4.6h0l-1.5,1-2.7-.1-1.3.7-2,1.6-1.4,1.5-1.1,2v.9l2.2,5.1-.2.6-1.2-.2-.8.4-.8,2,.7.1-.4-.4.5-.1h0l.2.4,1.4-.9h0l1,.3.7-.2-3.9,2.8-.9,2.1.7.2v.7l-1.5,1.3-2,.9-2.2,2.7-.4.9-.7-.1-.8-1.2-.7.1-.1.4.9.1,1,1.2-10.6,3.4-4.2,2.1-3.7,2.6-1.2,1.3-2.3,1.7-1.4,1.4-.9,1.7-.7-.4h0l-.4-.4.1-.5-.6-.1-.1.6h-1l.4.7.5-.1v.4l-.7-.1-.4.7-.3-.8-1.2.7-.3.7-.9-.5.4.7-.4.4.2.4-.5.4-.5-.1.4.3-.6-.1.3.3-.1.3-.4-.2-.1,1.2-2.7.3-.4.4-.7.1-.8-.9-1.3.1-1.1-.4-1.2-3-.7.5.6,1.1-.5-.1-.6-1.1.3-.4-.4-.1-1.2-2.2-.4.5.1.5-.4.7-.5-.4-.2,1.1-.6-.1v-.8h.3l-.1-.7-.2.2-.3-.4-.2.1.3.8-.1.4h-.4l.1.9-.7-.8-.9-.2-.7.3.4,1.2.3-.7.5.5-.5-.1,1.1,1-.2.4h-.6l-.1.5-1.2.1-.2.5-.7-.1-.1.7-.1-.4-1-.5-1.2,1.9-.6.2-.1.8h.7l-.4.3.1.3.9.1-1.2,1.4.4.4.3-.1-.1.9-.6-.1-1.3.5-.6-.2-.1-.7-.6.1-.7-.4-.4.3.2.4-.4,1-1.7.7-.5.9-.7-.7-.1-.6.5-.7-.1-.4-1-.4.3-.7-.4.1-.1-1.1h-.4l-.4-.6-1.7,2,.4.7-.7.8.9.1-.3.5-.5.1-.1.8-.4.3.9.9-.1.2-.4-.3-.1,1.6-.4.1-.1-.4-.5.2v1l-.4.1-.9-.5-.3-.5-2-.2-1.1,1-2.3.9-.7.7h0l-.9.5-.2-.4-.4.1-.8.9-.7-.2-1.3.4-.3-.4-1.2.3h0l.1-1.2.7.1.6-1.5-.1-.9.5-1,.2-1-.3-.4.4-1.2,1-.7,1-.1v-.4l1.3-.1.3-1,1.4-1.6.6-.2.2-.6.6.1.1-.4-1-.6-.1-.4.9.4.3-1,1-.4.7.1.1-.7h.7l.5-.5.1-1.7,1-.2-.2-1.7-.5-.7.3-.5-.2-.4-.6-.1.3-.5-.4-1.7.5-.9-.7-.7.4-.1.2-.8-.9-.1-.4-1.4-1,.1.4-.6-.1-2.6.4-1.3-1.2-.2-.3-.9-1.7-.9-.2-.7.4-1.4,1.2-1.1,1.2,1.4.5-.7,1.8,1.2.8-.3,1.7,2.7.7-.8.8-.4,2.3.7-.4.7.2.8.9-.9.9-.1.2-.7-.3-.4.1-1.5-1.2-.1-.5.2-3.1-1.2-.2-1.4.5-.9-.1-1,.4-.3-.5-.9.5-1.4-.3-.8-.4.4-.1-.9-.9-.7.7-1.2-.5-2.2.1-2,.9.4.2.6.7.1.4-1.3,1-.6,1-1.5-.2-.6.6-.5-.1-.8,1.7-.1.6.4.4-.3,1,.1,1.2-.4,1.3.9,1.2.3,1.1-.6.4-2,.9-.4-.3-.4.2-1,1.6.6.4-.1-.1-.8-.7-.7-.2-.8.7-1.9.9-.6.1.7.5-.4-.9-.8.9-1.1-.3-.7.4-.5.7.4-.1-.7.8-.2-.2-.4.4-.7-.7-.4-.3-.5.1-1.5.9-.1-.7-.7,1.3-2,.7-.4.9.1,1.7-1.7,2.2-.4.6-1.6-1-.7.1-.4,1.6.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"887.77","cy":"285","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Odisha")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"chhattisgarh"}},[_c('path',{attrs:{"d":"M867.77,228.4l1.5.3.4.7.9.2.6,2.2.5.2-.2.4,2,.7.5,1.1-.2,1.2.9,1.4,2.5.6.1-.9,1-.1.2,1.4-.8,1.4-.1,1.2.6.4.6-.4.4.7-.6,3.1,1.4.9.3,2,.7-1,.4.8.9-.2.1.4,1.4-.2.3.6-.3,1.2-.6.1-.7,1.6H882l-.4.4-.1,1.1-1.1.6h-1.2l-1.2,1.1-.1.8h-.4l-.1.4,1,.7-.6,1.6-2.2.4-1.7,1.7-.9-.1-.7.4-1.3,2,.7.7-.9.1-.1,1.5.3.5.7.4-.4.7.2.4-.8.2.1.7-.6-.5-.4.5.3.7-.9,1.1,1,.8-.5.4-.1-.7-.9.6-.7,1.9.2.9.7.7.1.8-.4.1-1.6-.6-.2,1,.3.4-.9.4-.4,2-1.1.6-1.2-.3-1.3-.9-1.2.4-1-.1-.4.3-.6-.4-1.7.1.1.8-.5.5.2.6-1,1.5-1,.7-.4,1.3H854l-.2-.6-.8-.4-.1,2,.5,2.2-.7,1.2.9.7.1.9.4-.4.3.8-.5,1.4.6.9-.4.3.1,1-.5.9.2,1.4,3.1,1.2.5-.2,1.2.1-.1,1.5.3.4-.2.7-.9.1-.9.9-.2-.8.4-.7-2.3-.7-.8.4-.7.8-1.7-2.7-.8.3-1.8-1.2-.5.7-1.2-1.4-1.2,1.1-.4,1.3.2.7,1.7.9.3.9,1.2.2-.4,1.3.1,2.6-.4.6,1.1-.1.4,1.4.9.1-.2.8-.4.1.7.7-.5.9.4,1.7-.3.5.6.1.2.4-.3.5.5.7.2,1.7-1,.2-.2,1.7-.5.5h-.7v.1l-.7-.1-1,.4-.3,1-.9-.4.1.4,1,.6-.1.4-.6-.1-.2.6-.6.2-1.4,1.6-.3,1-1.3.1v.4l-1,.1-1,.7-.4,1.2.3.4-.2,1-.5,1,.1.9-.6,1.5-.7-.1-.1,1.2h0l-2-.1-1.4-.7-1.3,1.1-.7-.1-1.4-4.6.4-1.4-1.7.6-.2-1,.3-.1-.6-.4-.5,1.1-.9-.1v-.7l.9-.6-.7-.7-.4-1.3.1-.4-.5-.1.1-.3-.7-.6-.3-.7-2.2-1.7-2.2.7-1.2-2.1h0l-.4-.7.5-.1,1.1-.9-1.2-1.7v-.9l.8-1.4.1-1.1.9-.7-.1-.8.8-.4.6-1.2,1.4-1.1.7,1.5.9-.3.2.7.9-.1,1.4-1.2-.9-1.1,1.6-.7-.2-.9-.5-.1-.3-.5-.9-.1-.7-.7-.9-.1.1-1.3-1.9-1.3.1-.7-1.1-.1.1.8-.4-.4h-.9l.1-.4.5.1,1-.9-.2-.5-1.2-.1v-.4l.6-.3.6.4.6-.1.4-.9v-1.2l-.1-.7-.7-.4-1.6-.1-.1-.3.4-.4-.5-.8,2-.4.5-.6,1.2-.4-.5-1,.6-3.3-.9-.1-.9.4-.4-.5.4-.6,1.1-.4-.5-1.3-.1-2.7h-1.3l-.5-1.2.4-.4-.2-1,.4-1.2,2.7-1.2.6-.8-.2-.5h0l1.1-2.3-.3-1.9.1-2,.4-.7,1,.1.3-.9.1-2.1-.3-.4.4-.1,1-2.5.6.1.2.9.6-.1.1-.6-.5-.3.7-.3.1-1.6,1-.3.4-.8-.1-2.4,1.1-.8.6.7.9-.8.4.3.3-.7.9.3.3,1,.4-.7.4.2-.1-.4h.7l.6-.7h1.4l.1-.4.4-.1.1-1,.8-.3.2-.4.3.4.4-.3-.2-1,.6-.7-.4-1.1.1-.7,1.3-.3.1-.4,1.2-.7-.4-1.4.3-.6h1.3l.7-.6.7.2.5-.7-.1-1.4.7-.9-.1-.7-.7-.6-.4.1-.2-.7-.8.4-.5-.1v-.6l-.6.1-.9-2-1.4.4-.4-.6-1-.4-.7.7-.6-.1-.4.7-.3-.3V237l-.4-.1-.1-.6.5-.2.1-1h.4l.7-1-.2-.6-.5-.3-.1-1-.5-.4.2-.9.8-.3.9,1.1-.1.3.9.4,1.1-.2.9-.8.5.4.7-.1.7.7h1.7l.7-.6-.1.4.4.4.4-.2,1.1.3,2-.1.9.4.4-.1-.3-.5h.9l1-.6.1-.9,1.4-.2.9-.7h0l2,1.4h2.2l1.6-.7.4-1.1.9-.6.2-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"844.27","cy":"272.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Chhattisgarh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"jharkhand"}},[_c('path',{attrs:{"d":"M870.37,221.4l3.3.4,2.3-.4.9-.3.9-1.5.9.4.9,2.2.4-.4.1-.6.5.5-.1-.6.2-.1.4.4.3-.3.4.4.4-.4-.1-.2h.4l.5,1.1-.5.4v.5l.6.4-.2.1.3.4.7.1.6.5-.1.4.6-.1.6.9.5-.9-.1-.6.7-.1.1-.4,1.3.3.3-1,1.7-1.2.6.3v.9l.7-.1.3,1.5,1.1-.1.4-.6.9-.1.4-.4-.1.9.4.1,1.2-.8-.3-.6,2-.6v-.5l3.1-.4.5.4.3-.7h.5l.1-.7,1.3.4-.2-1.7.7-.4.6-1.8.6.4h1.5l1.1,1.2,1.5-.8-.1.7.7-.1.6.7.1,1.7.9.3.4-.4.7.6.9-.1-.3.4.1.8-.5.8,1.1.3.9,1.1.6.1.2-.9.4-.1.3-1.5.7-.3.9-1.2,1,.7.9-.3.3-.7h.4l.4.4-.1.5.6-.1.3.3.4-.3.5.4-.2-.8.5-.9,1.8.6.7-3.3-.3-.4.6-.6.6-.1.1-.4-.1-2.3.9-1.1.6-.3.6.3.5-2.2.7.3.4-.4,1.2.6v-.8l.4-.4-.2-.6.9.2.1-.8.5-.3.4.7h1.2l.4.9,1.2.1.1.4h0l-.1,2.2,1.5,1.1,1.4,1.7.1.6-1.3.7.1.5h-.4l.1.5-.4.5h-.3l.1-.4-.3.4.4.4.9.3-.2.8.4.3-.4.5.3.2h-.8l.6.3-.4.5-.6.2-1.2-.5.6.6-.1.9.1-.3.2.3-.6,1.3.4.1-.8,1.7-.7.2-.4.7-.7.1v.5l.9.4-.1.6-1.8-.1.6.4-.6.4.1.4-1.2-.5v1l.3.2-.4.4-.7.1.4.4-1.5-.4-.4.2-.2-.1.3-.4-1.35-.1.4,1.2.4.1v.9l-.4.4-.4-.6-.1,1.3-.4-.1-.4-.1.1-.2-.9-.2.5.8-.3.4h-.4l-2.4-1.2-.4.4-.7-.6-.3.3-.1.3-1,.6-.4-.4.4,1.2-.4,1.2-.8.1-.1-.3h-.6l-1.5.4-.9.7h-1.4v.4l-.9.4-.4.7-.1.8.3.2-1.1.7.2.3-.2.1-.3-.4-.5.4-.3-.3.2-.6-.3.2-1.2-.3v-1.5l-1.4-.3-.6.5.6.9-1.6.7-1.2-.3-.1,1,.5.7-.4.1.2.7-.8,1,.1,1.1h.4l.9,1.1,1.9-.2.1.6,1.3.4.2.7.9.8,1.3-.4,1.4.7.4-.4,1.2.1.2.4.4-.4-.3.7-.5.1-.2-.2-.6.4.4.4-.4.6-.2,1.4,1.4,1.2.5-.3,1.2.8.5,1.6,1.7.1.6,1.2-.1.4h-.7l.2.8,1.2.5-.2,1.2.9.5v.7l-1,.1-.1-.2v.4l-.1.4h-.5l-.7-.1h0l-1.1-.3-.1-.4-.9-.2-.2-.4h-.7l-.5-.7-.9.3-.1.4-1.2-.7-1.1-1.7-2.6-.7-1.1-1.2-.2.7-.8.4-.2.7.9.5.2.8-.4.6.4.1-.1.1.5.1-1.1,1,.9.9-.4,1.2-.8,1.3-.4.2-.1.7-2.2-.4.4-1.4h.7l-.4-.6-1.8,1-.6-.7-.8.3-.8-.2-2.2-1.2-.5.1-.1.6-.5-.1-.4.3-1,1.7-.3-.7-.6-.4v.4l-.2-.4-.6.1-.4-.5-.8-.2-.7.5-.4-.1.7-.4.7-2.6.7-.3v-.3h-.4l.1-.4-.3-.1-.1-2.1-1.7.6-.1-.2-.8.5-.3-.4-.7.3-.4-.4-.9.1-.1.4-3.3-.1-.7.2v.4l-.4.1-.3.5-2.1.2-.7-.6h-.8l-.7-.4-.3-1.2-2-.8h0l.1-.8,1-1h1l1.1-.6.1-1.1.4-.4h.5l.7-1.6.6-.1.3-1.2-.3-.6-1.4.2-.1-.5-.8.2-.4-.8-.7,1-.3-2L879,244l.6-3.1-.4-.7-.6.4-.6-.4.1-1.2.8-1.4-.2-1.4-1,.1v.9l-2.5-.6-.9-1.4.2-1.2-.5-1.1-2-.7.2-.4-.5-.2-.6-2.2-.9-.2-.4-.7-1.5-.3h0l1.2-2.7-.4-.8,1.2-.8-.3-.7-.4-.1-.3-.8.1-.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"895.52","cy":"237.1","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Jharkhand")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"west-bengal"}},[_c('path',{attrs:{"d":"M945.87,269.1l.4.4.1.5-.7-.2Zm5-.1,1,.8H951Zm-1.6-.3.4.4-.2.5-.4-.4Zm-2.8-.2.7.6-.6.7-.6-.7.2-.8Zm3.5-.2.4,1-.7.2.2-.4-.4-.4Zm3,.2.3.4-.4.1-.1-.8Zm-5.7-.7v.9l-.6-.4Zm5.9-.4.1.7.4.3.2.7-.4.1v-.4l-.4-.4-.3-.8.4-.2Zm-2.7.2-.1.7-.6-.4.7-.3Zm-7.4-.2.5.3.2.7-.7.7Zm2.1-.1.2.6-.4.8-.2-.8Zm-3.8-.1.2.4-.1.3.2.3.1.4-.1.7-.4-1.4.1-.7Zm12.9,0,.6,1.2-.7.4-.8-1,.1-.4.8-.2Zm-7.6.1.4-.1.2.5-.7.7-.4-.9Zm5-.5.9.8-.3,1-.7-1Zm-7.1.2.2.4-.3.7.3.5-.5.5-.3-1.4.4-.6-.4-.2.2-.4Zm-3-.3.7.1.5,1.2-.2,1.1.3.4-.4.4-.5-.1-.4-3.1Zm10.9-.1.6.7-.7-.1Zm-8.6,0-.1.6.3.3-.4.3-.1-1,.3-.2Zm9.8-.1.6.4-.4.2-.2-.6Zm-2.8,0h.4l-.4.8.3,1.2-.2.1-.5-.2.1-1.2-.6.1.3-.7Zm-3.7-.3.6.8-.2.6-.4-.9Zm6-.1.6.9-.1.1-.8-.9Zm-5.7-.1.1.7-.3-.2-.1-.4Zm-2.1,0v.9l-.5.3.1-.8Zm3.7-.3.7.8-.1.4.2.1-.1.5-.5.1.3.4-.9-.3.1-1.1Zm-2.6,0,.4.4v.9l-.8.3-.2-.9.6-.7Zm-1.9,0,.3.2-.3.9-.4-.7Zm8.8,0h.2l.1.7-.5-.4.2-.3Zm-2.5.1v.6l-.6.3.4-1.2Zm1.6-.7.5.4-.2.5-.7.3-.2-.7Zm-5.3-.1.2.3-.1.5-.4-.3Zm-3.9.1.4.8.4.1-.1.4-.5.1-.1.6-.6-.1-.3-1.1.8-.8Zm8-.3.3.2.5,1.9-1-.9Zm-10.8-.2.5,1v1.2l-.4,1,.1.5-.7.4-1-.4-.1-.4.6-1.7,1-1.6Zm9.9.3.5-.6.3.3-.8,1.1-.1-.6.1-.2Zm2.8-.6.7.4-.2.7-.9-.3.4-.8Zm-5.4-.1.5.5-.2,1.4-.6-1.3Zm-.9,0,.2.3-.3.9-.2-.4Zm-1.7,0,.5.3.1.5-.7.7h-.7l.3-1.2Zm4,0,.5.1.5.6-.4,1.3-.9-.9Zm-1.2-.3.4.1-.3.4Zm3,0,1.2-.1.8.4-.2.4-.7.6Zm-1.7-.2,1.2.2.1.6-.3.4-.3-.6-.8-.1Zm.3-.8.1.4.5.1.1.2-.7-.1-.3-.6Zm-1.3-.6.9.3-.6.9-.7-.2Zm-7.8-.2-.8,1.5-.6.4.4-1.4,1-.5Zm10.1.2,1.4.1-.1,1.2-.6.1-1.4-.7.2-.7Zm3.5-.5.6,1-.2.9-.4.1-.8-1.5.1-.6.7.1Zm-2.6-.5.2.7-1.4-.2Zm-.4-.4.2.3-.9.3-.1.4-.4-.1.4-.9.6-.2Zm.2-1.4.9,1.7h-.7l-.7-.7.7-.3-.5-.9.3.2Zm1.5.1.4.6-.3.9-.6.4v.7l.4.4-.1-.9h.4l.1,1.2.7,1.1-.1.3-1.2-.6-.4-.9v-1.2l.4-.5-.6-1.2.4.1.5-.4Zm.7-.3.7,1.1-.15,1.1-1.1-.1.4-1.1-.4-.9Zm-4.7,0,1.4.5-1.6,1.4.8.8-.1.4-1-.4-.4-1.2.9-1.5Zm2.5.8-1.2.7-.6.9h-.2l-.3-.4,1.7-1.5.3-.1Zm1.4-1.2.2.4-.4.4-.1-.3V259Zm-2.1-1,.2.7-.4.3.4.7-.5.1-.7-.4.1-.4.9-1Zm.5-1,.7.1.3.6.4.1.1,1-.7.3.1.8-1.5-.8.4-.2-.2-1.4Zm2.1-.6v.9l.6.4-.4.2,1.1,1.4v.8l.4-.1-.5.4-.7-1.2-.7-.1-.3-.8.3-2.3.2.4Zm-1.3-2.4v1.2l.4,1-.5.4-.4-2.1Zm.6-.4.4.1.6,2-.6.3-.3,1.7-.5-.4v-.7l.4-.3-.4-1.2v-1.4l.4-.1Zm-13.9-77.2.9.3.1,1,.8.4.9-.3.6.3,1.1-.1.3.4,1.7.4,1.5-1.2-.1-.4.6-.2h.9l.6.4.4-.3.6.7.4-.1h0l1.8.7.1,2.7.7-.7.5.5-.2.4.4.3.9-.3.3.7.7.1.1,1,.4.4,1.9-.1,1.8-.8.2.4.9.1.1.4,1.5-.1.9.7.4-.1.1.3-.7.6.3.1h.4l.2-.4.8.3.4-.2.3.7.5-.3.7.2h0l.3.9-.3.4.3.7-.2.1-.1,1.5.3.4-.7,1.1.3-.1.1.3-1.2.5v.4l-.4.1.1.6-.7-.2.3.6-.2.2-.3-.2.4.5-.5.4.5.1-.6.4.6.2-.2.1h-.3l-.4-.6-.1-.3-.5-.1.4.9h-.7l-.1.4-.3-.1.6.7-.6.3.2.2.3-.3.3.7-1.1.7v.9l-.6-.1v-.6l-1.6-.1-.1-.7-.5.7-.7-.1-1.1-.7v-.3h-.1l.1-.4-.7-.5-1-.3-.4-.7.1-.9-.6-.8.6-.7h-.8l.2-.3-.3-.4.1-.6h-.8l-1.2-1.1-.2.6-.3-.1-.4.4.1.7.7.1.1.2h.4l.2.4-.2.4.7.4.5-.1.1.7-1.5.2-.5-.8-.7-.1-.3.2.2.7-.6.1-.4-.4v-.8l-.4-.2-.6.2-.2-.9-.7.3-.4-.8.3-.1-1.2-.8-.1-.6h-.4v.4l-.6-.1.1-.6-.5.1-.6-1-.8-.1-.3-1.4-.6.7-.7,2,.3.5.1-.7,1.7.4.7,1.7-.6.2-.4-.4-.3.7-.5.1.1.2-.9.6v1l-1.6.5-1.1.7-.3,1.2.4.1-.2.7.2.1-.7.2-.9,1.7.4.4.1,1.5.5.4.5-.4.4.2.9-.4v.4l1.6,1.2.4.7.7.1-.1,1.1.8.3-.1.4,1.2.9.5-.1.6.6.7.1.2-.4.9.1-.1-.5h.7l.4.9-.4,1,.4.3v.5l.7.7.3-.2.3.5,1.3.2-.9.6.1.7h-.4l.2.6-.4.3-1.2-.7-.7.7-.4-.3-.3.2-.7-.5-1.4.1-.8.4-1-.6-.8.3.2.9-.3.3.1.8-.2.5.3.2-.9,1.1.1.4-.9.1-.2.4.3.3-.4.4-.7-.5-.2.4v-1.2l-.5-.7-1.3.4.6,1.2-.4.2-.1.7-.2-.3-.2.7-.5.1-.1.8-.8.9,2.1,2.7.8.7,1.2.4.9.9,1.7.1,1.2.6.4.8.2-.5h.3l.7.4,1.1-.1.5.6-.1,1.3-.5.5.1.8-.2.1.1.3h.4v1.7l.5-.2.2.4-.6.1-.1,1.1h-.4l-.7.7-1.2.1.4.7-.7.5.3.4-.3,2,.5.1-.1.6.9-.1.2.9,1.3,1.2.9-.2-.1.9h-.4l-.1.4.1.9-.4.3.2.6-.7.2.4.7,1.2.6h.3l.1-.6.5.4.9-.1.1.4,1.2-.1-.2.5-.3-.1-.7,1.1-.8.5.1,1.5h-.4l.3.2-.1.6.5.1.3.5-.1.7h.6l.3.6-.1.8-.6.5.6,1.2-.4,1.2.4.1-.3.7-1,.4-.4.7.2.4-.2,1.5.4.5-.9-.1-.3,1.2-.9.8-.1.5-.8-.1-.9,1.7.3,1-.6,1.2.1,1-.4.4-.1-.3-.5.1-.2.8-.5-.4.5-.8-1.6.4-.4.4-.1,1.4H943l-.1-.9-.6.1-.9.7.2.9-.9-.1-.8-1.9.2-.7-.4-.5.8-1,.2-.9-.3-1.5-.6-.5-1.4-.2.5-1.5-.9,1.4-.9-.4-.4-.7-.2-2-.4-.4-.6-.1.9,1.2v1.7l1,.9,2,.3.8,1.4-2,1.4-.1.1-1.1,2.5-.8.9-.6.1-1.5,1.6-.6-.1-.9.7-3.1.8h0l-.4-.6.2-1-.4-.4v-.5h-1.1l-.3-.4-1.4-.4-.4-2.3-1-.3h.4l-1,.4v.8l-.9-.1-.5-.7.6-1.3-.2-.9-.9-.7-1.9-.2-.7-.9-1.2.1.1-1.2h0l.7.1h.5l.1-.4v-.6l.1.2,1-.1v-.7l-.9-.5.2-1.2-1.1-.3-.3-.8h.7l.1-.4-.6-1.2-1.7-.1-.5-1.6-1.2-.8-.5.3-1.4-1.2.2-1.4.4-.6-.4-.4.6-.4.2.2.5-.1.4-.7-.4.4-.2-.4-1.2-.1-.4.4L912,246l-1.3.4-.9-.8-.2-.7-1.4-.4-.1-.6-1.9.2-.9-1.1h-.4l-.1-1.1.8-1-.1-.7.4-.1-.5-.7.1-1,1.2.3,1.6-.7-.6-.9.6-.5,1.4.3v1.6l1.2.3.3-.2-.2.6.3.3.5-.4.3.4.2-.1-.1-.2,1.1-.7-.3-.2.1-.7.4-.7.9-.4v-.4h1.4l.9-.7,1.5-.4h.6l.1.3.8-.1.4-1.2-.4-1.2.4.4.8-.6.1-.3.3-.3.7.6.4-.4,2.4,1.2h.4l.3-.4-.6-.8,1,.2-.1.2.4.1.4.1.1-1.3.4.6.4-.4-.1-.9-.4-.1-.4-1.2,1.4.1-.3.4.2.1.4-.2,1.5.4-.4-.4.7-.1.4-.4-.3-.2v-1.1l1.2.5-.2-.4.6-.4-.6-.4,1.8.1.1-.6-.9-.4V226l.7-.1.4-.7.7-.2.8-1.7-.4-.1.6-1.3-.2-.3-.1.4.1-.9-.6-.6,1.2.5.6-.2.4-.5-.6-.3h.4l-.3-.2.4-.5-.4-.3.2-.8-.9-.3-.3-.4.3-.4-.1.4h.3l.4-.5-.1-.5h.4l-.1-.4,1.3-.7-.2-.7-1.4-1.7-1.5-1.1.1-2.2h0l.7.4-.2-.6.5-.7-1.1-.9.1-.7-.4-.1-.1-.4.4-.7.4.1.4-.5h.4l.2-.9.3.2.4-.5.9.2v.4l.3.1.1-.3.3.4.7.1v-.4l-.6-.6-.2-.9.5-.8-.3-.1.2-.9-1.3-.6-.4-.8h-.4l.2-.7-.4-.2.4-.4-1.3-.4-.3-.7.4-.4.2-1.8,1.1-.8.3.4.1-.3.4.1-.1-1.2.7.2.4-.7h.5l1.2-1.3,1.1-.5,1.2-1.2-.4-.4-.4.1-.1-.3.6-.4-.6-.4-.1-.5-.5.1-.2-.3.8-.7v-.3l-.9.2-.4.4-.6-.4h0v-.1h0l.9-1.7.4-2.2-.2-1.6-.6-.6.1-.4-.4-.5.2-.6-.7-.3-.2-.5h-.6l-.2-.9-.4-.3.4-1.1-.1-.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"932.17","cy":"241.75","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("West Bengal")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"bihar"}},[_c('path',{attrs:{"d":"M879.67,171.4l.5-.1v.5l.9.3.1.4.7-.1.6,1.2,4.9.8,1.1,2.1-.2,2-.5.8,1.7.7.2-.3.3.4.6-.4.9.9,1.1.1.2.4-.1.4,1.4.5-.6.5,2.6-.2-.3.9.5.9,1.9.3,1.1-.9.7.1,2.7-1.5,1.5,1.3v2.4l1.3.9.5-.1v.7l1.5-.7.2-.7,1-.3,1.7.7-.1.4.9-.1.4.4.5-.5,1.2-.1,3.3,1.4.4.7,2.5,1.2.5-.6,1,.4.9-.4v-.4l.6-.1.1-.4,1.2-.3.4-.9h.4l.3,2.2,1.1.8,1.4-.1.1.7.7.1.4.4.4-1,1.4-.6,2.1,1,.7-.2.4-.7.9.4.5-.1.4-.9.9.6.6-.9.6,1.2,1,.4.1.4h.5l.1-.4.9-.8.1-1.7h0l.6.4.4-.4.9-.2v.4l-.8.7.2.3.5-.1v.5l.6.4-.6.4.1.3.4-.1.4.4-1.2,1.2-1.1.5-1.2,1.3h-.2l-.4.7-.7-.2.1,1.2-.4-.1-.1.3-.3-.4-1.1.8-.2,1.8-.4.4.3.7,1.3.4-.4.4.4.2-.2.7h.5l.4.8,1.3.6-.2.9.3.1-.5.8.2.9.6.6v.4l-.7-.1-.3-.4-.1.3-.3-.1v-.7l-.9-.2-.4.5-.3-.2-.2.9h-.4l-.4.5-.5-.1-.4.7.1.4.4.1-.1.7,1.1.9-.5.7.2.6-.7-.4h0l-.1-.4-1.2-.1-.4-.9h-1.2l-.4-.7-.5.3-.1.8-.9-.2.2.6-.4.4v.8l-1.2-.6-.4.4-.7-.3-.5,2.2-.6-.3-.6.3-.9,1.1.1,2.3-.1.4-.6.1-.6.6.3.4-.7,3.3-1.8-.6-.5.9.2.8-.5-.4-.4.3-.3-.3-.6.1.1-.5-.4-.4h-.4l-.3.7-.9.3-1-.7-.9,1.2-.7.3-.3,1.5-.4.1-.2.9-.6-.1-1-1.1-1.1-.3.5-.8-.1-.8.3-.4-.9.1-.7-.6-.4.4-.9-.3-.1-1.7-.6-.7-.7.1.1-.7-1.5.8-1.1-1.2h-1.5l-.6-.4-.6,1.8-.7.4.2,1.7-1.3-.4-.1.7h-.5l-.3.7-.5-.4-3.1.4v.5l-2,.6.3.6-1.2.8-.4-.1.1-.9-.4.4-.9.1-.3.6-1.1.1-.3-1.5-.7.1v-1l-.7-.3-1.7,1.2-.3,1-1.3-.3-.1.4-.7.1.1.6-.5.9-.6-.9-.6.1.1-.4-.4-.7-.7-.1-.2-.5.2-.1-.6-.4v-.5l.5-.4-.5-1h-.4l.1.2-.4.4-.4-.4-.3.3-.4-.4-.2.1.1.6-.5-.5-.1.6-.4.4-.9-2.2-.8-.4-.9,1.5-.9.2-2.3.4-3.3-.4h0l.7-1.7-.7-.4.2-.5-.5-.4v-.5l-.4.1-1-.9.1-.8-.6-.7-.1-2.3-.4-.1.6-1.8-.4-.9.2-.3.6-.1.3-.7.8-.1,1.2-1.1.4.1.9-.4.4-.7.6-.1-.2-.1.3-.3.1.1.4-.4.4.4.6-.4-.1-.4.7-.1-.4-.5.6-.1,1-1.4,2.4-1.3-.3-.7.4-.4.8-.1.7.4.1.6,1.2.1V202l.5.1.2-1.2.7-.1.3.8.7-.3.6.7.6-.1.1-.7.1.5.3.1.1-.9,1.2.1-.4-.6.3-.6-.9-.7-.4.1v-.7l-1.6-.2-.2-.7-.9-.4-.9.2-1.4-.9-.6.1V196l-1.2-1.2-.7-.1-.5-.8-.1-1.6,1,.4.5-.7.7.3.4-1.2-.1-.9-1.5-.2-.9-1.1-.4.2-1.2-.3v-1.2l.9.1.1-.4,1.1-.2.5-.9v-.7l2.9.7,2.2-.4-.2-.7-1.2-.2-.4-1.2-.8.4-.2-.1-.1-.3.4-.9-.1-.9-.5-.1-.6.7-.6-.3.1-.6-.6-.2-.1.4-.6-.2-.1-.7-.4-.2.4-.3-.1-1.4-.7-.4.4-.4-1.2.1.6-1.8-.4-.6-.9-.4.4-.7-.1-.4-.9.2-.4-.2.4-.5h0l.7-.6-.5-.1-.1-.7.9-.4,1.4.3,1-.9.1-.4,1.2.3Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"902.77","cy":"202.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Bihar")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"sikkim"}},[_c('path',{attrs:{"d":"M948.07,161.5l.3.4h1.3l1.2,1.1.1,1.4.4.1.4,1.1-.5.8-.1,2.5-1.2,1.7.7,2.7,1.7,1.4-.4.9-1.4.4-.2,1-.6.7h0l-.4.1-.6-.7-.4.3-.6-.4h-.9l-.6.2.1.4-1.5,1.2-1.7-.4-.3-.4-1.1.1-.7-.3-.9.3-.8-.4-.1-1-.9-.3h0l.8-2-.4-.6.1-.6.5-.4-.6-1.2,2.3-5-.4-.5.4-.3-.1-.3-1-.5-.1-1.2.2-.2.7.4.7-.4.2.4,1.5-.7.7.2,1.4-1.2.9.1.2-.8.9-.3-.1-.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"945.57","cy":"171.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Sikkim")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"meghalaya"}},[_c('path',{attrs:{"d":"M966.47,204.6l2.2-.9-1.9-2.2.7-.1.3-.5-.1-.9.9-.4.2-.3-.3-.2,1.7-1.4.9.3,2.2-.5.6-.6.5-.1.5.4.7-.4.9.9-.4,1,1.1-1.1.7.4-.4.4.3.2.9-.9.9-.1-.1.7.6.1.5-.7.4.2.7-.2.6.7-.1-.5.4-.1.4,1h.9l-.4,1.1.7-.4.4-.1-.4.4.2.1,2-.7-.2,1.4.2.8.5.1.8-.4.9-1.5,1.3-.3.4.2,1.2-.5.1-.3-.4.4-.5-.1.9-.9-.4.1,1.2-1.9.9.2.1.9-.4.4.9.6.8-.8.1-1.7,1.3-1,.9.4-.1.7.8.9,1-.7.9.1,1.2-.2.7-.6.9.3.9-.3-2.2,2.2.1.6.9.1-.7.7-.4.9.1,2.4,1-.7,1.6-.1.8-.5.7.4v.7l.5.1.6,1,.9.2.2.9.4.1.8-.6-.1.9-1.2,1.2.5-.1.1.9.7-.3.1.4.2-.1.7.7.3-.1.4.8.4.1.1.8-.4.6.6.5-2.1.7-.7,1-1.4-.4.3.7-.9-.1-.3,1.2-.6.1h0l-1.2-.4v-.4l-1.7-.3-2.5-1.5-4.3.4-.4-.2-.1.5-.6-.1-.9.6-.6-.4.2-.5-2.2.7-.8-.6H989l-1-.5-2.9.1-3.3.7-1.2-.4-.7.5-.7-.4-2.7-.1-.9.5-1.7-.8-3.4-.6-2.2-1.3-2.1.1.2-.2-.4-1.2.5-1.5h0l.4-.2Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"985.87","cy":"205.65","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Meghalaya")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"assam"}},[_c('path',{attrs:{"d":"M966.47,204.6l.1.9-.4.2h0Zm33.9-22.7,2.5-.1,1.2-.6.7.1.9-.7h1.9l.9-.4-.1-.5.3-.4,3.3.5.7.4v.4l1.5.8,5-.8,2.2.4,2.8-.6,1.4-1.5.9-.2-.1-.7-.4-.3,2.4-2.7,1.6-1.2,1.4-2,1.5-.7-.1-.6-.7-.9.7-.5.4.8.4-.2,1.1.4.9-.4.4.8,3.4-1.6.1-.3h1l.6-.5.7-.1.3-.6,2.6-.6,4.3-1.7,1,.5,2-.7,1.4-1.3,3.3-.4,2.3.1-.7,1.4-1.6,1.3-.7.9.1.3-.4.2.6.7-.3.3.4.4-.2.4.6.4.2.7.7.2.1.8-.6,1.3.3.2.3-.4.1.7.4-.7.5-.1.3.4.1-.2.6,1.2-1.7,1.3-.2.5-.5-.5-.8.1-3.3,1.1-1.2-.7-.9.9v1.3l-1.7.5-1.5,1.2-.8-.2h0l-1.3,1.3-1.4.7-.6.1-.9-.6-.7.4-1.3,2.2-1.7,1.2-.9.2-.4-.4-.4.8-.4-.4-1.2.7-.1.6-.8.4-.1,1.4-.7.4-.5.8-.4-.3-.1-1.4-.2.1-1.4,1.7-.1,2-1,.3L1029,194l-.2,1.7-.6,1.1.4,1.4-.9.5-.5.7-.6-.3-.7.8-.2-.5.3-1.1-.4-.9-.3.5-.9.4.3,1-2,1.4-1.1,1.7-1.1.4-1.4,1.4.9,1.4,1,.5.2.9-.4.6.4.6h0l-1.3,1.1-.8,2.5-.5.8h-.6l-.3.5.2,1.1-.4.2.2.4-.4.7-.5.4v.7l-.7.4-.4-.5-.2.1v1.2l-.5.5.4.6-.4,1.3.5.2-.7.1.2.2-.6,1.1.1,1.4-.6.1h0l-1,.1-.4-.3-.1.3-.7-.1-.5.4-.9-2.4-1.2,2.7-1,.4-.2,1.3-.9.1-.3,1.2-.7.3-.1.4-.7-.2-.2-1.7h-3.2l.9-2.2-.7-1.4v-.7h0l.3-2.5.7-1.3-.9-2.7.9-.4,1.4,1.2h.6l.2-.4.7.1.2-.5-.2-.8-.3.2-.2-.2.4-.1-.2-.3-.5.1v-1h0l.6-.1.3-1.2.9.1-.3-.7,1.4.4.7-1,2.1-.7-.6-.5.4-.6-.1-.8-.4-.1-.4-.8-.3.1-.7-.7-.2.1-.1-.4-.7.3-.1-.9-.4.1,1.2-1.2.1-.9-.8.6-.4-.1-.2-.9-.9-.2-.6-1-.5-.1V201l-.7-.4-.8.4-1.6.1-1,.7-.1-2.4.4-.9.7-.7-.9-.1-.1-.6,2.2-2.2-.9.3-.9-.3-.7.6-1.2.2-.9-.1-1,.7-.8-.9.1-.7-.9-.4-1.3,1-.1,1.7-.8.8-.9-.6.4-.4-.1-.9-.9-.2-1.2,1.9.4-.1-.9.9.5.1.4-.4-.1.3-1.2.5-.4-.2-1.3.3-.9,1.5-.8.4-.5-.1-.2-.8.2-1.4-2,.7-.2-.1.4-.4-.4.1-.7.4.4-1.1h-.9l-.4-1-.4.1.1.5-.6-.7-.7.2-.4-.2-.5.7-.6-.1.1-.7-.9.1-.9.9-.3-.2.4-.4-.7-.4-1.1,1.1.4-1-.9-.9-.7.4-.5-.4-.5.1-.6.6-2.2.5-.9-.3-1.7,1.4.3.2-.2.3-.9.4.1.8-.4.5-.6.1,1.9,2.2-2.2.9h0l.2-1.4-.8-1.4.1-.9-.4-.8,1.2-2.1-.6-.1-.1-.3.5-.2-.6-.6v.5l-.2-.1-.3-.9-.4.1.4-.4-.1-.5-.6-.4.1-.3-.3-.4-.5-.1h0l.2-.1-.6-.2.6-.4-.5-.1.5-.4-.4-.5.3.2.2-.2-.4-.5.6.3-.1-.5.4-.1v-.4l1.2-.5-.1-.3-.3.1.7-1.1-.3-.4.1-1.5.2-.1-.3-.7.3-.4-.3-.9h0l.1-.6,1.4.2,2.8-.5.7-.3-.1-.7.5-.7,1.3.1.8-.8.9-.1,2.2,1.7,2.3.6,5.2-.2.7-.7,2.5.2,1.1.4,1.1-.9,1.3.8,2-.5.9.3,1.7-.8.9-1h.6l1.3,1,.9.2.7-.2.6-.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"1015.02","cy":"194","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Assam")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"arunachal-pradesh"}},[_c('path',{attrs:{"d":"M1061.37,139.5l.4.7-.1.6.9,1.3h.7l1.1-.9.4.5-.7,1.4-1.3.2-1.2,1.2-1.1.3.6.4.5,1.1-.6.9.3.6,1.2-.7,1.5-1.5,1.4-.1,1.4-.7-.7,1.4.1.5.5-.1.3,1.5,1.2,1.8-.4,1-1.7.6.3.9-1,.9-.4-.1.1.5-.8.1-.4.4.7.8-1.7,1.2.9.4.8-.1.4.9.4-.1.5-1.2h.8l1-.8,1.3-.1,1.3.7.4.8,1.2.1.7-.3.4.7,1.1.5,1.4-.9,1.2,1.2,1.7.4,1.8,1.3-.6.1-.5.6.1.7-.5.7,1,.1.1.5.6.3-.6.7.1,1.5-1,.1-.2-.7-.8.4-2.3,2-.1.7h-1l-.7,1.3-.6.1-.7.8.6,1.5-.4,1.2,3.9,5.5-.4.6-.6-.3-.6.2-1.3-.9-1.7-.4-.2-.4.4-.3-.1-.5-.4-.1-.9-1.4-1.4-.4-.2.3-1.3-.1-1.4,1.3-.8-.3-3.5.4-3,1.5-1.5,2.5-.9.6h-1l-1.2,2.2-.9-.4-.9,1.5-1.2-.1-1.55,2.2-1.9.7-1-.5h0l-.3-.8.4-.9-.4-.2-.1-.9-.4-.2.7-.4-.6-2.6h0l.8.2,1.5-1.2,1.7-.5v-1.3l.9-.9,1.2.7,3.3-1.1.8-.1.5.5.2-.5,1.7-1.3-.6-1.2-.1.2-.3-.4-.5.1-.4.7-.1-.7-.3.4-.3-.2.6-1.3-.1-.8-.7-.2-.2-.7-.6-.4.2-.4-.4-.4.3-.3-.6-.7.4-.2-.1-.3.7-.9,1.6-1.2.7-1.4-2.3-.1-3.3.4-1.4,1.3-2,.7-1-.5-4.3,1.7-2.6.6-.3.6-.7.1-.6.5h-1l-.1.3-3.4,1.6-.4-.8-.9.4-1-.4-.4.2-.4-.8-.7.5.7.9v.6l-1.5.7-1.4,2-1.6,1.2-2.4,2.7.4.3.1.7-.9.2-1.4,1.5-2.8.6-2.2-.4-5,.8-1.5-.8v-.4l-.7-.4-3.3-.5-.3.4.1.5-.9.4h-1.9l-.9.7-.7-.1-1.2.6-2.5.1h0l-.1-2-1.1-.9-.1-1.7.7-1-.4-.7.9-.1.3-.3-.9-.7-.1-1.2-.5-1.4-1.2.3-1.2-.4-2.2.2-.4-.6-.7.3-1.2-1.5.1-.6-.3-.4,1-1.2.2-1-.1-.6-.4-.4-.5.1-.3-.7,1.8-.1.7.8,1.7.1.6,1.2.9.4,1-.9,1.1.2,2.4-1.7h.8l.8,1.4.9-.3.4-.4.7.3.7-.7.9.4.7-.9.9-.4,1.1-1.5-1.2-1.2.4-1.1,1.7-1.3.4.5,1-.6,1-1,.6.5.5-.6-.1-.7,3-.5.2-1.2-.7-.7,1.4-1.1.4-1-.1-.6.4-.1.1-.6,1.7-.7.4.4.3-.5.7.4h1.3l1.7-.6.7.4,1-.7,1.2.6,1.2-1.8-.2-.4.1-.7,2.5-2,.9-2.2,1.1-1.1,1-.1.2-.7.9-.7,2-.1,1.1-2.1,1.2.8,1,1.1.3,1.3,1.1-.4,2.3.9-.4-.7,1.5.5.4.4,2,.1.2.9,2.2.4.7-.1.4-.6.2-1.2.8.2-.1-1.4.7-.1.2-.8.6.2,2.1-1.9.3.4,1.3-.9,1.2.1,1.9-1.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"1033.87","cy":"162.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Arunachal Pradesh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"nagaland"}},[_c('path',{attrs:{"d":"M1047,179.4l.6,2.6-.7.4.4.2.1.9.4.2-.4.9.3.8h0l-1.2,1.2v.7l-1.3,2,.6.5v.5l.5.2-.2,2.5.3.4-.4.7.1,1,1,.5-1.2,1.9-1.1.6-.2.4-.1.7.6,1.8-1.7,1.6-.3.9-.4.3.2.4-.9.1-.6,1.1-2,.6h0l-.7-.1-1.2-.8v-1.2l.6-.9h-.3l.3-.8-.4-.1-1,1.4-.5-.1-.7.5-.1.8-1.6.8-.4-.3-1.1.2-.3-.9-.5-.1-.3.5-.7-.1-.1-.4-1.1-.6-.1.4-.7.2-1.1-.2-1.8.4-.1.7h.6l.1.6-1.4,1.7h-.4l-1.3,2.7-.8-.8-.7.1.1-.5-.5-.1-.1-.5h0l-.4-.6.4-.6-.2-.9-1-.5-.9-1.4,1.4-1.4,1.1-.4,1.1-1.7,2-1.4-.3-1,.9-.4.3-.5.4.9-.3,1.1.2.5.7-.8.6.3.5-.7.9-.5-.4-1.4.6-1.1.2-1.7,1.6-2.5,1-.3.1-2,1.4-1.7.2-.1.1,1.4.4.3.5-.8.7-.4.1-1.4.8-.4.1-.6,1.2-.7.4.4.4-.8.4.4.9-.2,1.7-1.2,1.3-2.2.7-.4.9.6.6-.1,1.4-.7Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"1036.22","cy":"195.95","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Nagaland")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"manipur"}},[_c('path',{attrs:{"d":"M1021,208.4l.1.5.5.1-.1.5.7-.1.8.8,1.3-2.7h.4l1.4-1.7-.1-.6h-.6l.1-.7,1.8-.4,1.1.2.7-.2.1-.4,1.1.6.1.4.7.1.3-.5.5.1.3.9,1.1-.2.4.3,1.6-.8.1-.8.7-.5.5.1,1-1.4.4.1-.3.8h.3l-.6.9V205l1.2.8.7.1h0l-.1.7-.7.5-.7,2.9,2.4,1.3-.1,1.9-.6.8.2.6-1.2,1.7-.4,2-.9.1-.3,1.4-1,.9-.6,1.4-.4.1v1.1l-.6.4.3.4-.9.7v.8l-1,2.1-.3,2-.7,1.7-.4.1-.1,1.4-.6.1-.4-.8-2.2-.9-.7-.1-1.4.4-.9-1.3-2-.1-.3.7-.6-.4-.7.7-.7-.4-.8-1.7-.9-.3-.3.1.1.6h-.7l-.5.4.1-.6-.3-.4h-.4l-.1.6-.7-.1-.4-.6-.7.7-.3-.9-.4.2-1.2-.4.7-1.6-.2-1.2.5-1-.4-.1.1-.7-.4-.2h0l.6-.1-.1-1.4.6-1.1-.1-.2.7-.1-.5-.2.4-1.3-.4-.6.5-.5.1-1.2.2-.1.4.5.7-.4v-.7l.5-.4.4-.7-.2-.4.4-.2-.2-1.1.3-.5h.6l.5-.8.8-2.5Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"1025.77","cy":"218","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Manipur")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"mizoram"}},[_c('path',{attrs:{"d":"M1003.17,225.9h1.9l.2,1.7.7.2.1-.4.7-.3.3-1.2.9-.1.2-1.3,1-.4,1.2-2.7.9,2.4.5-.4.7.1.1-.3.4.3,1-.1h0l.4.2-.1.7.4.1-.5,1,.2,1.2-.7,1.6,1.2.4.4-.2.3.9.7-.7.4.6.7.1.1-.6h.4l.3.4-.1.6.5-.4h.7l-.1,1.1.9.9.1,2.7.6,1.3-.7,4.1.3.7-.7.6.4,2.2-.3,1.2.3.2-1.4,2.2h-.7l-.9-.9-.9.2-.1.8.6,1.3-.4.1-.4,1.6-.2.1.2,1.1-.3.6.8,1.8-.5,1.1.4.2.1.9.7.6.3,2.7-.9.2.4.7-.2.4-1.2-.5-.4.2.3,1.5h-.8l-.1,1.9h-.3l-.5-.8-.4.2-.3,1.2-.7-2h-.4l-2-1.4-.3.1-.2,2.1-1.2.7-.1-1.3-.5-1.2.2-.1.4.3.1-.9-1.2-6.4v-1.5l-.3-1.3-.4-.2-.4-1.2-.1-1.2-.2.1-.1-.6-.7-.2.3-2-.4-.8-.1-2.2.7-.1-.6-1.2.1-.7-.9-1.8-.4-2.5-.3-.1.2-1-.4-.6h0l-.1-1.4h.4l-.2-.5.3-.4.4.1.1-.7-.3-.8.3-.5-.2-.7.4-1.8Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"1011.47","cy":"240.25","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Mizoram")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"tripura"}},[_c('path',{attrs:{"d":"M1001.57,221.5l.7.3h0v.7l.7,1.4-.9,2.2,1.3-.1h0l.6,1.7-.4,1.8.2.7-.3.5.3.8-.1.7-.4-.1-.3.4.2.5h-.4l.1,1.4h0l-.3.1-.4,1.1-.1-.7-.5-.3-.1-.5-.3.1-1.4,1.6-.7-.2-.6-1.2h-.3l-.3.7.5,3.3-.5.2v.5l-.6-.1-.9.7-1.1,2,.9,3-.3.4-.6.1-.9,1.3-.4-.2-.7.1-.7.6-.6-.3-1.1-3,.2-.5-.6-.1.1-.4-.4-.7h-.6l-.5,1.2.5,2-.7-.1-.7-1.5v-1.5l-.4-.7.2-.2-.4-.3.4-.7-.4.1-.7-2.2-.7-.4.1-.5h-.2l-.5-.9-.1-1.1.6.4.1-.7-.8-.1V234l.5-.2.4.2.5-1.7-.4-.7.2-.5-.2-.3h.6l-.1-.7.2-.3.2.1.1-.4,1.1.4.3-1.2-.3-.9,2.5.6,1.4-.4.4-1.4-.2-.4.3-.3.3,1,.7.4h.4l-.3-1.7,1.1.7.5-.3-.1.5.7,1,.3-.1.5-2.1-.3-1.2.6-.4.6.6-.3-1.1,2.2.1.3-.7.5-.1-.3-1.2.1-.4Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"992.77","cy":"234.45","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Tripura")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"uttar-pradesh"}},[_c('path',{attrs:{"d":"M780.77,121.8l1.1-.1,1.2,1.2,3.3,1.6-1.4,2.4-.4.4-.4-.1-.4.9.2.4-.8.7.2.4-.4.6.2.4-.5.7.9,1.5-.1,1.2.6.3-.1.3.6.2.7-.6,1.2-.1.4,1.6-.4-.1-.1.3.6.1.1.7.7-.1.1-.7.6-.1.9-1.3.8-.6.6.1,1.5-1.6,1.2.4,1.2.5.6,2,1.2,1.1,2.7,1.5,2.1.4-.8,1.1-.7.4-.3-.3-.3.9-.5-.4-.7.6,1.3,1,.8-.1.7,1v.9h.7l.3-.3.9.9.1-.9,1.6.7.1,1,.4.3-.1.5.7-.1,1.4,1.3h.8l.1-.3.3.6.4.1.1,1.3,1.4-.1.4-.5.2.8.9-.4.8.4.7-.6.9-.2.5.5-.4,1,.5-.1.1-.6h.4l.3.4-.5.1.9.1-.2.3.5.9.7.3.7-.4.4-.8-.2-.3.7-.5h.7l1.5,1.2.5-.1.1.5.9.5.7,1.1,1.4.1,1,1.3.2-.4-.4-1.6,1-.4.7.9.9-.1.4.9,1.2.4.3.7,1.2.6.1-.4.5.2.1.5,1,.6.6-.3.3.7.7.5,2,.4.4,1.2,1.3,1.6v.5h-.2l.4.3-.1.3.8-.1.1-.6,1,.3.6.7-.1.6,2.2,1.4,1.2.3,2.7,2.2.7-.1.7-1.2,1.5.1.9,1,1.3.4,3.6,2.8,3.9-.7.1.9.7,1.3-.3,1.4h3l.4.6,1.2.3,2.3-.1,1.7,2.1.8-.2.7-1.2-.4-.4.3-.4-.2-.4,3.4.1,3.7,2h0l-.4.5.4.2.9-.2.1.4-.4.7.9.4.4.6-.6,1.8,1.2-.1-.4.4.8.4.1,1.4-.3.3.4.2.1.7.6.2.1-.4.6.2-.1.5.6.4.6-.7.5.1.1.9-.4.9.1.3.2.1.8-.4.4,1.2,1.2.2.2.7-2.2.4h-3.5v.7l-.5.9-1.1.2-.2.4-.9-.1v1.2l1.2.3.4-.2.9,1.1,1.5.1.1.9-.4,1.2-.7-.3-.5.7-1-.4.1,1.6.4.7.7.1,1.2,1.2v.6l.5-.1,1.4.9.9-.2.9.4.2.7,1.6.2v.7l.4-.1.9.7-.3.6.4.6-1.2-.1-.1.9-.3-.1.1-.6-.1.7-.6.1-.6-.6-.7.2-.4-.8-.7.1-.2,1.2-.5-.1v.3l-1.2-.1-.1-.6-.7-.4-.8.1-.4.4.1.9-2.4,1.3-1,1.4-.7.1.4.5-.7.1.1.4-.6.4-.4-.4-.4.4-.1-.1-.3.3.2.1-.6.1-.4.7-.8.2-.4-.1-1.2,1.1-.8.1-.3.7-.6.1-.2.3.4.9-.6,1.8.4.1.1,2.3.6.7-.1.8,1,.9.4-.1v.5l.5.4-.2.5.7.4-.7,1.7h0l-1.6.4-.1.7.3.8.4.1.3.7-1.2.8.4.8-1.2,2.7h0l-.5.4-.2.8-.9.6-.4,1.1-1.6.7h-2.2l-2-1.4h0l-.1-.7-.9-.3.4-.9-.9-.1-.8-.9.2-.4.7.3.1-1.4.4-.2.2-.9-.1-1.3-.8-.2.4-1.9-.3-.2-.1-.7.5.2.8-.2-.1-.8h-.6l.1-.7h-1v-.5l-.6-.4-2,.8-.1-.4h-1l-.2-.4-.4.4.1,1.4-1.2-.4-.6.1.1-.9-.5-.3-.1.4-.4-.1.2-1.7-.1.4-.3-.2v.3h-.4l.2.4-.7-.2.2-.7h.3l-.4-.4.2-.4-.6.5h-.7l-1.7-.9-.7.4-.9-1,.2-.7-.2-1.3-.2.3-.9-.4-.6.1-.9-.7-.8.1-.4-.6-.8.3.4-.8.6-.4-.2-.3-.2.4-.1-.6.4-.4-.6-.1-.2-.4-.9.1.2.7-.4-.1-.4.3.5.5-.4.5-1.2-.6.6-.1-.1-.4-.6.1-.9-.8-.2.1v.8l-.1-.8h-.8l-.4,1,.2.7-.9,1.2.1,1-.4.1.2-.1-.6-.4-.4,1.1-.9-1h-1l.1.4-.9.1-.3-.8-.6.3h0l.1.3-.3-.1h0l-.7.2-.5-.1-.2-.4.9-.4-.3-.7.7-.5-.1-.9.6-.6-.4-.6-.7.1-.1,1.4-.4-.6-1.5.1.4.2v.4l.8.2v.4l-.7-.1-.8.3.1-.4-.4.1-.9-.5.5-.3-.6-.5.2,1.4-.7-.3-.3.4-.5-.6h-.5l.4.2-.1.7h-.3l-.4-.7-1.2.4.2.8-.4-.3-.7.4-.7-.4,1.3-1.9,1.1-.5-.4-1.2-.3.1-1.2-.9.1-1.7-.9-.7-.1.4-.8-.2-.1.6-1,.7-.6-.3-.9.2-.4,1.2-.8-.1-.4.7-.1-.4-.9.3.4,1.5-.4.3.1.6-1.7-.7-2.2.2.1-.4-.2.1-.4-.5-1.2,1.6-.4-.2.1-.7-.6.4-.2-.5-.2.4-.2-.9.4-.7.5-.1-.2-.2.5-.7h.5l-.5-.2-.7.4-.7-.6-.2.5-.4-.5.2-.7-.8-.1-.5.5v.7l.4-.3.4.4.4-.2-.1.7.3.3-.2.2-.9-.8.1.9.5.7-.1.3-.7.2v-.5l-.4-.1-.4.2.4.1-.1.4-.5.1-.3-.7-.3.1.2.4-.8.1-.3-.6.2-.4-.6-.4-.7.9-.3-.1.1-.7.5-.7-.7-.4-.1-.5-.5.5.4.2v.7l-.7-.4-1.2.9.1-1.5.2.1.3-.5.5.2.4-.4.2-.3-.4.3-.8-.2-.5,2-.6-.7.1-.5h-.4l.1-.3.8-.3-.1-.4.6-.6,1.2-.2-.3.4h-.6l.6.4.7-.4-.3-1.1-.5.1-.4-.3.5-.6-.3-.7.4-.1-.1-.5-.2.3-.1-.3h-.6v.6l-.7.2.4.7-.4.6-.3-.2.5-.1-.2-.2-1.1-.1-.4-.4-.1.7.4.5.9.1-1.1.3.3.9-.8.1-.1-.4-.8-.1v-.5l.2.3.5-.4-.2-.3-.5.1-.3.3-.4-.1-.2.4-.4-.1.2.7-.8-.2.2.6-.2.4h-.4l-.1-.4-.4.5-.4-.2-.2.3.4.3.7-.4,1.1.6.4,2.7.7.6-.3,1.6.5.4.2.7,1.4.7.2.8-.2.4.1,1.5-.5.7.1.9.4.2,1.6-.8,1.3,2.4-.6.2-.2-.3-.1.6,1.2.4-.3,1.4-.9.9-.4,1.3-1,.2-.4.5-.5-1.3-.2.3-.2-.2-.5.4-.4-.2-1.4-1.8-1.1-.7-1.1,1.6-.9.4-.8-.9.5-.9-1.4-1,.1-.5-.7-.8.6-.6.1-1.8-.7-1.3-.1-1.1-.7-.7v-.4l2.5-2v-1.4l1-.7h.7l-.4-.4.4-.3-.9-.4.2-.4-.7-.4-.1-.9-.6-.2.4-.4-.6-.7.5-.4.3-.9.4.1.7-.5-.2-.9.3-.5.4.2.5-.5,1.4.3.4-.4.6.4.4-.4,2-.5.1-.8-.9-1.2,1.1-.9v-.3l-.4-.1.2-.2.8.5-.2-1,.6-.1-.1-.7.8-.6.2-1.4.9-.7-.9-.9.9-.3-.4-.7h.6l.1-.7h.6l-.3-.6.4-.4.2.3.1-.7.5-.1-.1-.3.3-.1-.9-.3.1-.9h.4l.1-.4-1.2-.2.2-.8-.6-.8h-.4l-.1-.5-.2.1.4-.7-.2-1.2-.9.4.1-.6-.7-.3-.6.1-.8-1H798l-.4-.4-.3.2-.1-.4-.9.5-1.4.2-1.7-.7-.4-.6-.6.1-.6-.8-1,.1-.3.7-.8-.3h0l-.3-.9.5.1.6-.7-.7-.5-.1.3-1.4-.2-.1.8-.9-.1.1.7-.4.2-.2-.9-1,.2-.7-.4-.1.6-2.1-.8-.5.4-.1.6-1.7.8-1.3.2-.4-.4-.3,1,.2.4-.7.4.2-.4h-.5l.1-.8-.2-.8,3.4-1.8,1.3-.2.3-.6-.4-.1-.1.5h.4l-.4-.9-.7.6-1.1-.4.1-.7-.7.2-.4-.4,1.4-.4.2-.8.7-.1.3-.4-.5-.3.1-.4-.8-1,.4-.7-.6.3-1.2-.9-1-.3-.2-.4.2-.7-.5-.3-.2-.7-.7-.2-.1-.7.3-.4-.6-.3.5-.7-.1-.7h-.2l.1-1.2-.4-.3h0l.9-.9h1.1v-.7l.7.2.1-.8h.8l.3-.4-.4-.1.4-.4-.9-.9-.1-.7.1-.4.2.1.1-1.1.7-.4-.8-.1-.1-.4.4.1-.1-.5.4-.3-1.1-.4.4-.2.1-.4-.5-.5.4-.4-.3-.9-2.1-1.7h0l-.7-1,.7-.7-.4-.7.2-1.2-.6.1-.9-1.3-.4-.1.3-.7-.4-.6h0l-.1-.4.6-.2-.5-.9.4-.9-1.4-1.7.3-1.3-.2-.7.3-.3-.2-.5.4-1.1-.5-.2-.1-.4.4-.2-.3-.4.2-.6-.8-1.6.4-.4-.4-.8.9-1.8-.4-1.2.5-.4.4-2,1.2-1.7.1-.8,2.2-1-.2-.2.4-.9.7-.4.8-1.7.7-.5.4-1-.3-.2h0Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"826.27","cy":"183.6","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Uttar Pradesh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"madhya-pradesh"}},[_c('path',{attrs:{"d":"M790.47,182.9l.8.3.3-.7,1-.1.6.8.6-.1.4.6,1.7.7,1.4-.2.9-.5.1.4.3-.2.4.5h.7l.8,1,.6-.1.7.3-.1.6.9-.4.2,1.2-.4.7.2-.1.1.5h.4l.6.8-.2.8,1.2.2-.1.4h-.4l-.1.9.9.3-.3.1.1.3-.5.1-.1.7-.2-.3-.4.4.3.6h-.6l-.1.7h-.6l.4.7-.9.3.9.9-.9.7-.2,1.4-.8.6.1.7-.6.1.2,1-.8-.5-.2.2.4.1v.3l-1.1.9.9,1.2-.1.8-2,.5-.4.4-.6-.4-.4.4-1.4-.3-.5.5-.4-.2-.3.5.2.9-.7.5-.4-.1-.3.9-.5.4.6.7-.4.4.6.2.1.9.7.4-.2.4.9.4-.4.3.4.4h-.7l-1,.7v1.4l-2.5,2v.4l.7.7.1,1.1.7,1.3-.1,1.8-.6.6.7.8-.1.5,1.4,1-.5.9.8.9.9-.4,1.1-1.6,1.1.7,1.4,1.8.4.2.5-.4.2.2.2-.3.5,1.3.4-.5,1-.2.4-1.3.9-.9.3-1.4-1.2-.4.1-.6.2.3.6-.2-1.3-2.4-1.6.7-.4-.2-.1-.9.5-.7-.1-1.5.2-.4-.2-.8-1.4-.7-.2-.7-.5-.4.3-1.6-.7-.6-.4-2.7-1.1-.6-.7.4-.4-.3.2-.3.4.2.4-.5.1.4h.4l.2-.4-.2-.6.8.2-.2-.7.4.1.2-.4.4.1.4-.7.5-.1.2.3-.5.4-.2-.3v.5l.8.1.1.4.8-.1-.3-.9,1.1-.3-.9-.1-.4-.5.1-.7.4.4,1.1.1.2.2-.5.1.3.2.4-.6-.4-.7.7-.2v-.6h.6l.1.3.2-.3.1.5-.4.1.3.7-.5.6.4.3.5-.1.3,1.1-.7.4-.6-.4h.6l.3-.4-1.2.2-.6.6.1.4-.8.3-.1.3h.4l-.1.5.6.7.5-2,.8.2.4-.3.3,1.1-.4.4-.5-.2-.3.5-.2-.1-.1,1.5,1.2-.9.7.4v-.8l-.4-.2.5-.5.1.5.7.4-.5.7-.1.7.3.1.7-.9.6.4-.2.4.3.6.8-.1-.2-.4.3-.1.3.7.5-.1.1-.4-.4-.1.4-.2.4.1v.5l.7-.2.1-.3-.5-.7-.1-.9.9.8.2-.2-.3-.3.1-.7-.4.2-.4-.4-.4.3v-.7l.5-.5.8.1-.2.7.4.5.2-.5.7.6.7-.4.5.2h-.5l-.5.7.2.2-.5.1-.4.7.2.9.2-.4.2.5.6-.4-.1.7.4.2,1.2-1.6.4.5.2-.1-.1.4,2.2-.2,1.7.7-.1-.6.4-.3-.4-1.5.9-.3.1.4.4-.7.8.1.4-1.2.9-.2.6.3,1-.7.1-.6.8.2.1-.4.9.7-.1,1.7,1.2.9.3-.1.4,1.2-1.1.5-1.3,1.9.7.4.7-.4.4.3-.2-.8,1.2-.4.4.7h.4l.1-.7-.4-.2h.5l.5.6.3-.4.7.3-.2-1.4.6.5-.5.3.9.5.4-.1-.1.4.8-.3.7.1v-.4l-.8-.2v-.4l-.4-.2,1.5-.1.4.6.1-1.4.7-.1.4.6-.6.7.1.9-.7.5.3.7h-2.1l.2.4.5.1.7-.2h0l.2.1-.1-.3h0l.6-.3.3.8.9-.1-.1-.4h1l.9,1,.4-1.1.6.4-.3.1.4-.1-.1-1,.9-1.2-.2-.7.4-1h.6l.1.8v-.8l.2-.1.9.8.6-.1.1.4-.6.1,1.2.6.4-.5-.5-.5.4-.3.4.1-.2-.7.9-.1.2.4.6.1-.4.4.1.6.2-.4.2.3-.6.4.1.3.8-.3.4.6.8-.1.9.7.6-.1.9.4.2-.3.2,1.3-.2.7.9,1,.7-.4,1.7,1h.7l.6-.5-.2.4.4.4h-.3l-.2.7.7.2-.2-.4h.4V217l.3.2.1-.4-.2,1.7.4.1.1-.4.5.3-.1.9.6-.1,1.2.4-.1-1.4.4-.4.2.4h1l.1.4,2-.8.6.4v.5h1l-.1.9h.6l.1.8-.8.2-.5-.2.1.7.3.2-.4,1.9.8.2.1,1.3-.3.9-.4.2-.1,1.4-.7-.4-.2.4.8.9.9.1-.4.9.9.3.1.7h0l-.9.7-1.4.2-.1.9-1,.6h-.9l.3.5-.4.1-.9-.4-2,.1-1.1-.3-.4.2-.4-.4.1-.4-.7.6h-1.7l-.7-.7-.7.1-.5-.4-.9.8-1.1.2-.9-.4.1-.3-.9-1.1-.8.3-.2.9.5.4.1,1,.5.3.2.5-.7,1h-.4l-.1,1-.5.2.1.6.4.1v.7l.3.3.4-.7.6.1.7-.7,1,.4.4.6,1.4-.4.9,2,.6-.1v.6l.5.1.8-.4.2.7.4-.1.7.6.1.7-.7.9.1,1.4-.5.7-.7-.2-.7.6h-1.4l-.3.6.4,1.4-1.2.7-.1.4-1.3.3-.1.7.4,1.1-.6.7.2,1-.4.3-.3-.4-.2.4-.8.3-.1,1-.4.1-.2.2h-1.4l-.6.7h-.7l.1.4-.4-.2-.4.7-.3-1-.9-.3-.3.7-.4-.3-.9.8-.6-.7-1.1.8.1,2.4-.4.8-1,.3-.1,1.6-.7.3.5.3-.1.6-.6.1-.2-.9-.6-.1-1,2.5-.4.1.3.4-.1,2.1-.3.9-1-.1-.4.7-.1,2,.3,1.9-1.1,2.3h0l-.9.1-1.7-1.2-.6-.1-.1.5-.6-.1-.2-.5.4-.5-.6-1.4-1.7-1.6-1.1-.2-1.1.4-.8.9-1.1.4-.9-.4-.3.5-.9-.1-1.9-1.2-1.3.7-1.7.2-.7-2.1-1.1-.3-.3.3-.7-.1-1.8-.7-.1,1.2-1.1-.1-.9,1-1.2-.1-.2-.3-1.2.4.2.5-.4.1.6.7-.1.4-.6-.2-.2.3-1.4-.1-.2.4-.4-.4-.4.5-2-.4-.3-.4-.9-.2-1.2.4-.1-1.7-.7-.3-.3.7-.4-.2-.5.3-.6-.4.1.4-1.3.2-.1,1-3.5,1.8-.9.1-1.2-.6-.1.4-.7.1-.2.4-.4.1-.2-.7-.4.4-.1-.5h-.7l.1.4-.3.1-1.4-.2-.3-1.3-.5-.3-.3-.9.6-.4,1.7.4.6-.2-.3-.2v-1l-.4-1.2-1-1.2-2.9.1-.1.7-.9.1-.3.4-.6-.5-.2.2-1.3-.1-2.6,2-.7-.2-.3.4-.6-.1-.1.9-.4.3.4.5-.1.4-2.4,2.1.6.9-.6,1.4-2-.1-.5,1.3-1.2.6h-1.4l-.3-.3-1.4.1-.9-1.3.8-.1.1-.3-.4-.8.2-.4-.85-1.9-.7.4-1.3-.7-1.2-.1-3.3.3-.9-.2-.9.4-1.2-.4-1.1.2-.6-.4-.9.2v-.4l-1.2.1-1.6-.8-.9-1.7-2.4-1.1-1.7.3-3.5-1.2-.1-.6-.7-.1-.1-1.3.4-1.7-.5-.7-.7-.3v-.9l-.9.1-.5.7-.8.2-.2.5-1.4.1-.8-.4h0l.1-.5-.9-.5,1.2-1.2-.4-.3-.4.1-.1-1.9-.7-.1.2-.4-.5-.7.2-1.2.6-.2.4.7.9.1.2-.7.3.1.4-.7.6.1-.6-.7-.7-.1-.2-.7-.1.6-.4.2-.5-.6-.3.6-.3-.8h-.4l.1-.7-.7.3-.1-.3.5-.7,1.3.6,1.7-2.1h1.8l.3-1.4,1.2-2.1-.4-1.1-.8.4-.6-.6-.3-.5.4-.3-.7-1.4h0l1-.8,1.8.4.5-.7.9-.2.9-.9.7.1.4-.3v-.4l-.8.1.4-.4-.3-.5-.9.2-1.2-.7-.3.3-.5-.7.8-.8.1-.7.6-.7.7-.1.7-.7.5.1.8-.8.3.2.7-.4.9-1.2.5-.1-.5-.9.5-.9-.5-2.3.2-1,1.1-1.5-1.7-3,.4-.4-.2-.4-.4-.3h-1.8l.5-.6.1-.9,1.1-1.6-.6.1v.4l-.6.1-1-.4.7-.7-.1-.7.7-.2-.1-.4.5-.6-.7-.3.4-1.8,1.4,2.3.7-.1.3-.7.6-.1-.1-.7h.4l-.2-.7-1.4.1-.9-.4-.1.4.1-1-.5-1.2.4-.7.3.7.3-.2.4.4.1.6,1.9.6.2-.4.9-.1-.1-1.3.7-.4-.1-.9,2.8.1.1.3-.5.3.3.7-.4,1-.6-1.3-.1.2.4.7-.5.6.7.4.2-.3,1.5-.1-.1.5-1.7.9-.4-.7-.8-.1.4-.6-.4.1-.2-.4-.1.4.8.8-.7.4-.3.7.5.7.7-.1,2.8.7,2-.5.5.6,2.2-1.3,1.2.6-.1.9.3.3-.3.7.1.3.4-.3.8.7-.1.4.3.3-.5.4.3.3-.1.6-.9.7-.9-.9-.7.8.1.3-.4.1.1.9.4.7.7.1.2.9-.8.4-.4,1.4h.5l.2.5h.7v.6l-.8.2-.3,1.1-.9.5.1-1.1-.5.6-.8.1-.3-.5-.8-.4-.7,1.1-.1,1,1.6,1,.2.3-.3.3.4.4h1l.5.7.1-.9h.4l.1-.7-.5-.3.1-.4.7.2.4.6.3-.4,1-.4.3.2,1.4-.8-.2-1.5,1.3-.8,1.3-.4-.2-1.7.5-.8-.1-.7.7-.8.3.4-.2.4.3,1.1h1l.7-.7,1.3.7.1-.3.4.1.2-.2.9,1.1.7-.3-.2-.4.5-.5-.1-.4.4.1v-.1l1.2-.4.1.6-.4.9.4.4h.8l.7.9.9-.3.7.1.2-.9.4-.3-1.1-1-.5-1.1.1-2.2-.6-1.1.8-.2.2.4.5-.3v.9l.8.4.6-.3.4-.9h.3l.2-.7-.1-1.2-.5-1.2-.8-.4-.3-.6-.7.3-.9-.1-.7-1.2.4-.4,1.4-.1.4-.4-.5-.3.1-.5-.4-.1-.6-1.5,2.1-1.2,1.3.4.6-.2.9-.7,1.4-.1.6.6,1.4-.5-.1-1.2.4-.1-.1-.6-.9-.7.4-.8-.5-.1.4-1.4-.9-.4-.4.2-.9.9-.2,1-2-.4-.8.7-1,.1-.2.4-.7-.8-.7-.1-1.1.4-.1-.4-1.3-.1-1.2-.7-.2-.7-.4-.2-.7-1.4-.1-2.4-.5-.4.1-.4.7-.3v-1l.9-1.3.5.1.3-.7,1.3.1.4-.4-.1-.4.8-.2.5-1-.1-.3.9-1.1,1.5-.7.7-.8.9-.1.5-.8h1.2l1.3-1,.7-1,1.4-.1-.1-.7,1.4-.1,2.2-1.6.7.1.4-.7,1-.1.1-.7.9-.4.2-.7.8-.1.7-.7,1.4.4.1-.9.4-.3-.2-.7,1.2.1-.2-.6Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"793.02","cy":"244.5","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Madhya Pradesh")])]),_vm._v(" "),_c('g',{staticClass:"state india-state",attrs:{"id":"chandigarh"}},[_c('path',{attrs:{"d":"M769.47,116.8l-.4.3-1-.4-.5-1.2,1-.7.1.4.4-.1-.1.4.5.1h0Z"}}),_vm._v(" "),_c('circle',{staticClass:"circ",attrs:{"cx":"768.87","cy":"116.1","r":"0.5"}}),_vm._v(" "),_c('title',[_vm._v("Chandigarh")])])])])])]),_vm._v(" "),(this.$route.name === 'MapResults')?_c('b-col',{attrs:{"md":"1"}}):_vm._e()],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pkkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__ = __webpack_require__("LU4o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a4de15a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyFooter_vue__ = __webpack_require__("Kfvl");
function injectStyle (ssrContext) {
  __webpack_require__("rIJZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a4de15a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a4de15a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r4PC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rIJZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s2gU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestListing_vue__ = __webpack_require__("7HOx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7778cf70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestListing_vue__ = __webpack_require__("cfVV");
function injectStyle (ssrContext) {
  __webpack_require__("YOkb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7778cf70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7778cf70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RequestListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tfUm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uM9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-results"}},[(_vm.invalid_state_province)?_c('div',[_c('error-component',[_c('template',{slot:"title"},[_c('h1',[_vm._v("404 Error")])]),_vm._v(" "),_c('template',{slot:"subtitle"},[_c('h2',[_vm._v("Page not found")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('p',[_vm._v("\n          Missing a Partnership? Add a new Partnership by following the link below.\n        ")])])],2)],1):_vm._e(),_vm._v(" "),(!_vm.invalid_state_province && _vm.empty_state_province)?_c('div',[_c('error-component',[_c('template',{slot:"title"},[_c('h1',[_vm._v(_vm._s(_vm.state_province)+" Has No Partnerships")])]),_vm._v(" "),_c('template',{slot:"subtitle"},[_c('h2',[_vm._v("No partnerships found Try another state/province.")])]),_vm._v(" "),_c('template',{slot:"message"},[_c('h4',[_vm._v("Missing a Partnership? Add a Partnership by following the link below.")])])],2)],1):_vm._e(),_vm._v(" "),(!_vm.invalid_state_province && !_vm.empty_state_province)?_c('div',[(_vm.loading)?_c('div',{staticClass:"loading-screen"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h2',[_vm._v("Loading...")])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.loading ? 'hidden' : 'content'},[_c('div',{attrs:{"id":"map-wrapper"}},[_c('maps',{attrs:{"clickDisabled":true,"options":_vm.map_options}},[_c('template',{slot:"title-rows"},[_c('b-row',{staticClass:"title-rows"},[_c('b-col',[_c('h3',{attrs:{"id":"explore-title"}},[_vm._v("Partnerships With "+_vm._s(_vm.map_options.state_province))])])],1)],1)],2)],1),_vm._v(" "),_c('div',{attrs:{"id":"results"}},[_c('b-row',{staticClass:"header-row"},[_c('b-col',{attrs:{"md":"12"}},[_c('h1',[_vm._v("Partnerships")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.map_options.state_province))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{attrs:{"id":"map-results-filter"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Order","label-for":"order"}},[_c('b-form-select',{attrs:{"id":"order","options":_vm.order_options},model:{value:(_vm.order),callback:function ($$v) {_vm.order=$$v},expression:"order"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Sector","label-for":"sector"}},[_c('b-form-select',{attrs:{"id":"sector","options":_vm.sector_options,"text-field":"name","value-field":"name"},model:{value:(_vm.sector),callback:function ($$v) {_vm.sector=$$v},expression:"sector"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Sectors")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Type","label-for":"type"}},[_c('b-form-select',{attrs:{"id":"type","options":_vm.type_options,"text-field":"name","value-field":"name"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":""}},[_vm._v("All Types")])])],2)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.programs.length > 0)?_c('div',{attrs:{"id":"results-block"}},[_vm._l((_vm.page_programs),function(program,index){return _c('div',{staticClass:"results-content"},[_c('b-row',{staticClass:"results-row",on:{"click":function($event){_vm.goToPartnership(program.slug)}}},[_c('b-col',{attrs:{"md":"12"}},[_c('h2',{staticClass:"results"},[_vm._v(_vm._s(program.name))]),_vm._v(" "),_c('strong',[_vm._v("Sector:")]),_vm._v(" "+_vm._s(program.sector)+"\n                    "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Type:")]),_vm._v(" "+_vm._s(program.type)+"\n                    "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("States/Provinces:")]),_vm._v(" "),_vm._l((program.institutions),function(institution,index){return _c('span',[_vm._v("\n                      "+_vm._s((index != (program.institutions.length - 1)) ? institution.state_province + ',' : institution.state_province)+"\n                    ")])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Institutions:")]),_vm._v(" "),_vm._l((program.institutions),function(institution,index){return _c('span',[_vm._v("\n                      "+_vm._s((index != (program.institutions.length - 1)) ? institution.name + ',' : institution.name)+"\n                    ")])})],2)],1),_vm._v(" "),_c('hr',{class:(index !== (_vm.page_programs.length - 1)) ? 'separator' : 'separator-lg'})],1)}),_vm._v(" "),(_vm.programs.length > 1)?_c('pagination',{attrs:{"click-handler":_vm.changePage,"page":_vm.page,"page-count":_vm.programs.length}}):_vm._e()],2):_vm._e()])],1)],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uRks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("wfaF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3702d4c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("TE/U");
function injectStyle (ssrContext) {
  __webpack_require__("J0jU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3702d4c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3702d4c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vOTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clean_query__ = __webpack_require__("HrFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clean_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clean_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__ = __webpack_require__("9dHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Maps__ = __webpack_require__("IsxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__("cMGX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapResults',
  components: {
    ErrorComponent: __WEBPACK_IMPORTED_MODULE_1__components_ErrorComponent__["a" /* default */],
    Maps: __WEBPACK_IMPORTED_MODULE_2__components_Maps__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */]
  },
  data: function data() {
    return {
      state_province: '',
      map_options: {},
      page: 1,
      programs: [],
      page_programs: [],
      num_programs: 0,
      order: undefined,
      type: undefined,
      sector: undefined,
      order_options: [{ value: 'asc', text: 'A-Z' }, { value: 'desc', text: 'Z-A' }],
      sector_options: [],
      type_options: [],
      loading: true,
      empty_state_province: false,
      invalid_state_province: false
    };
  },
  methods: {
    changePage: function changePage(page) {
      page = this.programs[page - 1] !== undefined ? page : 1;
      this.page = page;
      this.page_programs = this.programs[page - 1];

      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.$router.replace({
        path: query !== '' ? this.$route.path + '?' + query : this.$route.path
      });
    },
    handleError: function handleError(error) {
      /* eslint-disable no-self-assign */
      error = error;
      return null;
    },
    getResults: function getResults() {
      var _this = this;

      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        state_province: this.$route.params.state_province_slug,
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.axios({
        method: 'get',
        url: query !== '' ? '/program/search?' + query : ''
      }).then(function (response) {
        _this.map_options = {
          country: response.data.country,
          state_province: response.data.state_province,
          slug: response.data.state_province_slug,
          state_provinces: response.data.state_provinces
        };

        _this.programs = response.data.programs;
        _this.num_programs = response.data.num_programs;
        _this.changePage(_this.page);
        _this.loading = false;
      });
    },
    goToPartnership: function goToPartnership(slug) {
      this.$router.push({
        path: '/partnership/' + slug
      });
    },
    updateSelect: function updateSelect() {
      var query = __WEBPACK_IMPORTED_MODULE_0_clean_query___default()({
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      });

      this.$router.replace({
        path: query !== '' ? this.$route.path + '?' + query : this.$route.path
      });

      this.getResults();
    }
  },
  watch: {
    order: function order() {
      this.updateSelect();
    },
    sector: function sector() {
      this.updateSelect();
    },
    type: function type() {
      this.updateSelect();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.axios({
        method: 'get',
        url: '/program/search?state_province=' + to.params.state_province_slug
      }).then(function (response) {
        if (response.data.length === 0) {
          vm.invalid_state_province = true;
        } else if (response.data.num_programs === 0) {
          vm.loading = false;
          vm.empty_state_province = true;
          vm.state_province = response.data.state_province;
          vm.$root.setTitle(vm.state_province + ' | ' + 'Map Results');
        } else {
          vm.$root.setTitle('Map Results');
          vm.order = to.query.order !== undefined ? to.query.order : undefined;
          vm.sector = to.query.sector !== undefined ? to.query.sector : undefined;
          vm.type = to.query.type !== undefined ? to.query.type : undefined;
          vm.page = to.query.page !== undefined ? Number(to.query.page) : undefined;
          vm.getResults();
        }
      });

      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(function (response) {
        vm.sector_options = response.data.sort();
      });

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(function (response) {
        vm.type_options = response.data.sort();
      });
    });
  }
});

/***/ }),

/***/ "wAPh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapResults_vue__ = __webpack_require__("vOTe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddc106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapResults_vue__ = __webpack_require__("uM9Q");
function injectStyle (ssrContext) {
  __webpack_require__("RNO/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ddc106"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ddc106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wfaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contact',
  data: function data() {
    return {
      uno_is_url: 'https://www.unomaha.edu/international-studies-and-programs/engagement/partnership2020'
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$root.setTitle('Contact');
    });
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MyFooter__ = __webpack_require__("pkkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyNavbar__ = __webpack_require__("8wjK");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_MyFooter__["a" /* default */],
    MyNavbar: __WEBPACK_IMPORTED_MODULE_1__components_MyNavbar__["a" /* default */]
  }
});

/***/ }),

/***/ "xJvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_paginate__ = __webpack_require__("kBYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_paginate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pagination',
  components: {
    Paginate: __WEBPACK_IMPORTED_MODULE_0_vuejs_paginate___default.a
  },
  data: function data() {
    return {
      current_page: 0
    };
  },
  props: {
    clickHandler: {
      type: Function,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    }
  },
  mounted: function mounted() {
    this.current_page = this.page;
  }
});

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.86df9d473720167fb73a.js